/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * My App
 * This is an awesome app!
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query'
import {
  computed,
  unref
} from 'vue'
import type {
  MaybeRef
} from 'vue'
import type {
  AbstractActionFiltersDTO,
  ActionItemFiltersDTO,
  AddAcknowledgementToContract,
  AddAcknowledgementToTicket,
  AddActionItemsToContractDTO,
  AddActionLabourToAssignmentDTO,
  AddActionsToRecipeDTO,
  AddArticleOptionToArticleDTO,
  AddArticlesToActionDTO,
  AddArticlesToTicketDTO,
  AddAssigneeToAssignmentDTO,
  AddAssigneeToTicketDTO,
  AddAssignmentToTicketDTO,
  AddBranchToOrganisationDTO,
  AddCaseToTicket,
  AddChildTicketToTicketDTO,
  AddComponentToTemplateDTO,
  AddContactPersonToOrganisationDTO,
  AddContactPersonsToTicketDTO,
  AddNewVersionDTO,
  AddPropertiesDTO,
  AddPropertiesWithAttributesToServiceHistoryDTO,
  AddPropertyAttributesDTO,
  AddRecipesToMaintenancePackageDTO,
  AddServiceHistoryToUnitDTO,
  AddServicePropertyToUnitDTO,
  AddSignatureDTO,
  AddTemplateToLayoutDTO,
  AddTemplateToStylesheetDTO,
  AddTemplateToThemeDTO,
  ArticleFiltersDTO,
  AssigneeFiltersDTO,
  CategoryDTO,
  CategoryFiltersDTO,
  ContactPersonFilterDTO,
  ContractFilterDTO,
  CreateActionDTO,
  CreateActionItemDTO,
  CreateActionLabourDTO,
  CreateAddressDTO,
  CreateAdjustmentDTO,
  CreateArticleDTO,
  CreateArticleOptionDTO,
  CreateAssigneeDTO,
  CreateAssignmentDTO,
  CreateCommentDTO,
  CreateComponentDTO,
  CreateContactDetailDTO,
  CreateContractDTO,
  CreateLayoutDTO,
  CreateMaintenancePackageDTO,
  CreateOrganisationContactPersonDTO,
  CreateOrganisationDTO,
  CreateProjectDTO,
  CreatePropertyAttributeDTO,
  CreatePropertyDTO,
  CreatePurchaseHistoryDTO,
  CreateRecipeDTO,
  CreateResponse,
  CreateSaleHistoryDTO,
  CreateServiceHistoryDTO,
  CreateServicePropertyAttributeDTO,
  CreateSiteDTO,
  CreateStylesheetDTO,
  CreateSupplierDTO,
  CreateTemplateDTO,
  CreateThemeDTO,
  CreateTicketContactPersonDTO,
  CreateTicketDTO,
  CreateTicketStatusDTO,
  CreateUnitDTO,
  CreateUserDTO,
  FetchActionItemResponse,
  FetchActionLabourResponse,
  FetchActionResponse,
  FetchAddressResponse,
  FetchAdjustmentResponse,
  FetchAllActionItems,
  FetchAllActionLabours,
  FetchAllActionsResponse,
  FetchAllAddressesResponse,
  FetchAllAdjustments,
  FetchAllArticlesResponse,
  FetchAllAssignees,
  FetchAllAssignments,
  FetchAllAssignmentsDTO,
  FetchAllBookedHours,
  FetchAllBookedHoursDTO,
  FetchAllCases,
  FetchAllCategoriesResponse,
  FetchAllComments,
  FetchAllCommentsDTO,
  FetchAllContactPersonsByOrganisationId,
  FetchAllContracts,
  FetchAllMaintenancePackagesResponse,
  FetchAllOrganisationBranchesResponse,
  FetchAllOrganisationContactPersonsResponse,
  FetchAllOrganisations,
  FetchAllPropertiesResponse,
  FetchAllPropertyAttributes,
  FetchAllPurchaseHistoriesDTO,
  FetchAllPurchaseHistoriesResponse,
  FetchAllRecipesResponse,
  FetchAllSaleHistoriesDTO,
  FetchAllSaleHistoriesResponse,
  FetchAllScheduledTickets,
  FetchAllServiceHistoriesResponse,
  FetchAllServicePropertyAttributesResponse,
  FetchAllSites,
  FetchAllSuppliers,
  FetchAllTicketContactPersonsResponse,
  FetchAllTicketStatus,
  FetchAllTickets,
  FetchAllUnits,
  FetchAllUsers,
  FetchArticleOptionResponse,
  FetchArticleResponse,
  FetchAssigneeResponse,
  FetchAssignmentResponse,
  FetchCategoryResponse,
  FetchContentDTO,
  FetchContractResponse,
  FetchFileResponse,
  FetchMaintenancePackageResponse,
  FetchOrganisationContactPersonResponse,
  FetchOrganisationResponse,
  FetchPropertyAttributeResponse,
  FetchPropertyResponse,
  FetchRecipeResponse,
  FetchServiceHistoryResponse,
  FetchServicePropertyAttributeResponse,
  FetchSiteResponse,
  FetchSupplierResponse,
  FetchTicketContactPersonResponse,
  FetchTicketResponse,
  FetchUnitResponse,
  FetchUnitsByOrganisationResponse,
  FetchUserResponse,
  GenerateTemplateDTO,
  NestedSignature,
  PatchActionDTO,
  PatchActionLabourDTO,
  PatchArticleDTO,
  PatchArticleOptionDTO,
  PatchContractDTO,
  PatchOrganisationDTO,
  PatchTicketDTO,
  PatchUnitDTO,
  PostExportInvoice200Item,
  PostFetchAdjustmentsParams,
  PostFetchAllAbstractActionsParams,
  PostFetchAllActionItemsParams,
  PostFetchAllActionLabourParams,
  PostFetchAllActionsParams,
  PostFetchAllAddressesParams,
  PostFetchAllArticlesParams,
  PostFetchAllAssigneesParams,
  PostFetchAllAssignmentsParams,
  PostFetchAllCategoriesParams,
  PostFetchAllCommentsParams,
  PostFetchAllComponentsParams,
  PostFetchAllContractsParams,
  PostFetchAllLayoutsParams,
  PostFetchAllMaintenancePackagesParams,
  PostFetchAllOrganisationContactPersonsParams,
  PostFetchAllOrganisationsBody,
  PostFetchAllOrganisationsParams,
  PostFetchAllProjectsParams,
  PostFetchAllPropertiesParams,
  PostFetchAllPropertyAttributesParams,
  PostFetchAllPurchaseHistoriesParams,
  PostFetchAllRecipesParams,
  PostFetchAllSaleHistoriesParams,
  PostFetchAllServiceHistoriesParams,
  PostFetchAllServicePropertiesParams,
  PostFetchAllServicePropertyAttributesParams,
  PostFetchAllSitesParams,
  PostFetchAllStylesheetsParams,
  PostFetchAllSupplierParams,
  PostFetchAllThemesParams,
  PostFetchAllTicketContactPersonsParams,
  PostFetchAllTicketsParams,
  PostFetchAllUnitsParams,
  PostFetchAllUnscheduledTicketsParams,
  PostFetchAllUsersParams,
  PostFetchHoursWorkedByMechanicParams,
  PostGenerateTemplatePdfBody,
  PreviewTemplateDTO,
  PropertyAttributeFiltersDTO,
  SaveFileDTO,
  SaveOrganisationFileDTO,
  ScheduleTicket,
  SendContractDTO,
  SendEmailDTO,
  ServicePropertyAttributeFiltersDTO,
  SiteFiltersDTO,
  TicketFiltersDTO,
  UnitFiltersDTO,
  UpdateActionDTO,
  UpdateActionItemDTO,
  UpdateActionLabourTotalHours,
  UpdateActionStatusDTO,
  UpdateArticleOptionStatusDTO,
  UpdateAssigneeDTO,
  UpdateAssignmentAbstractActionDTO,
  UpdateComponentDTO,
  UpdateContractDTO,
  UpdateContractStatusDTO,
  UpdateLayoutDTO,
  UpdateMaintenancePackageDTO,
  UpdateOrAddNoteToContractDTO,
  UpdateOrganisationDTO,
  UpdateProjectDTO,
  UpdatePropertyDTO,
  UpdateServiceHistoryDTO,
  UpdateStylesheetDTO,
  UpdateSupplierDTO,
  UpdateTemplateDTO,
  UpdateThemeDTO,
  UpdateTicketArticleAssociationPriceDTO,
  UpdateTicketArticleAssociationQuantity,
  UpdateTicketAssignee,
  UpdateTicketDescription,
  UpdateTicketExpectedDuration,
  UpdateTicketOrganisation,
  UpdateTicketOrganisationContactPersonDTO,
  UpdateTicketPriority,
  UpdateTicketSiteContactPerson,
  UpdateTicketStatus,
  UpdateTicketTitle,
  UpdateUnitDTO,
  UpdateUnitStatusDTO,
  UserFiltersDTO
} from '../models'
import { axios } from '../mutator/axios';
import type { ErrorType, BodyType } from '../mutator/axios';


type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];


export const postCreateAction = (
    createActionDTO: MaybeRef<CreateActionDTO>,
 options?: SecondParameter<typeof axios>,) => {
      createActionDTO = unref(createActionDTO);
      
      return axios<CreateResponse>(
      {url: `/api/action`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createActionDTO
    },
      options);
    }
  


export const getPostCreateActionMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCreateAction>>, TError,{data: BodyType<CreateActionDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postCreateAction>>, TError,{data: BodyType<CreateActionDTO>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCreateAction>>, {data: BodyType<CreateActionDTO>}> = (props) => {
          const {data} = props ?? {};

          return  postCreateAction(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostCreateActionMutationResult = NonNullable<Awaited<ReturnType<typeof postCreateAction>>>
    export type PostCreateActionMutationBody = BodyType<CreateActionDTO>
    export type PostCreateActionMutationError = ErrorType<unknown>

    export const usePostCreateAction = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCreateAction>>, TError,{data: BodyType<CreateActionDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postCreateAction>>,
        TError,
        {data: BodyType<CreateActionDTO>},
        TContext
      > => {

      const mutationOptions = getPostCreateActionMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postCreateRecipe = (
    createRecipeDTO: MaybeRef<CreateRecipeDTO>,
 options?: SecondParameter<typeof axios>,) => {
      createRecipeDTO = unref(createRecipeDTO);
      
      return axios<CreateResponse>(
      {url: `/api/recipe`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createRecipeDTO
    },
      options);
    }
  


export const getPostCreateRecipeMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCreateRecipe>>, TError,{data: BodyType<CreateRecipeDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postCreateRecipe>>, TError,{data: BodyType<CreateRecipeDTO>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCreateRecipe>>, {data: BodyType<CreateRecipeDTO>}> = (props) => {
          const {data} = props ?? {};

          return  postCreateRecipe(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostCreateRecipeMutationResult = NonNullable<Awaited<ReturnType<typeof postCreateRecipe>>>
    export type PostCreateRecipeMutationBody = BodyType<CreateRecipeDTO>
    export type PostCreateRecipeMutationError = ErrorType<unknown>

    export const usePostCreateRecipe = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCreateRecipe>>, TError,{data: BodyType<CreateRecipeDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postCreateRecipe>>,
        TError,
        {data: BodyType<CreateRecipeDTO>},
        TContext
      > => {

      const mutationOptions = getPostCreateRecipeMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postAddActionToRecipe = (
    id: MaybeRef<string>,
    addActionsToRecipeDTO: MaybeRef<AddActionsToRecipeDTO>,
 options?: SecondParameter<typeof axios>,) => {
      id = unref(id);
addActionsToRecipeDTO = unref(addActionsToRecipeDTO);
      
      return axios<void>(
      {url: `/api/recipe/${id}/add-action`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: addActionsToRecipeDTO
    },
      options);
    }
  


export const getPostAddActionToRecipeMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAddActionToRecipe>>, TError,{id: string;data: BodyType<AddActionsToRecipeDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postAddActionToRecipe>>, TError,{id: string;data: BodyType<AddActionsToRecipeDTO>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAddActionToRecipe>>, {id: string;data: BodyType<AddActionsToRecipeDTO>}> = (props) => {
          const {id,data} = props ?? {};

          return  postAddActionToRecipe(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAddActionToRecipeMutationResult = NonNullable<Awaited<ReturnType<typeof postAddActionToRecipe>>>
    export type PostAddActionToRecipeMutationBody = BodyType<AddActionsToRecipeDTO>
    export type PostAddActionToRecipeMutationError = ErrorType<unknown>

    export const usePostAddActionToRecipe = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAddActionToRecipe>>, TError,{id: string;data: BodyType<AddActionsToRecipeDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postAddActionToRecipe>>,
        TError,
        {id: string;data: BodyType<AddActionsToRecipeDTO>},
        TContext
      > => {

      const mutationOptions = getPostAddActionToRecipeMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postAddArticleToAction = (
    id: MaybeRef<string>,
    addArticlesToActionDTO: MaybeRef<AddArticlesToActionDTO>,
 options?: SecondParameter<typeof axios>,) => {
      id = unref(id);
addArticlesToActionDTO = unref(addArticlesToActionDTO);
      
      return axios<void>(
      {url: `/api/abstract-action/${id}/add-article`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: addArticlesToActionDTO
    },
      options);
    }
  


export const getPostAddArticleToActionMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAddArticleToAction>>, TError,{id: string;data: BodyType<AddArticlesToActionDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postAddArticleToAction>>, TError,{id: string;data: BodyType<AddArticlesToActionDTO>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAddArticleToAction>>, {id: string;data: BodyType<AddArticlesToActionDTO>}> = (props) => {
          const {id,data} = props ?? {};

          return  postAddArticleToAction(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAddArticleToActionMutationResult = NonNullable<Awaited<ReturnType<typeof postAddArticleToAction>>>
    export type PostAddArticleToActionMutationBody = BodyType<AddArticlesToActionDTO>
    export type PostAddArticleToActionMutationError = ErrorType<unknown>

    export const usePostAddArticleToAction = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAddArticleToAction>>, TError,{id: string;data: BodyType<AddArticlesToActionDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postAddArticleToAction>>,
        TError,
        {id: string;data: BodyType<AddArticlesToActionDTO>},
        TContext
      > => {

      const mutationOptions = getPostAddArticleToActionMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getFetchAction = (
    id: MaybeRef<string>,
 options?: SecondParameter<typeof axios>,signal?: AbortSignal
) => {
      id = unref(id);
      
      return axios<FetchActionResponse>(
      {url: `/api/action/${id}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetFetchActionQueryKey = (id: MaybeRef<string>,) => {
    return ['api','action',id] as const;
    }

    
export const getGetFetchActionQueryOptions = <TData = Awaited<ReturnType<typeof getFetchAction>>, TError = ErrorType<unknown>>(id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFetchAction>>, TError, TData>>, request?: SecondParameter<typeof axios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getGetFetchActionQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFetchAction>>> = ({ signal }) => getFetchAction(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: computed(() => !!(unref(id))), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFetchAction>>, TError, TData> 
}

export type GetFetchActionQueryResult = NonNullable<Awaited<ReturnType<typeof getFetchAction>>>
export type GetFetchActionQueryError = ErrorType<unknown>

export const useGetFetchAction = <TData = Awaited<ReturnType<typeof getFetchAction>>, TError = ErrorType<unknown>>(
 id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFetchAction>>, TError, TData>>, request?: SecondParameter<typeof axios>}

  ): UseQueryReturnType<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetFetchActionQueryOptions(id,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: QueryKey };

  query.queryKey = unref(queryOptions).queryKey as QueryKey;

  return query;
}




export const getFetchRecipe = (
    id: MaybeRef<string>,
 options?: SecondParameter<typeof axios>,signal?: AbortSignal
) => {
      id = unref(id);
      
      return axios<FetchRecipeResponse>(
      {url: `/api/recipe/${id}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetFetchRecipeQueryKey = (id: MaybeRef<string>,) => {
    return ['api','recipe',id] as const;
    }

    
export const getGetFetchRecipeQueryOptions = <TData = Awaited<ReturnType<typeof getFetchRecipe>>, TError = ErrorType<unknown>>(id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFetchRecipe>>, TError, TData>>, request?: SecondParameter<typeof axios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getGetFetchRecipeQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFetchRecipe>>> = ({ signal }) => getFetchRecipe(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: computed(() => !!(unref(id))), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFetchRecipe>>, TError, TData> 
}

export type GetFetchRecipeQueryResult = NonNullable<Awaited<ReturnType<typeof getFetchRecipe>>>
export type GetFetchRecipeQueryError = ErrorType<unknown>

export const useGetFetchRecipe = <TData = Awaited<ReturnType<typeof getFetchRecipe>>, TError = ErrorType<unknown>>(
 id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFetchRecipe>>, TError, TData>>, request?: SecondParameter<typeof axios>}

  ): UseQueryReturnType<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetFetchRecipeQueryOptions(id,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: QueryKey };

  query.queryKey = unref(queryOptions).queryKey as QueryKey;

  return query;
}




export const postFetchAllActions = (
    abstractActionFiltersDTO: MaybeRef<AbstractActionFiltersDTO>,
    params?: MaybeRef<PostFetchAllActionsParams>,
 options?: SecondParameter<typeof axios>,) => {
      abstractActionFiltersDTO = unref(abstractActionFiltersDTO);
params = unref(params);
      
      return axios<FetchAllActionsResponse>(
      {url: `/api/actions`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: abstractActionFiltersDTO,
        params: unref(params)
    },
      options);
    }
  


export const getPostFetchAllActionsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postFetchAllActions>>, TError,{data: BodyType<AbstractActionFiltersDTO>;params?: PostFetchAllActionsParams}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postFetchAllActions>>, TError,{data: BodyType<AbstractActionFiltersDTO>;params?: PostFetchAllActionsParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postFetchAllActions>>, {data: BodyType<AbstractActionFiltersDTO>;params?: PostFetchAllActionsParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postFetchAllActions(data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostFetchAllActionsMutationResult = NonNullable<Awaited<ReturnType<typeof postFetchAllActions>>>
    export type PostFetchAllActionsMutationBody = BodyType<AbstractActionFiltersDTO>
    export type PostFetchAllActionsMutationError = ErrorType<unknown>

    export const usePostFetchAllActions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postFetchAllActions>>, TError,{data: BodyType<AbstractActionFiltersDTO>;params?: PostFetchAllActionsParams}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postFetchAllActions>>,
        TError,
        {data: BodyType<AbstractActionFiltersDTO>;params?: PostFetchAllActionsParams},
        TContext
      > => {

      const mutationOptions = getPostFetchAllActionsMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postFetchAllRecipes = (
    abstractActionFiltersDTO: MaybeRef<AbstractActionFiltersDTO>,
    params?: MaybeRef<PostFetchAllRecipesParams>,
 options?: SecondParameter<typeof axios>,) => {
      abstractActionFiltersDTO = unref(abstractActionFiltersDTO);
params = unref(params);
      
      return axios<FetchAllRecipesResponse>(
      {url: `/api/recipes`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: abstractActionFiltersDTO,
        params: unref(params)
    },
      options);
    }
  


export const getPostFetchAllRecipesMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postFetchAllRecipes>>, TError,{data: BodyType<AbstractActionFiltersDTO>;params?: PostFetchAllRecipesParams}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postFetchAllRecipes>>, TError,{data: BodyType<AbstractActionFiltersDTO>;params?: PostFetchAllRecipesParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postFetchAllRecipes>>, {data: BodyType<AbstractActionFiltersDTO>;params?: PostFetchAllRecipesParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postFetchAllRecipes(data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostFetchAllRecipesMutationResult = NonNullable<Awaited<ReturnType<typeof postFetchAllRecipes>>>
    export type PostFetchAllRecipesMutationBody = BodyType<AbstractActionFiltersDTO>
    export type PostFetchAllRecipesMutationError = ErrorType<unknown>

    export const usePostFetchAllRecipes = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postFetchAllRecipes>>, TError,{data: BodyType<AbstractActionFiltersDTO>;params?: PostFetchAllRecipesParams}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postFetchAllRecipes>>,
        TError,
        {data: BodyType<AbstractActionFiltersDTO>;params?: PostFetchAllRecipesParams},
        TContext
      > => {

      const mutationOptions = getPostFetchAllRecipesMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postFetchAllAbstractActions = (
    abstractActionFiltersDTO: MaybeRef<AbstractActionFiltersDTO>,
    params?: MaybeRef<PostFetchAllAbstractActionsParams>,
 options?: SecondParameter<typeof axios>,) => {
      abstractActionFiltersDTO = unref(abstractActionFiltersDTO);
params = unref(params);
      
      return axios<FetchAllActionsResponse>(
      {url: `/api/abstract-actions`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: abstractActionFiltersDTO,
        params: unref(params)
    },
      options);
    }
  


export const getPostFetchAllAbstractActionsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postFetchAllAbstractActions>>, TError,{data: BodyType<AbstractActionFiltersDTO>;params?: PostFetchAllAbstractActionsParams}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postFetchAllAbstractActions>>, TError,{data: BodyType<AbstractActionFiltersDTO>;params?: PostFetchAllAbstractActionsParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postFetchAllAbstractActions>>, {data: BodyType<AbstractActionFiltersDTO>;params?: PostFetchAllAbstractActionsParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postFetchAllAbstractActions(data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostFetchAllAbstractActionsMutationResult = NonNullable<Awaited<ReturnType<typeof postFetchAllAbstractActions>>>
    export type PostFetchAllAbstractActionsMutationBody = BodyType<AbstractActionFiltersDTO>
    export type PostFetchAllAbstractActionsMutationError = ErrorType<unknown>

    export const usePostFetchAllAbstractActions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postFetchAllAbstractActions>>, TError,{data: BodyType<AbstractActionFiltersDTO>;params?: PostFetchAllAbstractActionsParams}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postFetchAllAbstractActions>>,
        TError,
        {data: BodyType<AbstractActionFiltersDTO>;params?: PostFetchAllAbstractActionsParams},
        TContext
      > => {

      const mutationOptions = getPostFetchAllAbstractActionsMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const putUpdateAction = (
    id: MaybeRef<string>,
    updateActionDTO: MaybeRef<UpdateActionDTO>,
 options?: SecondParameter<typeof axios>,) => {
      id = unref(id);
updateActionDTO = unref(updateActionDTO);
      
      return axios<void>(
      {url: `/api/abstract-action/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateActionDTO
    },
      options);
    }
  


export const getPutUpdateActionMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putUpdateAction>>, TError,{id: string;data: BodyType<UpdateActionDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof putUpdateAction>>, TError,{id: string;data: BodyType<UpdateActionDTO>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putUpdateAction>>, {id: string;data: BodyType<UpdateActionDTO>}> = (props) => {
          const {id,data} = props ?? {};

          return  putUpdateAction(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutUpdateActionMutationResult = NonNullable<Awaited<ReturnType<typeof putUpdateAction>>>
    export type PutUpdateActionMutationBody = BodyType<UpdateActionDTO>
    export type PutUpdateActionMutationError = ErrorType<unknown>

    export const usePutUpdateAction = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putUpdateAction>>, TError,{id: string;data: BodyType<UpdateActionDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof putUpdateAction>>,
        TError,
        {id: string;data: BodyType<UpdateActionDTO>},
        TContext
      > => {

      const mutationOptions = getPutUpdateActionMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const patchPatchAction = (
    id: MaybeRef<string>,
    patchActionDTO: MaybeRef<PatchActionDTO>,
 options?: SecondParameter<typeof axios>,) => {
      id = unref(id);
patchActionDTO = unref(patchActionDTO);
      
      return axios<void>(
      {url: `/api/abstract-action/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchActionDTO
    },
      options);
    }
  


export const getPatchPatchActionMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchPatchAction>>, TError,{id: string;data: BodyType<PatchActionDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof patchPatchAction>>, TError,{id: string;data: BodyType<PatchActionDTO>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchPatchAction>>, {id: string;data: BodyType<PatchActionDTO>}> = (props) => {
          const {id,data} = props ?? {};

          return  patchPatchAction(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchPatchActionMutationResult = NonNullable<Awaited<ReturnType<typeof patchPatchAction>>>
    export type PatchPatchActionMutationBody = BodyType<PatchActionDTO>
    export type PatchPatchActionMutationError = ErrorType<unknown>

    export const usePatchPatchAction = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchPatchAction>>, TError,{id: string;data: BodyType<PatchActionDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof patchPatchAction>>,
        TError,
        {id: string;data: BodyType<PatchActionDTO>},
        TContext
      > => {

      const mutationOptions = getPatchPatchActionMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postUpdateActionStatus = (
    id: MaybeRef<string>,
    updateActionStatusDTO: MaybeRef<UpdateActionStatusDTO>,
 options?: SecondParameter<typeof axios>,) => {
      id = unref(id);
updateActionStatusDTO = unref(updateActionStatusDTO);
      
      return axios<void>(
      {url: `/api/abstract-action/${id}/status`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: updateActionStatusDTO
    },
      options);
    }
  


export const getPostUpdateActionStatusMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUpdateActionStatus>>, TError,{id: string;data: BodyType<UpdateActionStatusDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postUpdateActionStatus>>, TError,{id: string;data: BodyType<UpdateActionStatusDTO>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postUpdateActionStatus>>, {id: string;data: BodyType<UpdateActionStatusDTO>}> = (props) => {
          const {id,data} = props ?? {};

          return  postUpdateActionStatus(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostUpdateActionStatusMutationResult = NonNullable<Awaited<ReturnType<typeof postUpdateActionStatus>>>
    export type PostUpdateActionStatusMutationBody = BodyType<UpdateActionStatusDTO>
    export type PostUpdateActionStatusMutationError = ErrorType<unknown>

    export const usePostUpdateActionStatus = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUpdateActionStatus>>, TError,{id: string;data: BodyType<UpdateActionStatusDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postUpdateActionStatus>>,
        TError,
        {id: string;data: BodyType<UpdateActionStatusDTO>},
        TContext
      > => {

      const mutationOptions = getPostUpdateActionStatusMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getFetchArticle = (
    id: MaybeRef<string>,
 options?: SecondParameter<typeof axios>,signal?: AbortSignal
) => {
      id = unref(id);
      
      return axios<FetchArticleResponse>(
      {url: `/api/article/${id}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetFetchArticleQueryKey = (id: MaybeRef<string>,) => {
    return ['api','article',id] as const;
    }

    
export const getGetFetchArticleQueryOptions = <TData = Awaited<ReturnType<typeof getFetchArticle>>, TError = ErrorType<unknown>>(id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFetchArticle>>, TError, TData>>, request?: SecondParameter<typeof axios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getGetFetchArticleQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFetchArticle>>> = ({ signal }) => getFetchArticle(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: computed(() => !!(unref(id))), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFetchArticle>>, TError, TData> 
}

export type GetFetchArticleQueryResult = NonNullable<Awaited<ReturnType<typeof getFetchArticle>>>
export type GetFetchArticleQueryError = ErrorType<unknown>

export const useGetFetchArticle = <TData = Awaited<ReturnType<typeof getFetchArticle>>, TError = ErrorType<unknown>>(
 id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFetchArticle>>, TError, TData>>, request?: SecondParameter<typeof axios>}

  ): UseQueryReturnType<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetFetchArticleQueryOptions(id,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: QueryKey };

  query.queryKey = unref(queryOptions).queryKey as QueryKey;

  return query;
}




export const patchPatchArticle = (
    id: MaybeRef<string>,
    patchArticleDTO: MaybeRef<PatchArticleDTO>,
 options?: SecondParameter<typeof axios>,) => {
      id = unref(id);
patchArticleDTO = unref(patchArticleDTO);
      
      return axios<void>(
      {url: `/api/article/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchArticleDTO
    },
      options);
    }
  


export const getPatchPatchArticleMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchPatchArticle>>, TError,{id: string;data: BodyType<PatchArticleDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof patchPatchArticle>>, TError,{id: string;data: BodyType<PatchArticleDTO>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchPatchArticle>>, {id: string;data: BodyType<PatchArticleDTO>}> = (props) => {
          const {id,data} = props ?? {};

          return  patchPatchArticle(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchPatchArticleMutationResult = NonNullable<Awaited<ReturnType<typeof patchPatchArticle>>>
    export type PatchPatchArticleMutationBody = BodyType<PatchArticleDTO>
    export type PatchPatchArticleMutationError = ErrorType<unknown>

    export const usePatchPatchArticle = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchPatchArticle>>, TError,{id: string;data: BodyType<PatchArticleDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof patchPatchArticle>>,
        TError,
        {id: string;data: BodyType<PatchArticleDTO>},
        TContext
      > => {

      const mutationOptions = getPatchPatchArticleMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getFetchArticleByArticleOptionExternalId = (
    externalId: MaybeRef<string>,
 options?: SecondParameter<typeof axios>,signal?: AbortSignal
) => {
      externalId = unref(externalId);
      
      return axios<FetchArticleResponse>(
      {url: `/api/article/external/${externalId}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetFetchArticleByArticleOptionExternalIdQueryKey = (externalId: MaybeRef<string>,) => {
    return ['api','article','external',externalId] as const;
    }

    
export const getGetFetchArticleByArticleOptionExternalIdQueryOptions = <TData = Awaited<ReturnType<typeof getFetchArticleByArticleOptionExternalId>>, TError = ErrorType<unknown>>(externalId: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFetchArticleByArticleOptionExternalId>>, TError, TData>>, request?: SecondParameter<typeof axios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getGetFetchArticleByArticleOptionExternalIdQueryKey(externalId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFetchArticleByArticleOptionExternalId>>> = ({ signal }) => getFetchArticleByArticleOptionExternalId(externalId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: computed(() => !!(unref(externalId))), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFetchArticleByArticleOptionExternalId>>, TError, TData> 
}

export type GetFetchArticleByArticleOptionExternalIdQueryResult = NonNullable<Awaited<ReturnType<typeof getFetchArticleByArticleOptionExternalId>>>
export type GetFetchArticleByArticleOptionExternalIdQueryError = ErrorType<unknown>

export const useGetFetchArticleByArticleOptionExternalId = <TData = Awaited<ReturnType<typeof getFetchArticleByArticleOptionExternalId>>, TError = ErrorType<unknown>>(
 externalId: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFetchArticleByArticleOptionExternalId>>, TError, TData>>, request?: SecondParameter<typeof axios>}

  ): UseQueryReturnType<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetFetchArticleByArticleOptionExternalIdQueryOptions(externalId,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: QueryKey };

  query.queryKey = unref(queryOptions).queryKey as QueryKey;

  return query;
}




export const postFetchAllArticles = (
    articleFiltersDTO: MaybeRef<ArticleFiltersDTO>,
    params?: MaybeRef<PostFetchAllArticlesParams>,
 options?: SecondParameter<typeof axios>,) => {
      articleFiltersDTO = unref(articleFiltersDTO);
params = unref(params);
      
      return axios<FetchAllArticlesResponse>(
      {url: `/api/articles`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: articleFiltersDTO,
        params: unref(params)
    },
      options);
    }
  


export const getPostFetchAllArticlesMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postFetchAllArticles>>, TError,{data: BodyType<ArticleFiltersDTO>;params?: PostFetchAllArticlesParams}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postFetchAllArticles>>, TError,{data: BodyType<ArticleFiltersDTO>;params?: PostFetchAllArticlesParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postFetchAllArticles>>, {data: BodyType<ArticleFiltersDTO>;params?: PostFetchAllArticlesParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postFetchAllArticles(data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostFetchAllArticlesMutationResult = NonNullable<Awaited<ReturnType<typeof postFetchAllArticles>>>
    export type PostFetchAllArticlesMutationBody = BodyType<ArticleFiltersDTO>
    export type PostFetchAllArticlesMutationError = ErrorType<unknown>

    export const usePostFetchAllArticles = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postFetchAllArticles>>, TError,{data: BodyType<ArticleFiltersDTO>;params?: PostFetchAllArticlesParams}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postFetchAllArticles>>,
        TError,
        {data: BodyType<ArticleFiltersDTO>;params?: PostFetchAllArticlesParams},
        TContext
      > => {

      const mutationOptions = getPostFetchAllArticlesMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postCreateArticle = (
    createArticleDTO: MaybeRef<CreateArticleDTO>,
 options?: SecondParameter<typeof axios>,) => {
      createArticleDTO = unref(createArticleDTO);
      
      return axios<CreateResponse>(
      {url: `/api/article`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createArticleDTO
    },
      options);
    }
  


export const getPostCreateArticleMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCreateArticle>>, TError,{data: BodyType<CreateArticleDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postCreateArticle>>, TError,{data: BodyType<CreateArticleDTO>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCreateArticle>>, {data: BodyType<CreateArticleDTO>}> = (props) => {
          const {data} = props ?? {};

          return  postCreateArticle(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostCreateArticleMutationResult = NonNullable<Awaited<ReturnType<typeof postCreateArticle>>>
    export type PostCreateArticleMutationBody = BodyType<CreateArticleDTO>
    export type PostCreateArticleMutationError = ErrorType<unknown>

    export const usePostCreateArticle = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCreateArticle>>, TError,{data: BodyType<CreateArticleDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postCreateArticle>>,
        TError,
        {data: BodyType<CreateArticleDTO>},
        TContext
      > => {

      const mutationOptions = getPostCreateArticleMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postCreateSupplier = (
    createSupplierDTO: MaybeRef<CreateSupplierDTO>,
 options?: SecondParameter<typeof axios>,) => {
      createSupplierDTO = unref(createSupplierDTO);
      
      return axios<CreateResponse>(
      {url: `/api/supplier`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createSupplierDTO
    },
      options);
    }
  


export const getPostCreateSupplierMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCreateSupplier>>, TError,{data: BodyType<CreateSupplierDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postCreateSupplier>>, TError,{data: BodyType<CreateSupplierDTO>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCreateSupplier>>, {data: BodyType<CreateSupplierDTO>}> = (props) => {
          const {data} = props ?? {};

          return  postCreateSupplier(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostCreateSupplierMutationResult = NonNullable<Awaited<ReturnType<typeof postCreateSupplier>>>
    export type PostCreateSupplierMutationBody = BodyType<CreateSupplierDTO>
    export type PostCreateSupplierMutationError = ErrorType<unknown>

    export const usePostCreateSupplier = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCreateSupplier>>, TError,{data: BodyType<CreateSupplierDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postCreateSupplier>>,
        TError,
        {data: BodyType<CreateSupplierDTO>},
        TContext
      > => {

      const mutationOptions = getPostCreateSupplierMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getFetchSupplier = (
    id: MaybeRef<string>,
 options?: SecondParameter<typeof axios>,signal?: AbortSignal
) => {
      id = unref(id);
      
      return axios<FetchSupplierResponse>(
      {url: `/api/supplier/${id}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetFetchSupplierQueryKey = (id: MaybeRef<string>,) => {
    return ['api','supplier',id] as const;
    }

    
export const getGetFetchSupplierQueryOptions = <TData = Awaited<ReturnType<typeof getFetchSupplier>>, TError = ErrorType<unknown>>(id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFetchSupplier>>, TError, TData>>, request?: SecondParameter<typeof axios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getGetFetchSupplierQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFetchSupplier>>> = ({ signal }) => getFetchSupplier(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: computed(() => !!(unref(id))), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFetchSupplier>>, TError, TData> 
}

export type GetFetchSupplierQueryResult = NonNullable<Awaited<ReturnType<typeof getFetchSupplier>>>
export type GetFetchSupplierQueryError = ErrorType<unknown>

export const useGetFetchSupplier = <TData = Awaited<ReturnType<typeof getFetchSupplier>>, TError = ErrorType<unknown>>(
 id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFetchSupplier>>, TError, TData>>, request?: SecondParameter<typeof axios>}

  ): UseQueryReturnType<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetFetchSupplierQueryOptions(id,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: QueryKey };

  query.queryKey = unref(queryOptions).queryKey as QueryKey;

  return query;
}




export const putUpdateSupplier = (
    id: MaybeRef<string>,
    updateSupplierDTO: MaybeRef<UpdateSupplierDTO>,
 options?: SecondParameter<typeof axios>,) => {
      id = unref(id);
updateSupplierDTO = unref(updateSupplierDTO);
      
      return axios<void>(
      {url: `/api/supplier/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateSupplierDTO
    },
      options);
    }
  


export const getPutUpdateSupplierMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putUpdateSupplier>>, TError,{id: string;data: BodyType<UpdateSupplierDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof putUpdateSupplier>>, TError,{id: string;data: BodyType<UpdateSupplierDTO>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putUpdateSupplier>>, {id: string;data: BodyType<UpdateSupplierDTO>}> = (props) => {
          const {id,data} = props ?? {};

          return  putUpdateSupplier(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutUpdateSupplierMutationResult = NonNullable<Awaited<ReturnType<typeof putUpdateSupplier>>>
    export type PutUpdateSupplierMutationBody = BodyType<UpdateSupplierDTO>
    export type PutUpdateSupplierMutationError = ErrorType<unknown>

    export const usePutUpdateSupplier = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putUpdateSupplier>>, TError,{id: string;data: BodyType<UpdateSupplierDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof putUpdateSupplier>>,
        TError,
        {id: string;data: BodyType<UpdateSupplierDTO>},
        TContext
      > => {

      const mutationOptions = getPutUpdateSupplierMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postFetchAllSupplier = (
    params?: MaybeRef<PostFetchAllSupplierParams>,
 options?: SecondParameter<typeof axios>,) => {
      params = unref(params);
      
      return axios<FetchAllSuppliers>(
      {url: `/api/suppliers`, method: 'POST',
        params: unref(params)
    },
      options);
    }
  


export const getPostFetchAllSupplierMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postFetchAllSupplier>>, TError,{params?: PostFetchAllSupplierParams}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postFetchAllSupplier>>, TError,{params?: PostFetchAllSupplierParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postFetchAllSupplier>>, {params?: PostFetchAllSupplierParams}> = (props) => {
          const {params} = props ?? {};

          return  postFetchAllSupplier(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostFetchAllSupplierMutationResult = NonNullable<Awaited<ReturnType<typeof postFetchAllSupplier>>>
    
    export type PostFetchAllSupplierMutationError = ErrorType<unknown>

    export const usePostFetchAllSupplier = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postFetchAllSupplier>>, TError,{params?: PostFetchAllSupplierParams}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postFetchAllSupplier>>,
        TError,
        {params?: PostFetchAllSupplierParams},
        TContext
      > => {

      const mutationOptions = getPostFetchAllSupplierMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postCreateSaleHistory = (
    createSaleHistoryDTO: MaybeRef<CreateSaleHistoryDTO>,
 options?: SecondParameter<typeof axios>,) => {
      createSaleHistoryDTO = unref(createSaleHistoryDTO);
      
      return axios<CreateResponse>(
      {url: `/api/sale-history`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createSaleHistoryDTO
    },
      options);
    }
  


export const getPostCreateSaleHistoryMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCreateSaleHistory>>, TError,{data: BodyType<CreateSaleHistoryDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postCreateSaleHistory>>, TError,{data: BodyType<CreateSaleHistoryDTO>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCreateSaleHistory>>, {data: BodyType<CreateSaleHistoryDTO>}> = (props) => {
          const {data} = props ?? {};

          return  postCreateSaleHistory(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostCreateSaleHistoryMutationResult = NonNullable<Awaited<ReturnType<typeof postCreateSaleHistory>>>
    export type PostCreateSaleHistoryMutationBody = BodyType<CreateSaleHistoryDTO>
    export type PostCreateSaleHistoryMutationError = ErrorType<unknown>

    export const usePostCreateSaleHistory = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCreateSaleHistory>>, TError,{data: BodyType<CreateSaleHistoryDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postCreateSaleHistory>>,
        TError,
        {data: BodyType<CreateSaleHistoryDTO>},
        TContext
      > => {

      const mutationOptions = getPostCreateSaleHistoryMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postFetchAllSaleHistories = (
    fetchAllSaleHistoriesDTO: MaybeRef<FetchAllSaleHistoriesDTO>,
    params?: MaybeRef<PostFetchAllSaleHistoriesParams>,
 options?: SecondParameter<typeof axios>,) => {
      fetchAllSaleHistoriesDTO = unref(fetchAllSaleHistoriesDTO);
params = unref(params);
      
      return axios<FetchAllSaleHistoriesResponse>(
      {url: `/api/sale-histories`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: fetchAllSaleHistoriesDTO,
        params: unref(params)
    },
      options);
    }
  


export const getPostFetchAllSaleHistoriesMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postFetchAllSaleHistories>>, TError,{data: BodyType<FetchAllSaleHistoriesDTO>;params?: PostFetchAllSaleHistoriesParams}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postFetchAllSaleHistories>>, TError,{data: BodyType<FetchAllSaleHistoriesDTO>;params?: PostFetchAllSaleHistoriesParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postFetchAllSaleHistories>>, {data: BodyType<FetchAllSaleHistoriesDTO>;params?: PostFetchAllSaleHistoriesParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postFetchAllSaleHistories(data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostFetchAllSaleHistoriesMutationResult = NonNullable<Awaited<ReturnType<typeof postFetchAllSaleHistories>>>
    export type PostFetchAllSaleHistoriesMutationBody = BodyType<FetchAllSaleHistoriesDTO>
    export type PostFetchAllSaleHistoriesMutationError = ErrorType<unknown>

    export const usePostFetchAllSaleHistories = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postFetchAllSaleHistories>>, TError,{data: BodyType<FetchAllSaleHistoriesDTO>;params?: PostFetchAllSaleHistoriesParams}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postFetchAllSaleHistories>>,
        TError,
        {data: BodyType<FetchAllSaleHistoriesDTO>;params?: PostFetchAllSaleHistoriesParams},
        TContext
      > => {

      const mutationOptions = getPostFetchAllSaleHistoriesMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postFetchAllPurchaseHistories = (
    fetchAllPurchaseHistoriesDTO: MaybeRef<FetchAllPurchaseHistoriesDTO>,
    params?: MaybeRef<PostFetchAllPurchaseHistoriesParams>,
 options?: SecondParameter<typeof axios>,) => {
      fetchAllPurchaseHistoriesDTO = unref(fetchAllPurchaseHistoriesDTO);
params = unref(params);
      
      return axios<FetchAllPurchaseHistoriesResponse[]>(
      {url: `/api/purchase-histories`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: fetchAllPurchaseHistoriesDTO,
        params: unref(params)
    },
      options);
    }
  


export const getPostFetchAllPurchaseHistoriesMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postFetchAllPurchaseHistories>>, TError,{data: BodyType<FetchAllPurchaseHistoriesDTO>;params?: PostFetchAllPurchaseHistoriesParams}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postFetchAllPurchaseHistories>>, TError,{data: BodyType<FetchAllPurchaseHistoriesDTO>;params?: PostFetchAllPurchaseHistoriesParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postFetchAllPurchaseHistories>>, {data: BodyType<FetchAllPurchaseHistoriesDTO>;params?: PostFetchAllPurchaseHistoriesParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postFetchAllPurchaseHistories(data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostFetchAllPurchaseHistoriesMutationResult = NonNullable<Awaited<ReturnType<typeof postFetchAllPurchaseHistories>>>
    export type PostFetchAllPurchaseHistoriesMutationBody = BodyType<FetchAllPurchaseHistoriesDTO>
    export type PostFetchAllPurchaseHistoriesMutationError = ErrorType<unknown>

    export const usePostFetchAllPurchaseHistories = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postFetchAllPurchaseHistories>>, TError,{data: BodyType<FetchAllPurchaseHistoriesDTO>;params?: PostFetchAllPurchaseHistoriesParams}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postFetchAllPurchaseHistories>>,
        TError,
        {data: BodyType<FetchAllPurchaseHistoriesDTO>;params?: PostFetchAllPurchaseHistoriesParams},
        TContext
      > => {

      const mutationOptions = getPostFetchAllPurchaseHistoriesMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postCreatePurchaseHistory = (
    createPurchaseHistoryDTO: MaybeRef<CreatePurchaseHistoryDTO>,
 options?: SecondParameter<typeof axios>,) => {
      createPurchaseHistoryDTO = unref(createPurchaseHistoryDTO);
      
      return axios<CreateResponse>(
      {url: `/api/purchase-history`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createPurchaseHistoryDTO
    },
      options);
    }
  


export const getPostCreatePurchaseHistoryMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCreatePurchaseHistory>>, TError,{data: BodyType<CreatePurchaseHistoryDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postCreatePurchaseHistory>>, TError,{data: BodyType<CreatePurchaseHistoryDTO>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCreatePurchaseHistory>>, {data: BodyType<CreatePurchaseHistoryDTO>}> = (props) => {
          const {data} = props ?? {};

          return  postCreatePurchaseHistory(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostCreatePurchaseHistoryMutationResult = NonNullable<Awaited<ReturnType<typeof postCreatePurchaseHistory>>>
    export type PostCreatePurchaseHistoryMutationBody = BodyType<CreatePurchaseHistoryDTO>
    export type PostCreatePurchaseHistoryMutationError = ErrorType<unknown>

    export const usePostCreatePurchaseHistory = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCreatePurchaseHistory>>, TError,{data: BodyType<CreatePurchaseHistoryDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postCreatePurchaseHistory>>,
        TError,
        {data: BodyType<CreatePurchaseHistoryDTO>},
        TContext
      > => {

      const mutationOptions = getPostCreatePurchaseHistoryMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postUpdateArticleOptionStatus = (
    id: MaybeRef<string>,
    updateArticleOptionStatusDTO: MaybeRef<UpdateArticleOptionStatusDTO>,
 options?: SecondParameter<typeof axios>,) => {
      id = unref(id);
updateArticleOptionStatusDTO = unref(updateArticleOptionStatusDTO);
      
      return axios<void>(
      {url: `/api/article-option/${id}/status`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: updateArticleOptionStatusDTO
    },
      options);
    }
  


export const getPostUpdateArticleOptionStatusMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUpdateArticleOptionStatus>>, TError,{id: string;data: BodyType<UpdateArticleOptionStatusDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postUpdateArticleOptionStatus>>, TError,{id: string;data: BodyType<UpdateArticleOptionStatusDTO>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postUpdateArticleOptionStatus>>, {id: string;data: BodyType<UpdateArticleOptionStatusDTO>}> = (props) => {
          const {id,data} = props ?? {};

          return  postUpdateArticleOptionStatus(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostUpdateArticleOptionStatusMutationResult = NonNullable<Awaited<ReturnType<typeof postUpdateArticleOptionStatus>>>
    export type PostUpdateArticleOptionStatusMutationBody = BodyType<UpdateArticleOptionStatusDTO>
    export type PostUpdateArticleOptionStatusMutationError = ErrorType<unknown>

    export const usePostUpdateArticleOptionStatus = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUpdateArticleOptionStatus>>, TError,{id: string;data: BodyType<UpdateArticleOptionStatusDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postUpdateArticleOptionStatus>>,
        TError,
        {id: string;data: BodyType<UpdateArticleOptionStatusDTO>},
        TContext
      > => {

      const mutationOptions = getPostUpdateArticleOptionStatusMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Create an article option
 */
export const postCreateArticleOption = (
    createArticleOptionDTO: MaybeRef<CreateArticleOptionDTO>,
 options?: SecondParameter<typeof axios>,) => {
      createArticleOptionDTO = unref(createArticleOptionDTO);
      
      return axios<CreateResponse>(
      {url: `/api/article-option`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createArticleOptionDTO
    },
      options);
    }
  


export const getPostCreateArticleOptionMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCreateArticleOption>>, TError,{data: BodyType<CreateArticleOptionDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postCreateArticleOption>>, TError,{data: BodyType<CreateArticleOptionDTO>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCreateArticleOption>>, {data: BodyType<CreateArticleOptionDTO>}> = (props) => {
          const {data} = props ?? {};

          return  postCreateArticleOption(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostCreateArticleOptionMutationResult = NonNullable<Awaited<ReturnType<typeof postCreateArticleOption>>>
    export type PostCreateArticleOptionMutationBody = BodyType<CreateArticleOptionDTO>
    export type PostCreateArticleOptionMutationError = ErrorType<unknown>

    /**
 * @summary Create an article option
 */
export const usePostCreateArticleOption = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCreateArticleOption>>, TError,{data: BodyType<CreateArticleOptionDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postCreateArticleOption>>,
        TError,
        {data: BodyType<CreateArticleOptionDTO>},
        TContext
      > => {

      const mutationOptions = getPostCreateArticleOptionMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Fetch an article option by id
 */
export const getFetchArticleOption = (
    id: MaybeRef<string>,
 options?: SecondParameter<typeof axios>,signal?: AbortSignal
) => {
      id = unref(id);
      
      return axios<FetchArticleOptionResponse>(
      {url: `/api/article-option/${id}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetFetchArticleOptionQueryKey = (id: MaybeRef<string>,) => {
    return ['api','article-option',id] as const;
    }

    
export const getGetFetchArticleOptionQueryOptions = <TData = Awaited<ReturnType<typeof getFetchArticleOption>>, TError = ErrorType<unknown>>(id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFetchArticleOption>>, TError, TData>>, request?: SecondParameter<typeof axios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getGetFetchArticleOptionQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFetchArticleOption>>> = ({ signal }) => getFetchArticleOption(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: computed(() => !!(unref(id))), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFetchArticleOption>>, TError, TData> 
}

export type GetFetchArticleOptionQueryResult = NonNullable<Awaited<ReturnType<typeof getFetchArticleOption>>>
export type GetFetchArticleOptionQueryError = ErrorType<unknown>

/**
 * @summary Fetch an article option by id
 */
export const useGetFetchArticleOption = <TData = Awaited<ReturnType<typeof getFetchArticleOption>>, TError = ErrorType<unknown>>(
 id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFetchArticleOption>>, TError, TData>>, request?: SecondParameter<typeof axios>}

  ): UseQueryReturnType<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetFetchArticleOptionQueryOptions(id,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: QueryKey };

  query.queryKey = unref(queryOptions).queryKey as QueryKey;

  return query;
}




/**
 * @summary Update an article option
 */
export const patchPatchArticleOption = (
    id: MaybeRef<string>,
    patchArticleOptionDTO: MaybeRef<PatchArticleOptionDTO>,
 options?: SecondParameter<typeof axios>,) => {
      id = unref(id);
patchArticleOptionDTO = unref(patchArticleOptionDTO);
      
      return axios<void>(
      {url: `/api/article-option/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchArticleOptionDTO
    },
      options);
    }
  


export const getPatchPatchArticleOptionMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchPatchArticleOption>>, TError,{id: string;data: BodyType<PatchArticleOptionDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof patchPatchArticleOption>>, TError,{id: string;data: BodyType<PatchArticleOptionDTO>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchPatchArticleOption>>, {id: string;data: BodyType<PatchArticleOptionDTO>}> = (props) => {
          const {id,data} = props ?? {};

          return  patchPatchArticleOption(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchPatchArticleOptionMutationResult = NonNullable<Awaited<ReturnType<typeof patchPatchArticleOption>>>
    export type PatchPatchArticleOptionMutationBody = BodyType<PatchArticleOptionDTO>
    export type PatchPatchArticleOptionMutationError = ErrorType<unknown>

    /**
 * @summary Update an article option
 */
export const usePatchPatchArticleOption = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchPatchArticleOption>>, TError,{id: string;data: BodyType<PatchArticleOptionDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof patchPatchArticleOption>>,
        TError,
        {id: string;data: BodyType<PatchArticleOptionDTO>},
        TContext
      > => {

      const mutationOptions = getPatchPatchArticleOptionMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postAddArticleOptionToArticle = (
    id: MaybeRef<string>,
    addArticleOptionToArticleDTO: MaybeRef<AddArticleOptionToArticleDTO>,
 options?: SecondParameter<typeof axios>,) => {
      id = unref(id);
addArticleOptionToArticleDTO = unref(addArticleOptionToArticleDTO);
      
      return axios<void>(
      {url: `/api/article/${id}/add-article-option`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: addArticleOptionToArticleDTO
    },
      options);
    }
  


export const getPostAddArticleOptionToArticleMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAddArticleOptionToArticle>>, TError,{id: string;data: BodyType<AddArticleOptionToArticleDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postAddArticleOptionToArticle>>, TError,{id: string;data: BodyType<AddArticleOptionToArticleDTO>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAddArticleOptionToArticle>>, {id: string;data: BodyType<AddArticleOptionToArticleDTO>}> = (props) => {
          const {id,data} = props ?? {};

          return  postAddArticleOptionToArticle(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAddArticleOptionToArticleMutationResult = NonNullable<Awaited<ReturnType<typeof postAddArticleOptionToArticle>>>
    export type PostAddArticleOptionToArticleMutationBody = BodyType<AddArticleOptionToArticleDTO>
    export type PostAddArticleOptionToArticleMutationError = ErrorType<void>

    export const usePostAddArticleOptionToArticle = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAddArticleOptionToArticle>>, TError,{id: string;data: BodyType<AddArticleOptionToArticleDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postAddArticleOptionToArticle>>,
        TError,
        {id: string;data: BodyType<AddArticleOptionToArticleDTO>},
        TContext
      > => {

      const mutationOptions = getPostAddArticleOptionToArticleMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const deleteRemoveArticleOptionFromArticle = (
    id: MaybeRef<string>,
    articleOptionId: MaybeRef<string>,
 options?: SecondParameter<typeof axios>,) => {
      id = unref(id);
articleOptionId = unref(articleOptionId);
      
      return axios<void>(
      {url: `/api/article/${id}/article-option/${articleOptionId}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteRemoveArticleOptionFromArticleMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteRemoveArticleOptionFromArticle>>, TError,{id: string;articleOptionId: string}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteRemoveArticleOptionFromArticle>>, TError,{id: string;articleOptionId: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteRemoveArticleOptionFromArticle>>, {id: string;articleOptionId: string}> = (props) => {
          const {id,articleOptionId} = props ?? {};

          return  deleteRemoveArticleOptionFromArticle(id,articleOptionId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteRemoveArticleOptionFromArticleMutationResult = NonNullable<Awaited<ReturnType<typeof deleteRemoveArticleOptionFromArticle>>>
    
    export type DeleteRemoveArticleOptionFromArticleMutationError = ErrorType<void>

    export const useDeleteRemoveArticleOptionFromArticle = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteRemoveArticleOptionFromArticle>>, TError,{id: string;articleOptionId: string}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof deleteRemoveArticleOptionFromArticle>>,
        TError,
        {id: string;articleOptionId: string},
        TContext
      > => {

      const mutationOptions = getDeleteRemoveArticleOptionFromArticleMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getFetchAddress = (
    id: MaybeRef<string>,
 options?: SecondParameter<typeof axios>,signal?: AbortSignal
) => {
      id = unref(id);
      
      return axios<FetchAddressResponse>(
      {url: `/api/address/${id}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetFetchAddressQueryKey = (id: MaybeRef<string>,) => {
    return ['api','address',id] as const;
    }

    
export const getGetFetchAddressQueryOptions = <TData = Awaited<ReturnType<typeof getFetchAddress>>, TError = ErrorType<unknown>>(id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFetchAddress>>, TError, TData>>, request?: SecondParameter<typeof axios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getGetFetchAddressQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFetchAddress>>> = ({ signal }) => getFetchAddress(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: computed(() => !!(unref(id))), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFetchAddress>>, TError, TData> 
}

export type GetFetchAddressQueryResult = NonNullable<Awaited<ReturnType<typeof getFetchAddress>>>
export type GetFetchAddressQueryError = ErrorType<unknown>

export const useGetFetchAddress = <TData = Awaited<ReturnType<typeof getFetchAddress>>, TError = ErrorType<unknown>>(
 id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFetchAddress>>, TError, TData>>, request?: SecondParameter<typeof axios>}

  ): UseQueryReturnType<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetFetchAddressQueryOptions(id,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: QueryKey };

  query.queryKey = unref(queryOptions).queryKey as QueryKey;

  return query;
}




export const postFetchAllAddresses = (
    params?: MaybeRef<PostFetchAllAddressesParams>,
 options?: SecondParameter<typeof axios>,) => {
      params = unref(params);
      
      return axios<FetchAllAddressesResponse>(
      {url: `/api/addresses`, method: 'POST',
        params: unref(params)
    },
      options);
    }
  


export const getPostFetchAllAddressesMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postFetchAllAddresses>>, TError,{params?: PostFetchAllAddressesParams}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postFetchAllAddresses>>, TError,{params?: PostFetchAllAddressesParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postFetchAllAddresses>>, {params?: PostFetchAllAddressesParams}> = (props) => {
          const {params} = props ?? {};

          return  postFetchAllAddresses(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostFetchAllAddressesMutationResult = NonNullable<Awaited<ReturnType<typeof postFetchAllAddresses>>>
    
    export type PostFetchAllAddressesMutationError = ErrorType<unknown>

    export const usePostFetchAllAddresses = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postFetchAllAddresses>>, TError,{params?: PostFetchAllAddressesParams}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postFetchAllAddresses>>,
        TError,
        {params?: PostFetchAllAddressesParams},
        TContext
      > => {

      const mutationOptions = getPostFetchAllAddressesMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postCreateAddress = (
    createAddressDTO: MaybeRef<CreateAddressDTO>,
 options?: SecondParameter<typeof axios>,) => {
      createAddressDTO = unref(createAddressDTO);
      
      return axios<CreateResponse>(
      {url: `/api/address`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createAddressDTO
    },
      options);
    }
  


export const getPostCreateAddressMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCreateAddress>>, TError,{data: BodyType<CreateAddressDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postCreateAddress>>, TError,{data: BodyType<CreateAddressDTO>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCreateAddress>>, {data: BodyType<CreateAddressDTO>}> = (props) => {
          const {data} = props ?? {};

          return  postCreateAddress(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostCreateAddressMutationResult = NonNullable<Awaited<ReturnType<typeof postCreateAddress>>>
    export type PostCreateAddressMutationBody = BodyType<CreateAddressDTO>
    export type PostCreateAddressMutationError = ErrorType<unknown>

    export const usePostCreateAddress = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCreateAddress>>, TError,{data: BodyType<CreateAddressDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postCreateAddress>>,
        TError,
        {data: BodyType<CreateAddressDTO>},
        TContext
      > => {

      const mutationOptions = getPostCreateAddressMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getFetchOrganisation = (
    id: MaybeRef<string>,
 options?: SecondParameter<typeof axios>,signal?: AbortSignal
) => {
      id = unref(id);
      
      return axios<FetchOrganisationResponse>(
      {url: `/api/organisation/${id}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetFetchOrganisationQueryKey = (id: MaybeRef<string>,) => {
    return ['api','organisation',id] as const;
    }

    
export const getGetFetchOrganisationQueryOptions = <TData = Awaited<ReturnType<typeof getFetchOrganisation>>, TError = ErrorType<unknown>>(id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFetchOrganisation>>, TError, TData>>, request?: SecondParameter<typeof axios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getGetFetchOrganisationQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFetchOrganisation>>> = ({ signal }) => getFetchOrganisation(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: computed(() => !!(unref(id))), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFetchOrganisation>>, TError, TData> 
}

export type GetFetchOrganisationQueryResult = NonNullable<Awaited<ReturnType<typeof getFetchOrganisation>>>
export type GetFetchOrganisationQueryError = ErrorType<unknown>

export const useGetFetchOrganisation = <TData = Awaited<ReturnType<typeof getFetchOrganisation>>, TError = ErrorType<unknown>>(
 id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFetchOrganisation>>, TError, TData>>, request?: SecondParameter<typeof axios>}

  ): UseQueryReturnType<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetFetchOrganisationQueryOptions(id,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: QueryKey };

  query.queryKey = unref(queryOptions).queryKey as QueryKey;

  return query;
}




export const putUpdateOrganisation = (
    id: MaybeRef<string>,
    updateOrganisationDTO: MaybeRef<UpdateOrganisationDTO>,
 options?: SecondParameter<typeof axios>,) => {
      id = unref(id);
updateOrganisationDTO = unref(updateOrganisationDTO);
      
      return axios<void>(
      {url: `/api/organisation/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateOrganisationDTO
    },
      options);
    }
  


export const getPutUpdateOrganisationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putUpdateOrganisation>>, TError,{id: string;data: BodyType<UpdateOrganisationDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof putUpdateOrganisation>>, TError,{id: string;data: BodyType<UpdateOrganisationDTO>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putUpdateOrganisation>>, {id: string;data: BodyType<UpdateOrganisationDTO>}> = (props) => {
          const {id,data} = props ?? {};

          return  putUpdateOrganisation(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutUpdateOrganisationMutationResult = NonNullable<Awaited<ReturnType<typeof putUpdateOrganisation>>>
    export type PutUpdateOrganisationMutationBody = BodyType<UpdateOrganisationDTO>
    export type PutUpdateOrganisationMutationError = ErrorType<unknown>

    export const usePutUpdateOrganisation = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putUpdateOrganisation>>, TError,{id: string;data: BodyType<UpdateOrganisationDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof putUpdateOrganisation>>,
        TError,
        {id: string;data: BodyType<UpdateOrganisationDTO>},
        TContext
      > => {

      const mutationOptions = getPutUpdateOrganisationMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const patchPatchOrganisation = (
    id: MaybeRef<string>,
    patchOrganisationDTO: MaybeRef<PatchOrganisationDTO>,
 options?: SecondParameter<typeof axios>,) => {
      id = unref(id);
patchOrganisationDTO = unref(patchOrganisationDTO);
      
      return axios<void>(
      {url: `/api/organisation/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchOrganisationDTO
    },
      options);
    }
  


export const getPatchPatchOrganisationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchPatchOrganisation>>, TError,{id: string;data: BodyType<PatchOrganisationDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof patchPatchOrganisation>>, TError,{id: string;data: BodyType<PatchOrganisationDTO>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchPatchOrganisation>>, {id: string;data: BodyType<PatchOrganisationDTO>}> = (props) => {
          const {id,data} = props ?? {};

          return  patchPatchOrganisation(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchPatchOrganisationMutationResult = NonNullable<Awaited<ReturnType<typeof patchPatchOrganisation>>>
    export type PatchPatchOrganisationMutationBody = BodyType<PatchOrganisationDTO>
    export type PatchPatchOrganisationMutationError = ErrorType<unknown>

    export const usePatchPatchOrganisation = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchPatchOrganisation>>, TError,{id: string;data: BodyType<PatchOrganisationDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof patchPatchOrganisation>>,
        TError,
        {id: string;data: BodyType<PatchOrganisationDTO>},
        TContext
      > => {

      const mutationOptions = getPatchPatchOrganisationMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postFetchAllOrganisations = (
    postFetchAllOrganisationsBody?: MaybeRef<PostFetchAllOrganisationsBody>,
    params?: MaybeRef<PostFetchAllOrganisationsParams>,
 options?: SecondParameter<typeof axios>,) => {
      postFetchAllOrganisationsBody = unref(postFetchAllOrganisationsBody);
params = unref(params);
      
      return axios<FetchAllOrganisations>(
      {url: `/api/organisations`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postFetchAllOrganisationsBody,
        params: unref(params)
    },
      options);
    }
  


export const getPostFetchAllOrganisationsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postFetchAllOrganisations>>, TError,{data: BodyType<PostFetchAllOrganisationsBody>;params?: PostFetchAllOrganisationsParams}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postFetchAllOrganisations>>, TError,{data: BodyType<PostFetchAllOrganisationsBody>;params?: PostFetchAllOrganisationsParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postFetchAllOrganisations>>, {data: BodyType<PostFetchAllOrganisationsBody>;params?: PostFetchAllOrganisationsParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postFetchAllOrganisations(data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostFetchAllOrganisationsMutationResult = NonNullable<Awaited<ReturnType<typeof postFetchAllOrganisations>>>
    export type PostFetchAllOrganisationsMutationBody = BodyType<PostFetchAllOrganisationsBody>
    export type PostFetchAllOrganisationsMutationError = ErrorType<unknown>

    export const usePostFetchAllOrganisations = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postFetchAllOrganisations>>, TError,{data: BodyType<PostFetchAllOrganisationsBody>;params?: PostFetchAllOrganisationsParams}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postFetchAllOrganisations>>,
        TError,
        {data: BodyType<PostFetchAllOrganisationsBody>;params?: PostFetchAllOrganisationsParams},
        TContext
      > => {

      const mutationOptions = getPostFetchAllOrganisationsMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postAddContactPersonToOrganisation = (
    id: MaybeRef<string>,
    addContactPersonToOrganisationDTO: MaybeRef<AddContactPersonToOrganisationDTO>,
 options?: SecondParameter<typeof axios>,) => {
      id = unref(id);
addContactPersonToOrganisationDTO = unref(addContactPersonToOrganisationDTO);
      
      return axios<void>(
      {url: `/api/organisation/${id}/add-contact-person`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: addContactPersonToOrganisationDTO
    },
      options);
    }
  


export const getPostAddContactPersonToOrganisationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAddContactPersonToOrganisation>>, TError,{id: string;data: BodyType<AddContactPersonToOrganisationDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postAddContactPersonToOrganisation>>, TError,{id: string;data: BodyType<AddContactPersonToOrganisationDTO>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAddContactPersonToOrganisation>>, {id: string;data: BodyType<AddContactPersonToOrganisationDTO>}> = (props) => {
          const {id,data} = props ?? {};

          return  postAddContactPersonToOrganisation(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAddContactPersonToOrganisationMutationResult = NonNullable<Awaited<ReturnType<typeof postAddContactPersonToOrganisation>>>
    export type PostAddContactPersonToOrganisationMutationBody = BodyType<AddContactPersonToOrganisationDTO>
    export type PostAddContactPersonToOrganisationMutationError = ErrorType<unknown>

    export const usePostAddContactPersonToOrganisation = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAddContactPersonToOrganisation>>, TError,{id: string;data: BodyType<AddContactPersonToOrganisationDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postAddContactPersonToOrganisation>>,
        TError,
        {id: string;data: BodyType<AddContactPersonToOrganisationDTO>},
        TContext
      > => {

      const mutationOptions = getPostAddContactPersonToOrganisationMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postAddBranchToOrganisation = (
    id: MaybeRef<string>,
    addBranchToOrganisationDTO: MaybeRef<AddBranchToOrganisationDTO>,
 options?: SecondParameter<typeof axios>,) => {
      id = unref(id);
addBranchToOrganisationDTO = unref(addBranchToOrganisationDTO);
      
      return axios<void>(
      {url: `/api/organisation/${id}/add-branch`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: addBranchToOrganisationDTO
    },
      options);
    }
  


export const getPostAddBranchToOrganisationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAddBranchToOrganisation>>, TError,{id: string;data: BodyType<AddBranchToOrganisationDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postAddBranchToOrganisation>>, TError,{id: string;data: BodyType<AddBranchToOrganisationDTO>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAddBranchToOrganisation>>, {id: string;data: BodyType<AddBranchToOrganisationDTO>}> = (props) => {
          const {id,data} = props ?? {};

          return  postAddBranchToOrganisation(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAddBranchToOrganisationMutationResult = NonNullable<Awaited<ReturnType<typeof postAddBranchToOrganisation>>>
    export type PostAddBranchToOrganisationMutationBody = BodyType<AddBranchToOrganisationDTO>
    export type PostAddBranchToOrganisationMutationError = ErrorType<unknown>

    export const usePostAddBranchToOrganisation = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAddBranchToOrganisation>>, TError,{id: string;data: BodyType<AddBranchToOrganisationDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postAddBranchToOrganisation>>,
        TError,
        {id: string;data: BodyType<AddBranchToOrganisationDTO>},
        TContext
      > => {

      const mutationOptions = getPostAddBranchToOrganisationMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postCreateOrganisation = (
    createOrganisationDTO: MaybeRef<CreateOrganisationDTO>,
 options?: SecondParameter<typeof axios>,) => {
      createOrganisationDTO = unref(createOrganisationDTO);
      
      return axios<CreateResponse>(
      {url: `/api/organisation`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createOrganisationDTO
    },
      options);
    }
  


export const getPostCreateOrganisationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCreateOrganisation>>, TError,{data: BodyType<CreateOrganisationDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postCreateOrganisation>>, TError,{data: BodyType<CreateOrganisationDTO>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCreateOrganisation>>, {data: BodyType<CreateOrganisationDTO>}> = (props) => {
          const {data} = props ?? {};

          return  postCreateOrganisation(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostCreateOrganisationMutationResult = NonNullable<Awaited<ReturnType<typeof postCreateOrganisation>>>
    export type PostCreateOrganisationMutationBody = BodyType<CreateOrganisationDTO>
    export type PostCreateOrganisationMutationError = ErrorType<unknown>

    export const usePostCreateOrganisation = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCreateOrganisation>>, TError,{data: BodyType<CreateOrganisationDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postCreateOrganisation>>,
        TError,
        {data: BodyType<CreateOrganisationDTO>},
        TContext
      > => {

      const mutationOptions = getPostCreateOrganisationMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getFetchOrganisationContactPerson = (
    id: MaybeRef<string>,
 options?: SecondParameter<typeof axios>,signal?: AbortSignal
) => {
      id = unref(id);
      
      return axios<FetchOrganisationContactPersonResponse>(
      {url: `/api/organisation-contact-person/${id}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetFetchOrganisationContactPersonQueryKey = (id: MaybeRef<string>,) => {
    return ['api','organisation-contact-person',id] as const;
    }

    
export const getGetFetchOrganisationContactPersonQueryOptions = <TData = Awaited<ReturnType<typeof getFetchOrganisationContactPerson>>, TError = ErrorType<unknown>>(id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFetchOrganisationContactPerson>>, TError, TData>>, request?: SecondParameter<typeof axios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getGetFetchOrganisationContactPersonQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFetchOrganisationContactPerson>>> = ({ signal }) => getFetchOrganisationContactPerson(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: computed(() => !!(unref(id))), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFetchOrganisationContactPerson>>, TError, TData> 
}

export type GetFetchOrganisationContactPersonQueryResult = NonNullable<Awaited<ReturnType<typeof getFetchOrganisationContactPerson>>>
export type GetFetchOrganisationContactPersonQueryError = ErrorType<unknown>

export const useGetFetchOrganisationContactPerson = <TData = Awaited<ReturnType<typeof getFetchOrganisationContactPerson>>, TError = ErrorType<unknown>>(
 id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFetchOrganisationContactPerson>>, TError, TData>>, request?: SecondParameter<typeof axios>}

  ): UseQueryReturnType<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetFetchOrganisationContactPersonQueryOptions(id,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: QueryKey };

  query.queryKey = unref(queryOptions).queryKey as QueryKey;

  return query;
}




export const postFetchAllOrganisationContactPersons = (
    contactPersonFilterDTO: MaybeRef<ContactPersonFilterDTO>,
    params?: MaybeRef<PostFetchAllOrganisationContactPersonsParams>,
 options?: SecondParameter<typeof axios>,) => {
      contactPersonFilterDTO = unref(contactPersonFilterDTO);
params = unref(params);
      
      return axios<FetchAllOrganisationContactPersonsResponse>(
      {url: `/api/organisation-contact-persons`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: contactPersonFilterDTO,
        params: unref(params)
    },
      options);
    }
  


export const getPostFetchAllOrganisationContactPersonsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postFetchAllOrganisationContactPersons>>, TError,{data: BodyType<ContactPersonFilterDTO>;params?: PostFetchAllOrganisationContactPersonsParams}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postFetchAllOrganisationContactPersons>>, TError,{data: BodyType<ContactPersonFilterDTO>;params?: PostFetchAllOrganisationContactPersonsParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postFetchAllOrganisationContactPersons>>, {data: BodyType<ContactPersonFilterDTO>;params?: PostFetchAllOrganisationContactPersonsParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postFetchAllOrganisationContactPersons(data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostFetchAllOrganisationContactPersonsMutationResult = NonNullable<Awaited<ReturnType<typeof postFetchAllOrganisationContactPersons>>>
    export type PostFetchAllOrganisationContactPersonsMutationBody = BodyType<ContactPersonFilterDTO>
    export type PostFetchAllOrganisationContactPersonsMutationError = ErrorType<unknown>

    export const usePostFetchAllOrganisationContactPersons = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postFetchAllOrganisationContactPersons>>, TError,{data: BodyType<ContactPersonFilterDTO>;params?: PostFetchAllOrganisationContactPersonsParams}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postFetchAllOrganisationContactPersons>>,
        TError,
        {data: BodyType<ContactPersonFilterDTO>;params?: PostFetchAllOrganisationContactPersonsParams},
        TContext
      > => {

      const mutationOptions = getPostFetchAllOrganisationContactPersonsMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postCreateOrganisationContactPerson = (
    createOrganisationContactPersonDTO: MaybeRef<CreateOrganisationContactPersonDTO>,
 options?: SecondParameter<typeof axios>,) => {
      createOrganisationContactPersonDTO = unref(createOrganisationContactPersonDTO);
      
      return axios<CreateResponse>(
      {url: `/api/organisation-contact-person`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createOrganisationContactPersonDTO
    },
      options);
    }
  


export const getPostCreateOrganisationContactPersonMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCreateOrganisationContactPerson>>, TError,{data: BodyType<CreateOrganisationContactPersonDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postCreateOrganisationContactPerson>>, TError,{data: BodyType<CreateOrganisationContactPersonDTO>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCreateOrganisationContactPerson>>, {data: BodyType<CreateOrganisationContactPersonDTO>}> = (props) => {
          const {data} = props ?? {};

          return  postCreateOrganisationContactPerson(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostCreateOrganisationContactPersonMutationResult = NonNullable<Awaited<ReturnType<typeof postCreateOrganisationContactPerson>>>
    export type PostCreateOrganisationContactPersonMutationBody = BodyType<CreateOrganisationContactPersonDTO>
    export type PostCreateOrganisationContactPersonMutationError = ErrorType<unknown>

    export const usePostCreateOrganisationContactPerson = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCreateOrganisationContactPerson>>, TError,{data: BodyType<CreateOrganisationContactPersonDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postCreateOrganisationContactPerson>>,
        TError,
        {data: BodyType<CreateOrganisationContactPersonDTO>},
        TContext
      > => {

      const mutationOptions = getPostCreateOrganisationContactPersonMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postCreateContactDetail = (
    createContactDetailDTO: MaybeRef<CreateContactDetailDTO>,
 options?: SecondParameter<typeof axios>,) => {
      createContactDetailDTO = unref(createContactDetailDTO);
      
      return axios<CreateResponse>(
      {url: `/api/contact-detail`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createContactDetailDTO
    },
      options);
    }
  


export const getPostCreateContactDetailMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCreateContactDetail>>, TError,{data: BodyType<CreateContactDetailDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postCreateContactDetail>>, TError,{data: BodyType<CreateContactDetailDTO>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCreateContactDetail>>, {data: BodyType<CreateContactDetailDTO>}> = (props) => {
          const {data} = props ?? {};

          return  postCreateContactDetail(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostCreateContactDetailMutationResult = NonNullable<Awaited<ReturnType<typeof postCreateContactDetail>>>
    export type PostCreateContactDetailMutationBody = BodyType<CreateContactDetailDTO>
    export type PostCreateContactDetailMutationError = ErrorType<unknown>

    export const usePostCreateContactDetail = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCreateContactDetail>>, TError,{data: BodyType<CreateContactDetailDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postCreateContactDetail>>,
        TError,
        {data: BodyType<CreateContactDetailDTO>},
        TContext
      > => {

      const mutationOptions = getPostCreateContactDetailMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postGetAllOrganisationContactPersons = (
    id: MaybeRef<string>,
 options?: SecondParameter<typeof axios>,) => {
      id = unref(id);
      
      return axios<FetchAllContactPersonsByOrganisationId[]>(
      {url: `/api/organisation/${id}/contact-persons`, method: 'POST'
    },
      options);
    }
  


export const getPostGetAllOrganisationContactPersonsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postGetAllOrganisationContactPersons>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postGetAllOrganisationContactPersons>>, TError,{id: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postGetAllOrganisationContactPersons>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  postGetAllOrganisationContactPersons(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostGetAllOrganisationContactPersonsMutationResult = NonNullable<Awaited<ReturnType<typeof postGetAllOrganisationContactPersons>>>
    
    export type PostGetAllOrganisationContactPersonsMutationError = ErrorType<unknown>

    export const usePostGetAllOrganisationContactPersons = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postGetAllOrganisationContactPersons>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postGetAllOrganisationContactPersons>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getPostGetAllOrganisationContactPersonsMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postFetchAllOrganisationBranches = (
    id: MaybeRef<string>,
 options?: SecondParameter<typeof axios>,) => {
      id = unref(id);
      
      return axios<FetchAllOrganisationBranchesResponse>(
      {url: `/api/organisation/${id}/branches`, method: 'POST'
    },
      options);
    }
  


export const getPostFetchAllOrganisationBranchesMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postFetchAllOrganisationBranches>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postFetchAllOrganisationBranches>>, TError,{id: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postFetchAllOrganisationBranches>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  postFetchAllOrganisationBranches(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostFetchAllOrganisationBranchesMutationResult = NonNullable<Awaited<ReturnType<typeof postFetchAllOrganisationBranches>>>
    
    export type PostFetchAllOrganisationBranchesMutationError = ErrorType<unknown>

    export const usePostFetchAllOrganisationBranches = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postFetchAllOrganisationBranches>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postFetchAllOrganisationBranches>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getPostFetchAllOrganisationBranchesMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getFetchOrganisationFile = (
    fileId: MaybeRef<string>,
 options?: SecondParameter<typeof axios>,signal?: AbortSignal
) => {
      fileId = unref(fileId);
      
      return axios<void>(
      {url: `/api/organisation/file/${fileId}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetFetchOrganisationFileQueryKey = (fileId: MaybeRef<string>,) => {
    return ['api','organisation','file',fileId] as const;
    }

    
export const getGetFetchOrganisationFileQueryOptions = <TData = Awaited<ReturnType<typeof getFetchOrganisationFile>>, TError = ErrorType<unknown>>(fileId: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFetchOrganisationFile>>, TError, TData>>, request?: SecondParameter<typeof axios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getGetFetchOrganisationFileQueryKey(fileId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFetchOrganisationFile>>> = ({ signal }) => getFetchOrganisationFile(fileId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: computed(() => !!(unref(fileId))), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFetchOrganisationFile>>, TError, TData> 
}

export type GetFetchOrganisationFileQueryResult = NonNullable<Awaited<ReturnType<typeof getFetchOrganisationFile>>>
export type GetFetchOrganisationFileQueryError = ErrorType<unknown>

export const useGetFetchOrganisationFile = <TData = Awaited<ReturnType<typeof getFetchOrganisationFile>>, TError = ErrorType<unknown>>(
 fileId: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFetchOrganisationFile>>, TError, TData>>, request?: SecondParameter<typeof axios>}

  ): UseQueryReturnType<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetFetchOrganisationFileQueryOptions(fileId,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: QueryKey };

  query.queryKey = unref(queryOptions).queryKey as QueryKey;

  return query;
}




/**
 * Fetch file in base64 format
 * @summary Get file as base64 by ID
 */
export const getFetchOrganisationFileBase64 = (
    fileId: MaybeRef<string>,
 options?: SecondParameter<typeof axios>,signal?: AbortSignal
) => {
      fileId = unref(fileId);
      
      return axios<void>(
      {url: `/api/organisation/file/${fileId}/base64`, method: 'GET', signal
    },
      options);
    }
  

export const getGetFetchOrganisationFileBase64QueryKey = (fileId: MaybeRef<string>,) => {
    return ['api','organisation','file',fileId,'base64'] as const;
    }

    
export const getGetFetchOrganisationFileBase64QueryOptions = <TData = Awaited<ReturnType<typeof getFetchOrganisationFileBase64>>, TError = ErrorType<unknown>>(fileId: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFetchOrganisationFileBase64>>, TError, TData>>, request?: SecondParameter<typeof axios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getGetFetchOrganisationFileBase64QueryKey(fileId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFetchOrganisationFileBase64>>> = ({ signal }) => getFetchOrganisationFileBase64(fileId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: computed(() => !!(unref(fileId))), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFetchOrganisationFileBase64>>, TError, TData> 
}

export type GetFetchOrganisationFileBase64QueryResult = NonNullable<Awaited<ReturnType<typeof getFetchOrganisationFileBase64>>>
export type GetFetchOrganisationFileBase64QueryError = ErrorType<unknown>

/**
 * @summary Get file as base64 by ID
 */
export const useGetFetchOrganisationFileBase64 = <TData = Awaited<ReturnType<typeof getFetchOrganisationFileBase64>>, TError = ErrorType<unknown>>(
 fileId: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFetchOrganisationFileBase64>>, TError, TData>>, request?: SecondParameter<typeof axios>}

  ): UseQueryReturnType<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetFetchOrganisationFileBase64QueryOptions(fileId,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: QueryKey };

  query.queryKey = unref(queryOptions).queryKey as QueryKey;

  return query;
}




export const postAddFileToOrganisation = (
    id: MaybeRef<string>,
    saveOrganisationFileDTO: MaybeRef<SaveOrganisationFileDTO>,
 options?: SecondParameter<typeof axios>,) => {
      id = unref(id);
saveOrganisationFileDTO = unref(saveOrganisationFileDTO);
      
      return axios<void>(
      {url: `/api/organisation/${id}/save-file`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: saveOrganisationFileDTO
    },
      options);
    }
  


export const getPostAddFileToOrganisationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAddFileToOrganisation>>, TError,{id: string;data: BodyType<SaveOrganisationFileDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postAddFileToOrganisation>>, TError,{id: string;data: BodyType<SaveOrganisationFileDTO>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAddFileToOrganisation>>, {id: string;data: BodyType<SaveOrganisationFileDTO>}> = (props) => {
          const {id,data} = props ?? {};

          return  postAddFileToOrganisation(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAddFileToOrganisationMutationResult = NonNullable<Awaited<ReturnType<typeof postAddFileToOrganisation>>>
    export type PostAddFileToOrganisationMutationBody = BodyType<SaveOrganisationFileDTO>
    export type PostAddFileToOrganisationMutationError = ErrorType<unknown>

    export const usePostAddFileToOrganisation = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAddFileToOrganisation>>, TError,{id: string;data: BodyType<SaveOrganisationFileDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postAddFileToOrganisation>>,
        TError,
        {id: string;data: BodyType<SaveOrganisationFileDTO>},
        TContext
      > => {

      const mutationOptions = getPostAddFileToOrganisationMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postSyncOrganisations = (
    
 options?: SecondParameter<typeof axios>,) => {
      
      
      return axios<void>(
      {url: `/api/organisations/sync`, method: 'POST'
    },
      options);
    }
  


export const getPostSyncOrganisationsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postSyncOrganisations>>, TError,void, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postSyncOrganisations>>, TError,void, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postSyncOrganisations>>, void> = () => {
          

          return  postSyncOrganisations(requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostSyncOrganisationsMutationResult = NonNullable<Awaited<ReturnType<typeof postSyncOrganisations>>>
    
    export type PostSyncOrganisationsMutationError = ErrorType<unknown>

    export const usePostSyncOrganisations = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postSyncOrganisations>>, TError,void, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postSyncOrganisations>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getPostSyncOrganisationsMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getFetchActionLabour = (
    id: MaybeRef<string>,
 options?: SecondParameter<typeof axios>,signal?: AbortSignal
) => {
      id = unref(id);
      
      return axios<FetchActionLabourResponse>(
      {url: `/api/action-labour/${id}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetFetchActionLabourQueryKey = (id: MaybeRef<string>,) => {
    return ['api','action-labour',id] as const;
    }

    
export const getGetFetchActionLabourQueryOptions = <TData = Awaited<ReturnType<typeof getFetchActionLabour>>, TError = ErrorType<unknown>>(id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFetchActionLabour>>, TError, TData>>, request?: SecondParameter<typeof axios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getGetFetchActionLabourQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFetchActionLabour>>> = ({ signal }) => getFetchActionLabour(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: computed(() => !!(unref(id))), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFetchActionLabour>>, TError, TData> 
}

export type GetFetchActionLabourQueryResult = NonNullable<Awaited<ReturnType<typeof getFetchActionLabour>>>
export type GetFetchActionLabourQueryError = ErrorType<unknown>

export const useGetFetchActionLabour = <TData = Awaited<ReturnType<typeof getFetchActionLabour>>, TError = ErrorType<unknown>>(
 id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFetchActionLabour>>, TError, TData>>, request?: SecondParameter<typeof axios>}

  ): UseQueryReturnType<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetFetchActionLabourQueryOptions(id,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: QueryKey };

  query.queryKey = unref(queryOptions).queryKey as QueryKey;

  return query;
}




export const patchPatchActionLabour = (
    id: MaybeRef<string>,
    patchActionLabourDTO: MaybeRef<PatchActionLabourDTO>,
 options?: SecondParameter<typeof axios>,) => {
      id = unref(id);
patchActionLabourDTO = unref(patchActionLabourDTO);
      
      return axios<void>(
      {url: `/api/action-labour/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchActionLabourDTO
    },
      options);
    }
  


export const getPatchPatchActionLabourMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchPatchActionLabour>>, TError,{id: string;data: BodyType<PatchActionLabourDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof patchPatchActionLabour>>, TError,{id: string;data: BodyType<PatchActionLabourDTO>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchPatchActionLabour>>, {id: string;data: BodyType<PatchActionLabourDTO>}> = (props) => {
          const {id,data} = props ?? {};

          return  patchPatchActionLabour(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchPatchActionLabourMutationResult = NonNullable<Awaited<ReturnType<typeof patchPatchActionLabour>>>
    export type PatchPatchActionLabourMutationBody = BodyType<PatchActionLabourDTO>
    export type PatchPatchActionLabourMutationError = ErrorType<unknown>

    export const usePatchPatchActionLabour = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchPatchActionLabour>>, TError,{id: string;data: BodyType<PatchActionLabourDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof patchPatchActionLabour>>,
        TError,
        {id: string;data: BodyType<PatchActionLabourDTO>},
        TContext
      > => {

      const mutationOptions = getPatchPatchActionLabourMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postFetchAllActionLabour = (
    params?: MaybeRef<PostFetchAllActionLabourParams>,
 options?: SecondParameter<typeof axios>,) => {
      params = unref(params);
      
      return axios<FetchAllActionLabours>(
      {url: `/api/action-labours`, method: 'POST',
        params: unref(params)
    },
      options);
    }
  


export const getPostFetchAllActionLabourMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postFetchAllActionLabour>>, TError,{params?: PostFetchAllActionLabourParams}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postFetchAllActionLabour>>, TError,{params?: PostFetchAllActionLabourParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postFetchAllActionLabour>>, {params?: PostFetchAllActionLabourParams}> = (props) => {
          const {params} = props ?? {};

          return  postFetchAllActionLabour(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostFetchAllActionLabourMutationResult = NonNullable<Awaited<ReturnType<typeof postFetchAllActionLabour>>>
    
    export type PostFetchAllActionLabourMutationError = ErrorType<unknown>

    export const usePostFetchAllActionLabour = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postFetchAllActionLabour>>, TError,{params?: PostFetchAllActionLabourParams}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postFetchAllActionLabour>>,
        TError,
        {params?: PostFetchAllActionLabourParams},
        TContext
      > => {

      const mutationOptions = getPostFetchAllActionLabourMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postCreateActionLabour = (
    createActionLabourDTO: MaybeRef<CreateActionLabourDTO>,
 options?: SecondParameter<typeof axios>,) => {
      createActionLabourDTO = unref(createActionLabourDTO);
      
      return axios<CreateResponse>(
      {url: `/api/action-labour`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createActionLabourDTO
    },
      options);
    }
  


export const getPostCreateActionLabourMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCreateActionLabour>>, TError,{data: BodyType<CreateActionLabourDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postCreateActionLabour>>, TError,{data: BodyType<CreateActionLabourDTO>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCreateActionLabour>>, {data: BodyType<CreateActionLabourDTO>}> = (props) => {
          const {data} = props ?? {};

          return  postCreateActionLabour(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostCreateActionLabourMutationResult = NonNullable<Awaited<ReturnType<typeof postCreateActionLabour>>>
    export type PostCreateActionLabourMutationBody = BodyType<CreateActionLabourDTO>
    export type PostCreateActionLabourMutationError = ErrorType<unknown>

    export const usePostCreateActionLabour = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCreateActionLabour>>, TError,{data: BodyType<CreateActionLabourDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postCreateActionLabour>>,
        TError,
        {data: BodyType<CreateActionLabourDTO>},
        TContext
      > => {

      const mutationOptions = getPostCreateActionLabourMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postUpdateActionLabourTotalHours = (
    id: MaybeRef<string>,
    updateActionLabourTotalHours: MaybeRef<UpdateActionLabourTotalHours>,
 options?: SecondParameter<typeof axios>,) => {
      id = unref(id);
updateActionLabourTotalHours = unref(updateActionLabourTotalHours);
      
      return axios<void>(
      {url: `/api/action-labour/${id}/total-hours`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: updateActionLabourTotalHours
    },
      options);
    }
  


export const getPostUpdateActionLabourTotalHoursMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUpdateActionLabourTotalHours>>, TError,{id: string;data: BodyType<UpdateActionLabourTotalHours>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postUpdateActionLabourTotalHours>>, TError,{id: string;data: BodyType<UpdateActionLabourTotalHours>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postUpdateActionLabourTotalHours>>, {id: string;data: BodyType<UpdateActionLabourTotalHours>}> = (props) => {
          const {id,data} = props ?? {};

          return  postUpdateActionLabourTotalHours(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostUpdateActionLabourTotalHoursMutationResult = NonNullable<Awaited<ReturnType<typeof postUpdateActionLabourTotalHours>>>
    export type PostUpdateActionLabourTotalHoursMutationBody = BodyType<UpdateActionLabourTotalHours>
    export type PostUpdateActionLabourTotalHoursMutationError = ErrorType<unknown>

    export const usePostUpdateActionLabourTotalHours = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUpdateActionLabourTotalHours>>, TError,{id: string;data: BodyType<UpdateActionLabourTotalHours>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postUpdateActionLabourTotalHours>>,
        TError,
        {id: string;data: BodyType<UpdateActionLabourTotalHours>},
        TContext
      > => {

      const mutationOptions = getPostUpdateActionLabourTotalHoursMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getFetchAssignee = (
    id: MaybeRef<string>,
 options?: SecondParameter<typeof axios>,signal?: AbortSignal
) => {
      id = unref(id);
      
      return axios<FetchAssigneeResponse>(
      {url: `/api/assignee/${id}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetFetchAssigneeQueryKey = (id: MaybeRef<string>,) => {
    return ['api','assignee',id] as const;
    }

    
export const getGetFetchAssigneeQueryOptions = <TData = Awaited<ReturnType<typeof getFetchAssignee>>, TError = ErrorType<unknown>>(id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFetchAssignee>>, TError, TData>>, request?: SecondParameter<typeof axios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getGetFetchAssigneeQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFetchAssignee>>> = ({ signal }) => getFetchAssignee(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: computed(() => !!(unref(id))), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFetchAssignee>>, TError, TData> 
}

export type GetFetchAssigneeQueryResult = NonNullable<Awaited<ReturnType<typeof getFetchAssignee>>>
export type GetFetchAssigneeQueryError = ErrorType<unknown>

export const useGetFetchAssignee = <TData = Awaited<ReturnType<typeof getFetchAssignee>>, TError = ErrorType<unknown>>(
 id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFetchAssignee>>, TError, TData>>, request?: SecondParameter<typeof axios>}

  ): UseQueryReturnType<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetFetchAssigneeQueryOptions(id,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: QueryKey };

  query.queryKey = unref(queryOptions).queryKey as QueryKey;

  return query;
}




export const putUpdateAssignee = (
    id: MaybeRef<string>,
    updateAssigneeDTO: MaybeRef<UpdateAssigneeDTO>,
 options?: SecondParameter<typeof axios>,) => {
      id = unref(id);
updateAssigneeDTO = unref(updateAssigneeDTO);
      
      return axios<void>(
      {url: `/api/assignee/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateAssigneeDTO
    },
      options);
    }
  


export const getPutUpdateAssigneeMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putUpdateAssignee>>, TError,{id: string;data: BodyType<UpdateAssigneeDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof putUpdateAssignee>>, TError,{id: string;data: BodyType<UpdateAssigneeDTO>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putUpdateAssignee>>, {id: string;data: BodyType<UpdateAssigneeDTO>}> = (props) => {
          const {id,data} = props ?? {};

          return  putUpdateAssignee(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutUpdateAssigneeMutationResult = NonNullable<Awaited<ReturnType<typeof putUpdateAssignee>>>
    export type PutUpdateAssigneeMutationBody = BodyType<UpdateAssigneeDTO>
    export type PutUpdateAssigneeMutationError = ErrorType<unknown>

    export const usePutUpdateAssignee = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putUpdateAssignee>>, TError,{id: string;data: BodyType<UpdateAssigneeDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof putUpdateAssignee>>,
        TError,
        {id: string;data: BodyType<UpdateAssigneeDTO>},
        TContext
      > => {

      const mutationOptions = getPutUpdateAssigneeMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postFetchAllAssignees = (
    assigneeFiltersDTO: MaybeRef<AssigneeFiltersDTO>,
    params?: MaybeRef<PostFetchAllAssigneesParams>,
 options?: SecondParameter<typeof axios>,) => {
      assigneeFiltersDTO = unref(assigneeFiltersDTO);
params = unref(params);
      
      return axios<FetchAllAssignees>(
      {url: `/api/assignees`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: assigneeFiltersDTO,
        params: unref(params)
    },
      options);
    }
  


export const getPostFetchAllAssigneesMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postFetchAllAssignees>>, TError,{data: BodyType<AssigneeFiltersDTO>;params?: PostFetchAllAssigneesParams}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postFetchAllAssignees>>, TError,{data: BodyType<AssigneeFiltersDTO>;params?: PostFetchAllAssigneesParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postFetchAllAssignees>>, {data: BodyType<AssigneeFiltersDTO>;params?: PostFetchAllAssigneesParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postFetchAllAssignees(data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostFetchAllAssigneesMutationResult = NonNullable<Awaited<ReturnType<typeof postFetchAllAssignees>>>
    export type PostFetchAllAssigneesMutationBody = BodyType<AssigneeFiltersDTO>
    export type PostFetchAllAssigneesMutationError = ErrorType<unknown>

    export const usePostFetchAllAssignees = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postFetchAllAssignees>>, TError,{data: BodyType<AssigneeFiltersDTO>;params?: PostFetchAllAssigneesParams}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postFetchAllAssignees>>,
        TError,
        {data: BodyType<AssigneeFiltersDTO>;params?: PostFetchAllAssigneesParams},
        TContext
      > => {

      const mutationOptions = getPostFetchAllAssigneesMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postCreateAssignee = (
    createAssigneeDTO: MaybeRef<CreateAssigneeDTO>,
 options?: SecondParameter<typeof axios>,) => {
      createAssigneeDTO = unref(createAssigneeDTO);
      
      return axios<CreateResponse>(
      {url: `/api/assignee`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createAssigneeDTO
    },
      options);
    }
  


export const getPostCreateAssigneeMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCreateAssignee>>, TError,{data: BodyType<CreateAssigneeDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postCreateAssignee>>, TError,{data: BodyType<CreateAssigneeDTO>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCreateAssignee>>, {data: BodyType<CreateAssigneeDTO>}> = (props) => {
          const {data} = props ?? {};

          return  postCreateAssignee(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostCreateAssigneeMutationResult = NonNullable<Awaited<ReturnType<typeof postCreateAssignee>>>
    export type PostCreateAssigneeMutationBody = BodyType<CreateAssigneeDTO>
    export type PostCreateAssigneeMutationError = ErrorType<unknown>

    export const usePostCreateAssignee = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCreateAssignee>>, TError,{data: BodyType<CreateAssigneeDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postCreateAssignee>>,
        TError,
        {data: BodyType<CreateAssigneeDTO>},
        TContext
      > => {

      const mutationOptions = getPostCreateAssigneeMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getFetchAssignment = (
    id: MaybeRef<string>,
 options?: SecondParameter<typeof axios>,signal?: AbortSignal
) => {
      id = unref(id);
      
      return axios<FetchAssignmentResponse>(
      {url: `/api/assignment/${id}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetFetchAssignmentQueryKey = (id: MaybeRef<string>,) => {
    return ['api','assignment',id] as const;
    }

    
export const getGetFetchAssignmentQueryOptions = <TData = Awaited<ReturnType<typeof getFetchAssignment>>, TError = ErrorType<unknown>>(id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFetchAssignment>>, TError, TData>>, request?: SecondParameter<typeof axios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getGetFetchAssignmentQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFetchAssignment>>> = ({ signal }) => getFetchAssignment(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: computed(() => !!(unref(id))), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFetchAssignment>>, TError, TData> 
}

export type GetFetchAssignmentQueryResult = NonNullable<Awaited<ReturnType<typeof getFetchAssignment>>>
export type GetFetchAssignmentQueryError = ErrorType<unknown>

export const useGetFetchAssignment = <TData = Awaited<ReturnType<typeof getFetchAssignment>>, TError = ErrorType<unknown>>(
 id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFetchAssignment>>, TError, TData>>, request?: SecondParameter<typeof axios>}

  ): UseQueryReturnType<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetFetchAssignmentQueryOptions(id,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: QueryKey };

  query.queryKey = unref(queryOptions).queryKey as QueryKey;

  return query;
}




export const deleteRemoveAssignment = (
    id: MaybeRef<string>,
 options?: SecondParameter<typeof axios>,) => {
      id = unref(id);
      
      return axios<void>(
      {url: `/api/assignment/${id}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteRemoveAssignmentMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteRemoveAssignment>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteRemoveAssignment>>, TError,{id: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteRemoveAssignment>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteRemoveAssignment(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteRemoveAssignmentMutationResult = NonNullable<Awaited<ReturnType<typeof deleteRemoveAssignment>>>
    
    export type DeleteRemoveAssignmentMutationError = ErrorType<void>

    export const useDeleteRemoveAssignment = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteRemoveAssignment>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof deleteRemoveAssignment>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteRemoveAssignmentMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postFetchAllAssignments = (
    fetchAllAssignmentsDTO: MaybeRef<FetchAllAssignmentsDTO>,
    params?: MaybeRef<PostFetchAllAssignmentsParams>,
 options?: SecondParameter<typeof axios>,) => {
      fetchAllAssignmentsDTO = unref(fetchAllAssignmentsDTO);
params = unref(params);
      
      return axios<FetchAllAssignments[]>(
      {url: `/api/assignments`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: fetchAllAssignmentsDTO,
        params: unref(params)
    },
      options);
    }
  


export const getPostFetchAllAssignmentsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postFetchAllAssignments>>, TError,{data: BodyType<FetchAllAssignmentsDTO>;params?: PostFetchAllAssignmentsParams}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postFetchAllAssignments>>, TError,{data: BodyType<FetchAllAssignmentsDTO>;params?: PostFetchAllAssignmentsParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postFetchAllAssignments>>, {data: BodyType<FetchAllAssignmentsDTO>;params?: PostFetchAllAssignmentsParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postFetchAllAssignments(data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostFetchAllAssignmentsMutationResult = NonNullable<Awaited<ReturnType<typeof postFetchAllAssignments>>>
    export type PostFetchAllAssignmentsMutationBody = BodyType<FetchAllAssignmentsDTO>
    export type PostFetchAllAssignmentsMutationError = ErrorType<unknown>

    export const usePostFetchAllAssignments = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postFetchAllAssignments>>, TError,{data: BodyType<FetchAllAssignmentsDTO>;params?: PostFetchAllAssignmentsParams}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postFetchAllAssignments>>,
        TError,
        {data: BodyType<FetchAllAssignmentsDTO>;params?: PostFetchAllAssignmentsParams},
        TContext
      > => {

      const mutationOptions = getPostFetchAllAssignmentsMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postCreateAssignment = (
    createAssignmentDTO: MaybeRef<CreateAssignmentDTO>,
 options?: SecondParameter<typeof axios>,) => {
      createAssignmentDTO = unref(createAssignmentDTO);
      
      return axios<CreateResponse>(
      {url: `/api/assignment`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createAssignmentDTO
    },
      options);
    }
  


export const getPostCreateAssignmentMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCreateAssignment>>, TError,{data: BodyType<CreateAssignmentDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postCreateAssignment>>, TError,{data: BodyType<CreateAssignmentDTO>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCreateAssignment>>, {data: BodyType<CreateAssignmentDTO>}> = (props) => {
          const {data} = props ?? {};

          return  postCreateAssignment(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostCreateAssignmentMutationResult = NonNullable<Awaited<ReturnType<typeof postCreateAssignment>>>
    export type PostCreateAssignmentMutationBody = BodyType<CreateAssignmentDTO>
    export type PostCreateAssignmentMutationError = ErrorType<unknown>

    export const usePostCreateAssignment = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCreateAssignment>>, TError,{data: BodyType<CreateAssignmentDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postCreateAssignment>>,
        TError,
        {data: BodyType<CreateAssignmentDTO>},
        TContext
      > => {

      const mutationOptions = getPostCreateAssignmentMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * This endpoint sets the status of a assignment to closed
 * @summary Close an assignment
 */
export const postCloseAssignment = (
    id: MaybeRef<string>,
 options?: SecondParameter<typeof axios>,) => {
      id = unref(id);
      
      return axios<void>(
      {url: `/api/assignment/${id}/close`, method: 'POST'
    },
      options);
    }
  


export const getPostCloseAssignmentMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCloseAssignment>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postCloseAssignment>>, TError,{id: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCloseAssignment>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  postCloseAssignment(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostCloseAssignmentMutationResult = NonNullable<Awaited<ReturnType<typeof postCloseAssignment>>>
    
    export type PostCloseAssignmentMutationError = ErrorType<unknown>

    /**
 * @summary Close an assignment
 */
export const usePostCloseAssignment = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCloseAssignment>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postCloseAssignment>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getPostCloseAssignmentMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * This endpoint sets the status of a assignment to opened
 * @summary Open an assignment
 */
export const postOpenAssignment = (
    id: MaybeRef<string>,
 options?: SecondParameter<typeof axios>,) => {
      id = unref(id);
      
      return axios<void>(
      {url: `/api/assignment/${id}/open`, method: 'POST'
    },
      options);
    }
  


export const getPostOpenAssignmentMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postOpenAssignment>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postOpenAssignment>>, TError,{id: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postOpenAssignment>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  postOpenAssignment(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostOpenAssignmentMutationResult = NonNullable<Awaited<ReturnType<typeof postOpenAssignment>>>
    
    export type PostOpenAssignmentMutationError = ErrorType<unknown>

    /**
 * @summary Open an assignment
 */
export const usePostOpenAssignment = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postOpenAssignment>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postOpenAssignment>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getPostOpenAssignmentMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postAddAssigneeToAssignment = (
    id: MaybeRef<string>,
    addAssigneeToAssignmentDTO: MaybeRef<AddAssigneeToAssignmentDTO>,
 options?: SecondParameter<typeof axios>,) => {
      id = unref(id);
addAssigneeToAssignmentDTO = unref(addAssigneeToAssignmentDTO);
      
      return axios<void>(
      {url: `/api/assignment/${id}/add-assignee`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: addAssigneeToAssignmentDTO
    },
      options);
    }
  


export const getPostAddAssigneeToAssignmentMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAddAssigneeToAssignment>>, TError,{id: string;data: BodyType<AddAssigneeToAssignmentDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postAddAssigneeToAssignment>>, TError,{id: string;data: BodyType<AddAssigneeToAssignmentDTO>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAddAssigneeToAssignment>>, {id: string;data: BodyType<AddAssigneeToAssignmentDTO>}> = (props) => {
          const {id,data} = props ?? {};

          return  postAddAssigneeToAssignment(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAddAssigneeToAssignmentMutationResult = NonNullable<Awaited<ReturnType<typeof postAddAssigneeToAssignment>>>
    export type PostAddAssigneeToAssignmentMutationBody = BodyType<AddAssigneeToAssignmentDTO>
    export type PostAddAssigneeToAssignmentMutationError = ErrorType<unknown>

    export const usePostAddAssigneeToAssignment = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAddAssigneeToAssignment>>, TError,{id: string;data: BodyType<AddAssigneeToAssignmentDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postAddAssigneeToAssignment>>,
        TError,
        {id: string;data: BodyType<AddAssigneeToAssignmentDTO>},
        TContext
      > => {

      const mutationOptions = getPostAddAssigneeToAssignmentMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postAddActionLabourToAssignment = (
    id: MaybeRef<string>,
    addActionLabourToAssignmentDTO: MaybeRef<AddActionLabourToAssignmentDTO>,
 options?: SecondParameter<typeof axios>,) => {
      id = unref(id);
addActionLabourToAssignmentDTO = unref(addActionLabourToAssignmentDTO);
      
      return axios<void>(
      {url: `/api/assignment/${id}/add-action-labour`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: addActionLabourToAssignmentDTO
    },
      options);
    }
  


export const getPostAddActionLabourToAssignmentMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAddActionLabourToAssignment>>, TError,{id: string;data: BodyType<AddActionLabourToAssignmentDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postAddActionLabourToAssignment>>, TError,{id: string;data: BodyType<AddActionLabourToAssignmentDTO>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAddActionLabourToAssignment>>, {id: string;data: BodyType<AddActionLabourToAssignmentDTO>}> = (props) => {
          const {id,data} = props ?? {};

          return  postAddActionLabourToAssignment(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAddActionLabourToAssignmentMutationResult = NonNullable<Awaited<ReturnType<typeof postAddActionLabourToAssignment>>>
    export type PostAddActionLabourToAssignmentMutationBody = BodyType<AddActionLabourToAssignmentDTO>
    export type PostAddActionLabourToAssignmentMutationError = ErrorType<unknown>

    export const usePostAddActionLabourToAssignment = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAddActionLabourToAssignment>>, TError,{id: string;data: BodyType<AddActionLabourToAssignmentDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postAddActionLabourToAssignment>>,
        TError,
        {id: string;data: BodyType<AddActionLabourToAssignmentDTO>},
        TContext
      > => {

      const mutationOptions = getPostAddActionLabourToAssignmentMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postCreateComment = (
    createCommentDTO: MaybeRef<CreateCommentDTO>,
 options?: SecondParameter<typeof axios>,) => {
      createCommentDTO = unref(createCommentDTO);
      
      return axios<CreateResponse>(
      {url: `/api/comment`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createCommentDTO
    },
      options);
    }
  


export const getPostCreateCommentMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCreateComment>>, TError,{data: BodyType<CreateCommentDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postCreateComment>>, TError,{data: BodyType<CreateCommentDTO>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCreateComment>>, {data: BodyType<CreateCommentDTO>}> = (props) => {
          const {data} = props ?? {};

          return  postCreateComment(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostCreateCommentMutationResult = NonNullable<Awaited<ReturnType<typeof postCreateComment>>>
    export type PostCreateCommentMutationBody = BodyType<CreateCommentDTO>
    export type PostCreateCommentMutationError = ErrorType<unknown>

    export const usePostCreateComment = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCreateComment>>, TError,{data: BodyType<CreateCommentDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postCreateComment>>,
        TError,
        {data: BodyType<CreateCommentDTO>},
        TContext
      > => {

      const mutationOptions = getPostCreateCommentMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postFetchAllComments = (
    fetchAllCommentsDTO: MaybeRef<FetchAllCommentsDTO>,
    params?: MaybeRef<PostFetchAllCommentsParams>,
 options?: SecondParameter<typeof axios>,) => {
      fetchAllCommentsDTO = unref(fetchAllCommentsDTO);
params = unref(params);
      
      return axios<FetchAllComments[]>(
      {url: `/api/comments`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: fetchAllCommentsDTO,
        params: unref(params)
    },
      options);
    }
  


export const getPostFetchAllCommentsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postFetchAllComments>>, TError,{data: BodyType<FetchAllCommentsDTO>;params?: PostFetchAllCommentsParams}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postFetchAllComments>>, TError,{data: BodyType<FetchAllCommentsDTO>;params?: PostFetchAllCommentsParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postFetchAllComments>>, {data: BodyType<FetchAllCommentsDTO>;params?: PostFetchAllCommentsParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postFetchAllComments(data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostFetchAllCommentsMutationResult = NonNullable<Awaited<ReturnType<typeof postFetchAllComments>>>
    export type PostFetchAllCommentsMutationBody = BodyType<FetchAllCommentsDTO>
    export type PostFetchAllCommentsMutationError = ErrorType<unknown>

    export const usePostFetchAllComments = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postFetchAllComments>>, TError,{data: BodyType<FetchAllCommentsDTO>;params?: PostFetchAllCommentsParams}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postFetchAllComments>>,
        TError,
        {data: BodyType<FetchAllCommentsDTO>;params?: PostFetchAllCommentsParams},
        TContext
      > => {

      const mutationOptions = getPostFetchAllCommentsMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postCreateContactPerson = (
    createTicketContactPersonDTO: MaybeRef<CreateTicketContactPersonDTO>,
 options?: SecondParameter<typeof axios>,) => {
      createTicketContactPersonDTO = unref(createTicketContactPersonDTO);
      
      return axios<CreateResponse>(
      {url: `/api/ticket-contact-person`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createTicketContactPersonDTO
    },
      options);
    }
  


export const getPostCreateContactPersonMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCreateContactPerson>>, TError,{data: BodyType<CreateTicketContactPersonDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postCreateContactPerson>>, TError,{data: BodyType<CreateTicketContactPersonDTO>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCreateContactPerson>>, {data: BodyType<CreateTicketContactPersonDTO>}> = (props) => {
          const {data} = props ?? {};

          return  postCreateContactPerson(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostCreateContactPersonMutationResult = NonNullable<Awaited<ReturnType<typeof postCreateContactPerson>>>
    export type PostCreateContactPersonMutationBody = BodyType<CreateTicketContactPersonDTO>
    export type PostCreateContactPersonMutationError = ErrorType<unknown>

    export const usePostCreateContactPerson = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCreateContactPerson>>, TError,{data: BodyType<CreateTicketContactPersonDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postCreateContactPerson>>,
        TError,
        {data: BodyType<CreateTicketContactPersonDTO>},
        TContext
      > => {

      const mutationOptions = getPostCreateContactPersonMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getFetchTicketContactPerson = (
    id: MaybeRef<string>,
 options?: SecondParameter<typeof axios>,signal?: AbortSignal
) => {
      id = unref(id);
      
      return axios<FetchTicketContactPersonResponse>(
      {url: `/api/ticket-contact-person/${id}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetFetchTicketContactPersonQueryKey = (id: MaybeRef<string>,) => {
    return ['api','ticket-contact-person',id] as const;
    }

    
export const getGetFetchTicketContactPersonQueryOptions = <TData = Awaited<ReturnType<typeof getFetchTicketContactPerson>>, TError = ErrorType<unknown>>(id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFetchTicketContactPerson>>, TError, TData>>, request?: SecondParameter<typeof axios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getGetFetchTicketContactPersonQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFetchTicketContactPerson>>> = ({ signal }) => getFetchTicketContactPerson(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: computed(() => !!(unref(id))), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFetchTicketContactPerson>>, TError, TData> 
}

export type GetFetchTicketContactPersonQueryResult = NonNullable<Awaited<ReturnType<typeof getFetchTicketContactPerson>>>
export type GetFetchTicketContactPersonQueryError = ErrorType<unknown>

export const useGetFetchTicketContactPerson = <TData = Awaited<ReturnType<typeof getFetchTicketContactPerson>>, TError = ErrorType<unknown>>(
 id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFetchTicketContactPerson>>, TError, TData>>, request?: SecondParameter<typeof axios>}

  ): UseQueryReturnType<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetFetchTicketContactPersonQueryOptions(id,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: QueryKey };

  query.queryKey = unref(queryOptions).queryKey as QueryKey;

  return query;
}




export const postFetchAllTicketContactPersons = (
    contactPersonFilterDTO: MaybeRef<ContactPersonFilterDTO>,
    params?: MaybeRef<PostFetchAllTicketContactPersonsParams>,
 options?: SecondParameter<typeof axios>,) => {
      contactPersonFilterDTO = unref(contactPersonFilterDTO);
params = unref(params);
      
      return axios<FetchAllTicketContactPersonsResponse>(
      {url: `/api/ticket-contact-persons`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: contactPersonFilterDTO,
        params: unref(params)
    },
      options);
    }
  


export const getPostFetchAllTicketContactPersonsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postFetchAllTicketContactPersons>>, TError,{data: BodyType<ContactPersonFilterDTO>;params?: PostFetchAllTicketContactPersonsParams}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postFetchAllTicketContactPersons>>, TError,{data: BodyType<ContactPersonFilterDTO>;params?: PostFetchAllTicketContactPersonsParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postFetchAllTicketContactPersons>>, {data: BodyType<ContactPersonFilterDTO>;params?: PostFetchAllTicketContactPersonsParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postFetchAllTicketContactPersons(data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostFetchAllTicketContactPersonsMutationResult = NonNullable<Awaited<ReturnType<typeof postFetchAllTicketContactPersons>>>
    export type PostFetchAllTicketContactPersonsMutationBody = BodyType<ContactPersonFilterDTO>
    export type PostFetchAllTicketContactPersonsMutationError = ErrorType<unknown>

    export const usePostFetchAllTicketContactPersons = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postFetchAllTicketContactPersons>>, TError,{data: BodyType<ContactPersonFilterDTO>;params?: PostFetchAllTicketContactPersonsParams}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postFetchAllTicketContactPersons>>,
        TError,
        {data: BodyType<ContactPersonFilterDTO>;params?: PostFetchAllTicketContactPersonsParams},
        TContext
      > => {

      const mutationOptions = getPostFetchAllTicketContactPersonsMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getFetchSite = (
    id: MaybeRef<string>,
 options?: SecondParameter<typeof axios>,signal?: AbortSignal
) => {
      id = unref(id);
      
      return axios<FetchSiteResponse>(
      {url: `/api/site/${id}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetFetchSiteQueryKey = (id: MaybeRef<string>,) => {
    return ['api','site',id] as const;
    }

    
export const getGetFetchSiteQueryOptions = <TData = Awaited<ReturnType<typeof getFetchSite>>, TError = ErrorType<unknown>>(id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFetchSite>>, TError, TData>>, request?: SecondParameter<typeof axios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getGetFetchSiteQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFetchSite>>> = ({ signal }) => getFetchSite(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: computed(() => !!(unref(id))), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFetchSite>>, TError, TData> 
}

export type GetFetchSiteQueryResult = NonNullable<Awaited<ReturnType<typeof getFetchSite>>>
export type GetFetchSiteQueryError = ErrorType<unknown>

export const useGetFetchSite = <TData = Awaited<ReturnType<typeof getFetchSite>>, TError = ErrorType<unknown>>(
 id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFetchSite>>, TError, TData>>, request?: SecondParameter<typeof axios>}

  ): UseQueryReturnType<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetFetchSiteQueryOptions(id,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: QueryKey };

  query.queryKey = unref(queryOptions).queryKey as QueryKey;

  return query;
}




export const postFetchAllSites = (
    siteFiltersDTO: MaybeRef<SiteFiltersDTO>,
    params?: MaybeRef<PostFetchAllSitesParams>,
 options?: SecondParameter<typeof axios>,) => {
      siteFiltersDTO = unref(siteFiltersDTO);
params = unref(params);
      
      return axios<FetchAllSites>(
      {url: `/api/sites`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: siteFiltersDTO,
        params: unref(params)
    },
      options);
    }
  


export const getPostFetchAllSitesMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postFetchAllSites>>, TError,{data: BodyType<SiteFiltersDTO>;params?: PostFetchAllSitesParams}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postFetchAllSites>>, TError,{data: BodyType<SiteFiltersDTO>;params?: PostFetchAllSitesParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postFetchAllSites>>, {data: BodyType<SiteFiltersDTO>;params?: PostFetchAllSitesParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postFetchAllSites(data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostFetchAllSitesMutationResult = NonNullable<Awaited<ReturnType<typeof postFetchAllSites>>>
    export type PostFetchAllSitesMutationBody = BodyType<SiteFiltersDTO>
    export type PostFetchAllSitesMutationError = ErrorType<unknown>

    export const usePostFetchAllSites = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postFetchAllSites>>, TError,{data: BodyType<SiteFiltersDTO>;params?: PostFetchAllSitesParams}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postFetchAllSites>>,
        TError,
        {data: BodyType<SiteFiltersDTO>;params?: PostFetchAllSitesParams},
        TContext
      > => {

      const mutationOptions = getPostFetchAllSitesMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postCreateSite = (
    createSiteDTO: MaybeRef<CreateSiteDTO>,
 options?: SecondParameter<typeof axios>,) => {
      createSiteDTO = unref(createSiteDTO);
      
      return axios<CreateResponse>(
      {url: `/api/site`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createSiteDTO
    },
      options);
    }
  


export const getPostCreateSiteMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCreateSite>>, TError,{data: BodyType<CreateSiteDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postCreateSite>>, TError,{data: BodyType<CreateSiteDTO>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCreateSite>>, {data: BodyType<CreateSiteDTO>}> = (props) => {
          const {data} = props ?? {};

          return  postCreateSite(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostCreateSiteMutationResult = NonNullable<Awaited<ReturnType<typeof postCreateSite>>>
    export type PostCreateSiteMutationBody = BodyType<CreateSiteDTO>
    export type PostCreateSiteMutationError = ErrorType<unknown>

    export const usePostCreateSite = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCreateSite>>, TError,{data: BodyType<CreateSiteDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postCreateSite>>,
        TError,
        {data: BodyType<CreateSiteDTO>},
        TContext
      > => {

      const mutationOptions = getPostCreateSiteMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getFetchTicket = (
    id: MaybeRef<string>,
 options?: SecondParameter<typeof axios>,signal?: AbortSignal
) => {
      id = unref(id);
      
      return axios<FetchTicketResponse>(
      {url: `/api/ticket/${id}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetFetchTicketQueryKey = (id: MaybeRef<string>,) => {
    return ['api','ticket',id] as const;
    }

    
export const getGetFetchTicketQueryOptions = <TData = Awaited<ReturnType<typeof getFetchTicket>>, TError = ErrorType<unknown>>(id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFetchTicket>>, TError, TData>>, request?: SecondParameter<typeof axios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getGetFetchTicketQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFetchTicket>>> = ({ signal }) => getFetchTicket(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: computed(() => !!(unref(id))), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFetchTicket>>, TError, TData> 
}

export type GetFetchTicketQueryResult = NonNullable<Awaited<ReturnType<typeof getFetchTicket>>>
export type GetFetchTicketQueryError = ErrorType<unknown>

export const useGetFetchTicket = <TData = Awaited<ReturnType<typeof getFetchTicket>>, TError = ErrorType<unknown>>(
 id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFetchTicket>>, TError, TData>>, request?: SecondParameter<typeof axios>}

  ): UseQueryReturnType<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetFetchTicketQueryOptions(id,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: QueryKey };

  query.queryKey = unref(queryOptions).queryKey as QueryKey;

  return query;
}




export const patchPatchTicket = (
    id: MaybeRef<string>,
    patchTicketDTO: MaybeRef<PatchTicketDTO>,
 options?: SecondParameter<typeof axios>,) => {
      id = unref(id);
patchTicketDTO = unref(patchTicketDTO);
      
      return axios<void>(
      {url: `/api/ticket/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchTicketDTO
    },
      options);
    }
  


export const getPatchPatchTicketMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchPatchTicket>>, TError,{id: string;data: BodyType<PatchTicketDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof patchPatchTicket>>, TError,{id: string;data: BodyType<PatchTicketDTO>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchPatchTicket>>, {id: string;data: BodyType<PatchTicketDTO>}> = (props) => {
          const {id,data} = props ?? {};

          return  patchPatchTicket(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchPatchTicketMutationResult = NonNullable<Awaited<ReturnType<typeof patchPatchTicket>>>
    export type PatchPatchTicketMutationBody = BodyType<PatchTicketDTO>
    export type PatchPatchTicketMutationError = ErrorType<void>

    export const usePatchPatchTicket = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchPatchTicket>>, TError,{id: string;data: BodyType<PatchTicketDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof patchPatchTicket>>,
        TError,
        {id: string;data: BodyType<PatchTicketDTO>},
        TContext
      > => {

      const mutationOptions = getPatchPatchTicketMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Fetch PDF from ticket service
 * @summary Get ticket PDF by ID
 */
export const getFetchTicketPdf = (
    id: MaybeRef<string>,
 options?: SecondParameter<typeof axios>,signal?: AbortSignal
) => {
      id = unref(id);
      
      return axios<void>(
      {url: `/api/pdf/${id}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetFetchTicketPdfQueryKey = (id: MaybeRef<string>,) => {
    return ['api','pdf',id] as const;
    }

    
export const getGetFetchTicketPdfQueryOptions = <TData = Awaited<ReturnType<typeof getFetchTicketPdf>>, TError = ErrorType<unknown>>(id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFetchTicketPdf>>, TError, TData>>, request?: SecondParameter<typeof axios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getGetFetchTicketPdfQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFetchTicketPdf>>> = ({ signal }) => getFetchTicketPdf(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: computed(() => !!(unref(id))), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFetchTicketPdf>>, TError, TData> 
}

export type GetFetchTicketPdfQueryResult = NonNullable<Awaited<ReturnType<typeof getFetchTicketPdf>>>
export type GetFetchTicketPdfQueryError = ErrorType<unknown>

/**
 * @summary Get ticket PDF by ID
 */
export const useGetFetchTicketPdf = <TData = Awaited<ReturnType<typeof getFetchTicketPdf>>, TError = ErrorType<unknown>>(
 id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFetchTicketPdf>>, TError, TData>>, request?: SecondParameter<typeof axios>}

  ): UseQueryReturnType<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetFetchTicketPdfQueryOptions(id,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: QueryKey };

  query.queryKey = unref(queryOptions).queryKey as QueryKey;

  return query;
}




export const postFetchAllTickets = (
    ticketFiltersDTO: MaybeRef<TicketFiltersDTO>,
    params?: MaybeRef<PostFetchAllTicketsParams>,
 options?: SecondParameter<typeof axios>,) => {
      ticketFiltersDTO = unref(ticketFiltersDTO);
params = unref(params);
      
      return axios<FetchAllTickets>(
      {url: `/api/tickets`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: ticketFiltersDTO,
        params: unref(params)
    },
      options);
    }
  


export const getPostFetchAllTicketsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postFetchAllTickets>>, TError,{data: BodyType<TicketFiltersDTO>;params?: PostFetchAllTicketsParams}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postFetchAllTickets>>, TError,{data: BodyType<TicketFiltersDTO>;params?: PostFetchAllTicketsParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postFetchAllTickets>>, {data: BodyType<TicketFiltersDTO>;params?: PostFetchAllTicketsParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postFetchAllTickets(data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostFetchAllTicketsMutationResult = NonNullable<Awaited<ReturnType<typeof postFetchAllTickets>>>
    export type PostFetchAllTicketsMutationBody = BodyType<TicketFiltersDTO>
    export type PostFetchAllTicketsMutationError = ErrorType<unknown>

    export const usePostFetchAllTickets = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postFetchAllTickets>>, TError,{data: BodyType<TicketFiltersDTO>;params?: PostFetchAllTicketsParams}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postFetchAllTickets>>,
        TError,
        {data: BodyType<TicketFiltersDTO>;params?: PostFetchAllTicketsParams},
        TContext
      > => {

      const mutationOptions = getPostFetchAllTicketsMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * The array of the scheduled tickets for the current and next day
 */
export const postFetchAllScheduledTickets = (
    
 options?: SecondParameter<typeof axios>,) => {
      
      
      return axios<FetchAllScheduledTickets>(
      {url: `/api/scheduled-tickets`, method: 'POST'
    },
      options);
    }
  


export const getPostFetchAllScheduledTicketsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postFetchAllScheduledTickets>>, TError,void, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postFetchAllScheduledTickets>>, TError,void, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postFetchAllScheduledTickets>>, void> = () => {
          

          return  postFetchAllScheduledTickets(requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostFetchAllScheduledTicketsMutationResult = NonNullable<Awaited<ReturnType<typeof postFetchAllScheduledTickets>>>
    
    export type PostFetchAllScheduledTicketsMutationError = ErrorType<unknown>

    export const usePostFetchAllScheduledTickets = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postFetchAllScheduledTickets>>, TError,void, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postFetchAllScheduledTickets>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getPostFetchAllScheduledTicketsMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * The array of the tickets with nullable scheduled date
 */
export const postFetchAllUnscheduledTickets = (
    params?: MaybeRef<PostFetchAllUnscheduledTicketsParams>,
 options?: SecondParameter<typeof axios>,) => {
      params = unref(params);
      
      return axios<FetchAllTickets>(
      {url: `/api/unscheduled-tickets`, method: 'POST',
        params: unref(params)
    },
      options);
    }
  


export const getPostFetchAllUnscheduledTicketsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postFetchAllUnscheduledTickets>>, TError,{params?: PostFetchAllUnscheduledTicketsParams}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postFetchAllUnscheduledTickets>>, TError,{params?: PostFetchAllUnscheduledTicketsParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postFetchAllUnscheduledTickets>>, {params?: PostFetchAllUnscheduledTicketsParams}> = (props) => {
          const {params} = props ?? {};

          return  postFetchAllUnscheduledTickets(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostFetchAllUnscheduledTicketsMutationResult = NonNullable<Awaited<ReturnType<typeof postFetchAllUnscheduledTickets>>>
    
    export type PostFetchAllUnscheduledTicketsMutationError = ErrorType<unknown>

    export const usePostFetchAllUnscheduledTickets = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postFetchAllUnscheduledTickets>>, TError,{params?: PostFetchAllUnscheduledTicketsParams}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postFetchAllUnscheduledTickets>>,
        TError,
        {params?: PostFetchAllUnscheduledTicketsParams},
        TContext
      > => {

      const mutationOptions = getPostFetchAllUnscheduledTicketsMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * The array of the not done scheduled tickets to the current day
 */
export const postFetchOverdueScheduledTickets = (
    
 options?: SecondParameter<typeof axios>,) => {
      
      
      return axios<FetchAllScheduledTickets>(
      {url: `/api/overdue-scheduled-tickets`, method: 'POST'
    },
      options);
    }
  


export const getPostFetchOverdueScheduledTicketsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postFetchOverdueScheduledTickets>>, TError,void, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postFetchOverdueScheduledTickets>>, TError,void, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postFetchOverdueScheduledTickets>>, void> = () => {
          

          return  postFetchOverdueScheduledTickets(requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostFetchOverdueScheduledTicketsMutationResult = NonNullable<Awaited<ReturnType<typeof postFetchOverdueScheduledTickets>>>
    
    export type PostFetchOverdueScheduledTicketsMutationError = ErrorType<unknown>

    export const usePostFetchOverdueScheduledTickets = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postFetchOverdueScheduledTickets>>, TError,void, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postFetchOverdueScheduledTickets>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getPostFetchOverdueScheduledTicketsMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Fetch all tickets associated with a specific unit
 * @summary Get tickets by unit ID
 */
export const postFetchTicketsByUnit = (
    id: MaybeRef<string>,
 options?: SecondParameter<typeof axios>,) => {
      id = unref(id);
      
      return axios<void>(
      {url: `/api/unit/${id}/tickets`, method: 'POST'
    },
      options);
    }
  


export const getPostFetchTicketsByUnitMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postFetchTicketsByUnit>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postFetchTicketsByUnit>>, TError,{id: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postFetchTicketsByUnit>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  postFetchTicketsByUnit(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostFetchTicketsByUnitMutationResult = NonNullable<Awaited<ReturnType<typeof postFetchTicketsByUnit>>>
    
    export type PostFetchTicketsByUnitMutationError = ErrorType<unknown>

    /**
 * @summary Get tickets by unit ID
 */
export const usePostFetchTicketsByUnit = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postFetchTicketsByUnit>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postFetchTicketsByUnit>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getPostFetchTicketsByUnitMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postCreateTicket = (
    createTicketDTO: MaybeRef<CreateTicketDTO>,
 options?: SecondParameter<typeof axios>,) => {
      createTicketDTO = unref(createTicketDTO);
      
      return axios<CreateResponse>(
      {url: `/api/ticket`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createTicketDTO
    },
      options);
    }
  


export const getPostCreateTicketMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCreateTicket>>, TError,{data: BodyType<CreateTicketDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postCreateTicket>>, TError,{data: BodyType<CreateTicketDTO>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCreateTicket>>, {data: BodyType<CreateTicketDTO>}> = (props) => {
          const {data} = props ?? {};

          return  postCreateTicket(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostCreateTicketMutationResult = NonNullable<Awaited<ReturnType<typeof postCreateTicket>>>
    export type PostCreateTicketMutationBody = BodyType<CreateTicketDTO>
    export type PostCreateTicketMutationError = ErrorType<unknown>

    export const usePostCreateTicket = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCreateTicket>>, TError,{data: BodyType<CreateTicketDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postCreateTicket>>,
        TError,
        {data: BodyType<CreateTicketDTO>},
        TContext
      > => {

      const mutationOptions = getPostCreateTicketMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postUpdateTicketTitle = (
    id: MaybeRef<string>,
    updateTicketTitle: MaybeRef<UpdateTicketTitle>,
 options?: SecondParameter<typeof axios>,) => {
      id = unref(id);
updateTicketTitle = unref(updateTicketTitle);
      
      return axios<void>(
      {url: `/api/ticket/${id}/title`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: updateTicketTitle
    },
      options);
    }
  


export const getPostUpdateTicketTitleMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUpdateTicketTitle>>, TError,{id: string;data: BodyType<UpdateTicketTitle>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postUpdateTicketTitle>>, TError,{id: string;data: BodyType<UpdateTicketTitle>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postUpdateTicketTitle>>, {id: string;data: BodyType<UpdateTicketTitle>}> = (props) => {
          const {id,data} = props ?? {};

          return  postUpdateTicketTitle(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostUpdateTicketTitleMutationResult = NonNullable<Awaited<ReturnType<typeof postUpdateTicketTitle>>>
    export type PostUpdateTicketTitleMutationBody = BodyType<UpdateTicketTitle>
    export type PostUpdateTicketTitleMutationError = ErrorType<unknown>

    export const usePostUpdateTicketTitle = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUpdateTicketTitle>>, TError,{id: string;data: BodyType<UpdateTicketTitle>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postUpdateTicketTitle>>,
        TError,
        {id: string;data: BodyType<UpdateTicketTitle>},
        TContext
      > => {

      const mutationOptions = getPostUpdateTicketTitleMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postUpdateTicketDescription = (
    id: MaybeRef<string>,
    updateTicketDescription: MaybeRef<UpdateTicketDescription>,
 options?: SecondParameter<typeof axios>,) => {
      id = unref(id);
updateTicketDescription = unref(updateTicketDescription);
      
      return axios<void>(
      {url: `/api/ticket/${id}/description`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: updateTicketDescription
    },
      options);
    }
  


export const getPostUpdateTicketDescriptionMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUpdateTicketDescription>>, TError,{id: string;data: BodyType<UpdateTicketDescription>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postUpdateTicketDescription>>, TError,{id: string;data: BodyType<UpdateTicketDescription>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postUpdateTicketDescription>>, {id: string;data: BodyType<UpdateTicketDescription>}> = (props) => {
          const {id,data} = props ?? {};

          return  postUpdateTicketDescription(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostUpdateTicketDescriptionMutationResult = NonNullable<Awaited<ReturnType<typeof postUpdateTicketDescription>>>
    export type PostUpdateTicketDescriptionMutationBody = BodyType<UpdateTicketDescription>
    export type PostUpdateTicketDescriptionMutationError = ErrorType<unknown>

    export const usePostUpdateTicketDescription = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUpdateTicketDescription>>, TError,{id: string;data: BodyType<UpdateTicketDescription>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postUpdateTicketDescription>>,
        TError,
        {id: string;data: BodyType<UpdateTicketDescription>},
        TContext
      > => {

      const mutationOptions = getPostUpdateTicketDescriptionMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postUpdateTicketPriority = (
    id: MaybeRef<string>,
    updateTicketPriority: MaybeRef<UpdateTicketPriority>,
 options?: SecondParameter<typeof axios>,) => {
      id = unref(id);
updateTicketPriority = unref(updateTicketPriority);
      
      return axios<void>(
      {url: `/api/ticket/${id}/priority`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: updateTicketPriority
    },
      options);
    }
  


export const getPostUpdateTicketPriorityMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUpdateTicketPriority>>, TError,{id: string;data: BodyType<UpdateTicketPriority>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postUpdateTicketPriority>>, TError,{id: string;data: BodyType<UpdateTicketPriority>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postUpdateTicketPriority>>, {id: string;data: BodyType<UpdateTicketPriority>}> = (props) => {
          const {id,data} = props ?? {};

          return  postUpdateTicketPriority(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostUpdateTicketPriorityMutationResult = NonNullable<Awaited<ReturnType<typeof postUpdateTicketPriority>>>
    export type PostUpdateTicketPriorityMutationBody = BodyType<UpdateTicketPriority>
    export type PostUpdateTicketPriorityMutationError = ErrorType<unknown>

    export const usePostUpdateTicketPriority = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUpdateTicketPriority>>, TError,{id: string;data: BodyType<UpdateTicketPriority>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postUpdateTicketPriority>>,
        TError,
        {id: string;data: BodyType<UpdateTicketPriority>},
        TContext
      > => {

      const mutationOptions = getPostUpdateTicketPriorityMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postScheduleDate = (
    id: MaybeRef<string>,
    scheduleTicket: MaybeRef<ScheduleTicket>,
 options?: SecondParameter<typeof axios>,) => {
      id = unref(id);
scheduleTicket = unref(scheduleTicket);
      
      return axios<void>(
      {url: `/api/ticket/${id}/schedule`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: scheduleTicket
    },
      options);
    }
  


export const getPostScheduleDateMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postScheduleDate>>, TError,{id: string;data: BodyType<ScheduleTicket>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postScheduleDate>>, TError,{id: string;data: BodyType<ScheduleTicket>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postScheduleDate>>, {id: string;data: BodyType<ScheduleTicket>}> = (props) => {
          const {id,data} = props ?? {};

          return  postScheduleDate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostScheduleDateMutationResult = NonNullable<Awaited<ReturnType<typeof postScheduleDate>>>
    export type PostScheduleDateMutationBody = BodyType<ScheduleTicket>
    export type PostScheduleDateMutationError = ErrorType<unknown>

    export const usePostScheduleDate = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postScheduleDate>>, TError,{id: string;data: BodyType<ScheduleTicket>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postScheduleDate>>,
        TError,
        {id: string;data: BodyType<ScheduleTicket>},
        TContext
      > => {

      const mutationOptions = getPostScheduleDateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postUpdateTicketStatus = (
    id: MaybeRef<string>,
    updateTicketStatus: MaybeRef<UpdateTicketStatus>,
 options?: SecondParameter<typeof axios>,) => {
      id = unref(id);
updateTicketStatus = unref(updateTicketStatus);
      
      return axios<void>(
      {url: `/api/ticket/${id}/status`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: updateTicketStatus
    },
      options);
    }
  


export const getPostUpdateTicketStatusMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUpdateTicketStatus>>, TError,{id: string;data: BodyType<UpdateTicketStatus>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postUpdateTicketStatus>>, TError,{id: string;data: BodyType<UpdateTicketStatus>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postUpdateTicketStatus>>, {id: string;data: BodyType<UpdateTicketStatus>}> = (props) => {
          const {id,data} = props ?? {};

          return  postUpdateTicketStatus(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostUpdateTicketStatusMutationResult = NonNullable<Awaited<ReturnType<typeof postUpdateTicketStatus>>>
    export type PostUpdateTicketStatusMutationBody = BodyType<UpdateTicketStatus>
    export type PostUpdateTicketStatusMutationError = ErrorType<unknown>

    export const usePostUpdateTicketStatus = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUpdateTicketStatus>>, TError,{id: string;data: BodyType<UpdateTicketStatus>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postUpdateTicketStatus>>,
        TError,
        {id: string;data: BodyType<UpdateTicketStatus>},
        TContext
      > => {

      const mutationOptions = getPostUpdateTicketStatusMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postUpdateTicketAssignee = (
    id: MaybeRef<string>,
    updateTicketAssignee: MaybeRef<UpdateTicketAssignee>,
 options?: SecondParameter<typeof axios>,) => {
      id = unref(id);
updateTicketAssignee = unref(updateTicketAssignee);
      
      return axios<void>(
      {url: `/api/ticket/${id}/assignee`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: updateTicketAssignee
    },
      options);
    }
  


export const getPostUpdateTicketAssigneeMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUpdateTicketAssignee>>, TError,{id: string;data: BodyType<UpdateTicketAssignee>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postUpdateTicketAssignee>>, TError,{id: string;data: BodyType<UpdateTicketAssignee>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postUpdateTicketAssignee>>, {id: string;data: BodyType<UpdateTicketAssignee>}> = (props) => {
          const {id,data} = props ?? {};

          return  postUpdateTicketAssignee(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostUpdateTicketAssigneeMutationResult = NonNullable<Awaited<ReturnType<typeof postUpdateTicketAssignee>>>
    export type PostUpdateTicketAssigneeMutationBody = BodyType<UpdateTicketAssignee>
    export type PostUpdateTicketAssigneeMutationError = ErrorType<unknown>

    export const usePostUpdateTicketAssignee = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUpdateTicketAssignee>>, TError,{id: string;data: BodyType<UpdateTicketAssignee>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postUpdateTicketAssignee>>,
        TError,
        {id: string;data: BodyType<UpdateTicketAssignee>},
        TContext
      > => {

      const mutationOptions = getPostUpdateTicketAssigneeMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postUpdateTicketExpectedDuration = (
    id: MaybeRef<string>,
    updateTicketExpectedDuration: MaybeRef<UpdateTicketExpectedDuration>,
 options?: SecondParameter<typeof axios>,) => {
      id = unref(id);
updateTicketExpectedDuration = unref(updateTicketExpectedDuration);
      
      return axios<void>(
      {url: `/api/ticket/${id}/expected-duration`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: updateTicketExpectedDuration
    },
      options);
    }
  


export const getPostUpdateTicketExpectedDurationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUpdateTicketExpectedDuration>>, TError,{id: string;data: BodyType<UpdateTicketExpectedDuration>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postUpdateTicketExpectedDuration>>, TError,{id: string;data: BodyType<UpdateTicketExpectedDuration>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postUpdateTicketExpectedDuration>>, {id: string;data: BodyType<UpdateTicketExpectedDuration>}> = (props) => {
          const {id,data} = props ?? {};

          return  postUpdateTicketExpectedDuration(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostUpdateTicketExpectedDurationMutationResult = NonNullable<Awaited<ReturnType<typeof postUpdateTicketExpectedDuration>>>
    export type PostUpdateTicketExpectedDurationMutationBody = BodyType<UpdateTicketExpectedDuration>
    export type PostUpdateTicketExpectedDurationMutationError = ErrorType<unknown>

    export const usePostUpdateTicketExpectedDuration = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUpdateTicketExpectedDuration>>, TError,{id: string;data: BodyType<UpdateTicketExpectedDuration>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postUpdateTicketExpectedDuration>>,
        TError,
        {id: string;data: BodyType<UpdateTicketExpectedDuration>},
        TContext
      > => {

      const mutationOptions = getPostUpdateTicketExpectedDurationMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const patchUpdateTicketOrganisation = (
    id: MaybeRef<string>,
    updateTicketOrganisation: MaybeRef<UpdateTicketOrganisation>,
 options?: SecondParameter<typeof axios>,) => {
      id = unref(id);
updateTicketOrganisation = unref(updateTicketOrganisation);
      
      return axios<void>(
      {url: `/api/ticket/${id}/organisation`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateTicketOrganisation
    },
      options);
    }
  


export const getPatchUpdateTicketOrganisationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchUpdateTicketOrganisation>>, TError,{id: string;data: BodyType<UpdateTicketOrganisation>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof patchUpdateTicketOrganisation>>, TError,{id: string;data: BodyType<UpdateTicketOrganisation>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchUpdateTicketOrganisation>>, {id: string;data: BodyType<UpdateTicketOrganisation>}> = (props) => {
          const {id,data} = props ?? {};

          return  patchUpdateTicketOrganisation(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchUpdateTicketOrganisationMutationResult = NonNullable<Awaited<ReturnType<typeof patchUpdateTicketOrganisation>>>
    export type PatchUpdateTicketOrganisationMutationBody = BodyType<UpdateTicketOrganisation>
    export type PatchUpdateTicketOrganisationMutationError = ErrorType<unknown>

    export const usePatchUpdateTicketOrganisation = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchUpdateTicketOrganisation>>, TError,{id: string;data: BodyType<UpdateTicketOrganisation>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof patchUpdateTicketOrganisation>>,
        TError,
        {id: string;data: BodyType<UpdateTicketOrganisation>},
        TContext
      > => {

      const mutationOptions = getPatchUpdateTicketOrganisationMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * This endpoint sets the status of a ticket to closed
 * @summary Close a ticket
 */
export const postCloseTicket = (
    id: MaybeRef<string>,
 options?: SecondParameter<typeof axios>,) => {
      id = unref(id);
      
      return axios<void>(
      {url: `/api/ticket/${id}/close`, method: 'POST'
    },
      options);
    }
  


export const getPostCloseTicketMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCloseTicket>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postCloseTicket>>, TError,{id: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCloseTicket>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  postCloseTicket(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostCloseTicketMutationResult = NonNullable<Awaited<ReturnType<typeof postCloseTicket>>>
    
    export type PostCloseTicketMutationError = ErrorType<unknown>

    /**
 * @summary Close a ticket
 */
export const usePostCloseTicket = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCloseTicket>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postCloseTicket>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getPostCloseTicketMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postReadyForProcessingTicket = (
    id: MaybeRef<string>,
 options?: SecondParameter<typeof axios>,) => {
      id = unref(id);
      
      return axios<void>(
      {url: `/api/ticket/${id}/ready-for-processing`, method: 'POST'
    },
      options);
    }
  


export const getPostReadyForProcessingTicketMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postReadyForProcessingTicket>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postReadyForProcessingTicket>>, TError,{id: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postReadyForProcessingTicket>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  postReadyForProcessingTicket(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostReadyForProcessingTicketMutationResult = NonNullable<Awaited<ReturnType<typeof postReadyForProcessingTicket>>>
    
    export type PostReadyForProcessingTicketMutationError = ErrorType<void>

    export const usePostReadyForProcessingTicket = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postReadyForProcessingTicket>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postReadyForProcessingTicket>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getPostReadyForProcessingTicketMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postAddSiteToTicket = (
    id: MaybeRef<string>,
    siteId: MaybeRef<string>,
 options?: SecondParameter<typeof axios>,) => {
      id = unref(id);
siteId = unref(siteId);
      
      return axios<void>(
      {url: `/api/ticket/${id}/site/${siteId}`, method: 'POST'
    },
      options);
    }
  


export const getPostAddSiteToTicketMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAddSiteToTicket>>, TError,{id: string;siteId: string}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postAddSiteToTicket>>, TError,{id: string;siteId: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAddSiteToTicket>>, {id: string;siteId: string}> = (props) => {
          const {id,siteId} = props ?? {};

          return  postAddSiteToTicket(id,siteId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAddSiteToTicketMutationResult = NonNullable<Awaited<ReturnType<typeof postAddSiteToTicket>>>
    
    export type PostAddSiteToTicketMutationError = ErrorType<unknown>

    export const usePostAddSiteToTicket = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAddSiteToTicket>>, TError,{id: string;siteId: string}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postAddSiteToTicket>>,
        TError,
        {id: string;siteId: string},
        TContext
      > => {

      const mutationOptions = getPostAddSiteToTicketMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postAddAssigneeToTicket = (
    id: MaybeRef<string>,
    addAssigneeToTicketDTO: MaybeRef<AddAssigneeToTicketDTO>,
 options?: SecondParameter<typeof axios>,) => {
      id = unref(id);
addAssigneeToTicketDTO = unref(addAssigneeToTicketDTO);
      
      return axios<void>(
      {url: `/api/ticket/${id}/add-assignee`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: addAssigneeToTicketDTO
    },
      options);
    }
  


export const getPostAddAssigneeToTicketMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAddAssigneeToTicket>>, TError,{id: string;data: BodyType<AddAssigneeToTicketDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postAddAssigneeToTicket>>, TError,{id: string;data: BodyType<AddAssigneeToTicketDTO>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAddAssigneeToTicket>>, {id: string;data: BodyType<AddAssigneeToTicketDTO>}> = (props) => {
          const {id,data} = props ?? {};

          return  postAddAssigneeToTicket(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAddAssigneeToTicketMutationResult = NonNullable<Awaited<ReturnType<typeof postAddAssigneeToTicket>>>
    export type PostAddAssigneeToTicketMutationBody = BodyType<AddAssigneeToTicketDTO>
    export type PostAddAssigneeToTicketMutationError = ErrorType<unknown>

    export const usePostAddAssigneeToTicket = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAddAssigneeToTicket>>, TError,{id: string;data: BodyType<AddAssigneeToTicketDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postAddAssigneeToTicket>>,
        TError,
        {id: string;data: BodyType<AddAssigneeToTicketDTO>},
        TContext
      > => {

      const mutationOptions = getPostAddAssigneeToTicketMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postAddUnitToTicket = (
    id: MaybeRef<string>,
    unitId: MaybeRef<string>,
 options?: SecondParameter<typeof axios>,) => {
      id = unref(id);
unitId = unref(unitId);
      
      return axios<void>(
      {url: `/api/ticket/${id}/unit/${unitId}`, method: 'POST'
    },
      options);
    }
  


export const getPostAddUnitToTicketMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAddUnitToTicket>>, TError,{id: string;unitId: string}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postAddUnitToTicket>>, TError,{id: string;unitId: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAddUnitToTicket>>, {id: string;unitId: string}> = (props) => {
          const {id,unitId} = props ?? {};

          return  postAddUnitToTicket(id,unitId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAddUnitToTicketMutationResult = NonNullable<Awaited<ReturnType<typeof postAddUnitToTicket>>>
    
    export type PostAddUnitToTicketMutationError = ErrorType<unknown>

    export const usePostAddUnitToTicket = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAddUnitToTicket>>, TError,{id: string;unitId: string}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postAddUnitToTicket>>,
        TError,
        {id: string;unitId: string},
        TContext
      > => {

      const mutationOptions = getPostAddUnitToTicketMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postAddChildTicketToTicket = (
    id: MaybeRef<string>,
    addChildTicketToTicketDTO: MaybeRef<AddChildTicketToTicketDTO>,
 options?: SecondParameter<typeof axios>,) => {
      id = unref(id);
addChildTicketToTicketDTO = unref(addChildTicketToTicketDTO);
      
      return axios<void>(
      {url: `/api/ticket/${id}/add-child-ticket`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: addChildTicketToTicketDTO
    },
      options);
    }
  


export const getPostAddChildTicketToTicketMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAddChildTicketToTicket>>, TError,{id: string;data: BodyType<AddChildTicketToTicketDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postAddChildTicketToTicket>>, TError,{id: string;data: BodyType<AddChildTicketToTicketDTO>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAddChildTicketToTicket>>, {id: string;data: BodyType<AddChildTicketToTicketDTO>}> = (props) => {
          const {id,data} = props ?? {};

          return  postAddChildTicketToTicket(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAddChildTicketToTicketMutationResult = NonNullable<Awaited<ReturnType<typeof postAddChildTicketToTicket>>>
    export type PostAddChildTicketToTicketMutationBody = BodyType<AddChildTicketToTicketDTO>
    export type PostAddChildTicketToTicketMutationError = ErrorType<unknown>

    export const usePostAddChildTicketToTicket = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAddChildTicketToTicket>>, TError,{id: string;data: BodyType<AddChildTicketToTicketDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postAddChildTicketToTicket>>,
        TError,
        {id: string;data: BodyType<AddChildTicketToTicketDTO>},
        TContext
      > => {

      const mutationOptions = getPostAddChildTicketToTicketMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postAddAssignmentToTicket = (
    id: MaybeRef<string>,
    addAssignmentToTicketDTO: MaybeRef<AddAssignmentToTicketDTO>,
 options?: SecondParameter<typeof axios>,) => {
      id = unref(id);
addAssignmentToTicketDTO = unref(addAssignmentToTicketDTO);
      
      return axios<void>(
      {url: `/api/ticket/${id}/add-assignment`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: addAssignmentToTicketDTO
    },
      options);
    }
  


export const getPostAddAssignmentToTicketMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAddAssignmentToTicket>>, TError,{id: string;data: BodyType<AddAssignmentToTicketDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postAddAssignmentToTicket>>, TError,{id: string;data: BodyType<AddAssignmentToTicketDTO>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAddAssignmentToTicket>>, {id: string;data: BodyType<AddAssignmentToTicketDTO>}> = (props) => {
          const {id,data} = props ?? {};

          return  postAddAssignmentToTicket(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAddAssignmentToTicketMutationResult = NonNullable<Awaited<ReturnType<typeof postAddAssignmentToTicket>>>
    export type PostAddAssignmentToTicketMutationBody = BodyType<AddAssignmentToTicketDTO>
    export type PostAddAssignmentToTicketMutationError = ErrorType<unknown>

    export const usePostAddAssignmentToTicket = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAddAssignmentToTicket>>, TError,{id: string;data: BodyType<AddAssignmentToTicketDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postAddAssignmentToTicket>>,
        TError,
        {id: string;data: BodyType<AddAssignmentToTicketDTO>},
        TContext
      > => {

      const mutationOptions = getPostAddAssignmentToTicketMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postAddSiteContactPersonsToTicket = (
    id: MaybeRef<string>,
    addContactPersonsToTicketDTO: MaybeRef<AddContactPersonsToTicketDTO>,
 options?: SecondParameter<typeof axios>,) => {
      id = unref(id);
addContactPersonsToTicketDTO = unref(addContactPersonsToTicketDTO);
      
      return axios<void>(
      {url: `/api/ticket/${id}/add-site-contact-persons`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: addContactPersonsToTicketDTO
    },
      options);
    }
  


export const getPostAddSiteContactPersonsToTicketMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAddSiteContactPersonsToTicket>>, TError,{id: string;data: BodyType<AddContactPersonsToTicketDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postAddSiteContactPersonsToTicket>>, TError,{id: string;data: BodyType<AddContactPersonsToTicketDTO>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAddSiteContactPersonsToTicket>>, {id: string;data: BodyType<AddContactPersonsToTicketDTO>}> = (props) => {
          const {id,data} = props ?? {};

          return  postAddSiteContactPersonsToTicket(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAddSiteContactPersonsToTicketMutationResult = NonNullable<Awaited<ReturnType<typeof postAddSiteContactPersonsToTicket>>>
    export type PostAddSiteContactPersonsToTicketMutationBody = BodyType<AddContactPersonsToTicketDTO>
    export type PostAddSiteContactPersonsToTicketMutationError = ErrorType<unknown>

    export const usePostAddSiteContactPersonsToTicket = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAddSiteContactPersonsToTicket>>, TError,{id: string;data: BodyType<AddContactPersonsToTicketDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postAddSiteContactPersonsToTicket>>,
        TError,
        {id: string;data: BodyType<AddContactPersonsToTicketDTO>},
        TContext
      > => {

      const mutationOptions = getPostAddSiteContactPersonsToTicketMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postAddOrganisationContactPersonsToTicket = (
    id: MaybeRef<string>,
    addContactPersonsToTicketDTO: MaybeRef<AddContactPersonsToTicketDTO>,
 options?: SecondParameter<typeof axios>,) => {
      id = unref(id);
addContactPersonsToTicketDTO = unref(addContactPersonsToTicketDTO);
      
      return axios<void>(
      {url: `/api/ticket/${id}/add-organisation-contact-persons`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: addContactPersonsToTicketDTO
    },
      options);
    }
  


export const getPostAddOrganisationContactPersonsToTicketMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAddOrganisationContactPersonsToTicket>>, TError,{id: string;data: BodyType<AddContactPersonsToTicketDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postAddOrganisationContactPersonsToTicket>>, TError,{id: string;data: BodyType<AddContactPersonsToTicketDTO>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAddOrganisationContactPersonsToTicket>>, {id: string;data: BodyType<AddContactPersonsToTicketDTO>}> = (props) => {
          const {id,data} = props ?? {};

          return  postAddOrganisationContactPersonsToTicket(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAddOrganisationContactPersonsToTicketMutationResult = NonNullable<Awaited<ReturnType<typeof postAddOrganisationContactPersonsToTicket>>>
    export type PostAddOrganisationContactPersonsToTicketMutationBody = BodyType<AddContactPersonsToTicketDTO>
    export type PostAddOrganisationContactPersonsToTicketMutationError = ErrorType<unknown>

    export const usePostAddOrganisationContactPersonsToTicket = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAddOrganisationContactPersonsToTicket>>, TError,{id: string;data: BodyType<AddContactPersonsToTicketDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postAddOrganisationContactPersonsToTicket>>,
        TError,
        {id: string;data: BodyType<AddContactPersonsToTicketDTO>},
        TContext
      > => {

      const mutationOptions = getPostAddOrganisationContactPersonsToTicketMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postAddArticleToTicket = (
    id: MaybeRef<string>,
    addArticlesToTicketDTO: MaybeRef<AddArticlesToTicketDTO>,
 options?: SecondParameter<typeof axios>,) => {
      id = unref(id);
addArticlesToTicketDTO = unref(addArticlesToTicketDTO);
      
      return axios<void>(
      {url: `/api/ticket/${id}/add-article`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: addArticlesToTicketDTO
    },
      options);
    }
  


export const getPostAddArticleToTicketMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAddArticleToTicket>>, TError,{id: string;data: BodyType<AddArticlesToTicketDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postAddArticleToTicket>>, TError,{id: string;data: BodyType<AddArticlesToTicketDTO>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAddArticleToTicket>>, {id: string;data: BodyType<AddArticlesToTicketDTO>}> = (props) => {
          const {id,data} = props ?? {};

          return  postAddArticleToTicket(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAddArticleToTicketMutationResult = NonNullable<Awaited<ReturnType<typeof postAddArticleToTicket>>>
    export type PostAddArticleToTicketMutationBody = BodyType<AddArticlesToTicketDTO>
    export type PostAddArticleToTicketMutationError = ErrorType<unknown>

    export const usePostAddArticleToTicket = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAddArticleToTicket>>, TError,{id: string;data: BodyType<AddArticlesToTicketDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postAddArticleToTicket>>,
        TError,
        {id: string;data: BodyType<AddArticlesToTicketDTO>},
        TContext
      > => {

      const mutationOptions = getPostAddArticleToTicketMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postAddAcknowledgementToTicket = (
    id: MaybeRef<string>,
    addAcknowledgementToTicket: MaybeRef<AddAcknowledgementToTicket>,
 options?: SecondParameter<typeof axios>,) => {
      id = unref(id);
addAcknowledgementToTicket = unref(addAcknowledgementToTicket);
      
      return axios<void>(
      {url: `/api/ticket/${id}/add-acknowledgement`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: addAcknowledgementToTicket
    },
      options);
    }
  


export const getPostAddAcknowledgementToTicketMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAddAcknowledgementToTicket>>, TError,{id: string;data: BodyType<AddAcknowledgementToTicket>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postAddAcknowledgementToTicket>>, TError,{id: string;data: BodyType<AddAcknowledgementToTicket>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAddAcknowledgementToTicket>>, {id: string;data: BodyType<AddAcknowledgementToTicket>}> = (props) => {
          const {id,data} = props ?? {};

          return  postAddAcknowledgementToTicket(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAddAcknowledgementToTicketMutationResult = NonNullable<Awaited<ReturnType<typeof postAddAcknowledgementToTicket>>>
    export type PostAddAcknowledgementToTicketMutationBody = BodyType<AddAcknowledgementToTicket>
    export type PostAddAcknowledgementToTicketMutationError = ErrorType<unknown>

    export const usePostAddAcknowledgementToTicket = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAddAcknowledgementToTicket>>, TError,{id: string;data: BodyType<AddAcknowledgementToTicket>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postAddAcknowledgementToTicket>>,
        TError,
        {id: string;data: BodyType<AddAcknowledgementToTicket>},
        TContext
      > => {

      const mutationOptions = getPostAddAcknowledgementToTicketMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postAddCaseToTicket = (
    id: MaybeRef<string>,
    addCaseToTicket: MaybeRef<AddCaseToTicket>,
 options?: SecondParameter<typeof axios>,) => {
      id = unref(id);
addCaseToTicket = unref(addCaseToTicket);
      
      return axios<void>(
      {url: `/api/ticket/${id}/add-case`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: addCaseToTicket
    },
      options);
    }
  


export const getPostAddCaseToTicketMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAddCaseToTicket>>, TError,{id: string;data: BodyType<AddCaseToTicket>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postAddCaseToTicket>>, TError,{id: string;data: BodyType<AddCaseToTicket>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAddCaseToTicket>>, {id: string;data: BodyType<AddCaseToTicket>}> = (props) => {
          const {id,data} = props ?? {};

          return  postAddCaseToTicket(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAddCaseToTicketMutationResult = NonNullable<Awaited<ReturnType<typeof postAddCaseToTicket>>>
    export type PostAddCaseToTicketMutationBody = BodyType<AddCaseToTicket>
    export type PostAddCaseToTicketMutationError = ErrorType<unknown>

    export const usePostAddCaseToTicket = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAddCaseToTicket>>, TError,{id: string;data: BodyType<AddCaseToTicket>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postAddCaseToTicket>>,
        TError,
        {id: string;data: BodyType<AddCaseToTicket>},
        TContext
      > => {

      const mutationOptions = getPostAddCaseToTicketMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postAddFileToTicket = (
    id: MaybeRef<string>,
    saveFileDTO: MaybeRef<SaveFileDTO>,
 options?: SecondParameter<typeof axios>,) => {
      id = unref(id);
saveFileDTO = unref(saveFileDTO);
      
      return axios<void>(
      {url: `/api/ticket/${id}/add-files`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: saveFileDTO
    },
      options);
    }
  


export const getPostAddFileToTicketMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAddFileToTicket>>, TError,{id: string;data: BodyType<SaveFileDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postAddFileToTicket>>, TError,{id: string;data: BodyType<SaveFileDTO>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAddFileToTicket>>, {id: string;data: BodyType<SaveFileDTO>}> = (props) => {
          const {id,data} = props ?? {};

          return  postAddFileToTicket(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAddFileToTicketMutationResult = NonNullable<Awaited<ReturnType<typeof postAddFileToTicket>>>
    export type PostAddFileToTicketMutationBody = BodyType<SaveFileDTO>
    export type PostAddFileToTicketMutationError = ErrorType<void>

    export const usePostAddFileToTicket = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAddFileToTicket>>, TError,{id: string;data: BodyType<SaveFileDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postAddFileToTicket>>,
        TError,
        {id: string;data: BodyType<SaveFileDTO>},
        TContext
      > => {

      const mutationOptions = getPostAddFileToTicketMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postAddSignatureToTicket = (
    id: MaybeRef<string>,
    addSignatureDTO: MaybeRef<AddSignatureDTO>,
 options?: SecondParameter<typeof axios>,) => {
      id = unref(id);
addSignatureDTO = unref(addSignatureDTO);
      
      return axios<void>(
      {url: `/api/ticket/${id}/add-signature`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: addSignatureDTO
    },
      options);
    }
  


export const getPostAddSignatureToTicketMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAddSignatureToTicket>>, TError,{id: string;data: BodyType<AddSignatureDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postAddSignatureToTicket>>, TError,{id: string;data: BodyType<AddSignatureDTO>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAddSignatureToTicket>>, {id: string;data: BodyType<AddSignatureDTO>}> = (props) => {
          const {id,data} = props ?? {};

          return  postAddSignatureToTicket(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAddSignatureToTicketMutationResult = NonNullable<Awaited<ReturnType<typeof postAddSignatureToTicket>>>
    export type PostAddSignatureToTicketMutationBody = BodyType<AddSignatureDTO>
    export type PostAddSignatureToTicketMutationError = ErrorType<unknown>

    export const usePostAddSignatureToTicket = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAddSignatureToTicket>>, TError,{id: string;data: BodyType<AddSignatureDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postAddSignatureToTicket>>,
        TError,
        {id: string;data: BodyType<AddSignatureDTO>},
        TContext
      > => {

      const mutationOptions = getPostAddSignatureToTicketMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getFetchSignature = (
    id: MaybeRef<string>,
 options?: SecondParameter<typeof axios>,signal?: AbortSignal
) => {
      id = unref(id);
      
      return axios<NestedSignature>(
      {url: `/api/ticket/${id}/signature`, method: 'GET', signal
    },
      options);
    }
  

export const getGetFetchSignatureQueryKey = (id: MaybeRef<string>,) => {
    return ['api','ticket',id,'signature'] as const;
    }

    
export const getGetFetchSignatureQueryOptions = <TData = Awaited<ReturnType<typeof getFetchSignature>>, TError = ErrorType<unknown>>(id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFetchSignature>>, TError, TData>>, request?: SecondParameter<typeof axios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getGetFetchSignatureQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFetchSignature>>> = ({ signal }) => getFetchSignature(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: computed(() => !!(unref(id))), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFetchSignature>>, TError, TData> 
}

export type GetFetchSignatureQueryResult = NonNullable<Awaited<ReturnType<typeof getFetchSignature>>>
export type GetFetchSignatureQueryError = ErrorType<unknown>

export const useGetFetchSignature = <TData = Awaited<ReturnType<typeof getFetchSignature>>, TError = ErrorType<unknown>>(
 id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFetchSignature>>, TError, TData>>, request?: SecondParameter<typeof axios>}

  ): UseQueryReturnType<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetFetchSignatureQueryOptions(id,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: QueryKey };

  query.queryKey = unref(queryOptions).queryKey as QueryKey;

  return query;
}




export const getFetchFile = (
    id: MaybeRef<string>,
 options?: SecondParameter<typeof axios>,signal?: AbortSignal
) => {
      id = unref(id);
      
      return axios<FetchFileResponse>(
      {url: `/api/file/${id}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetFetchFileQueryKey = (id: MaybeRef<string>,) => {
    return ['api','file',id] as const;
    }

    
export const getGetFetchFileQueryOptions = <TData = Awaited<ReturnType<typeof getFetchFile>>, TError = ErrorType<unknown>>(id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFetchFile>>, TError, TData>>, request?: SecondParameter<typeof axios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getGetFetchFileQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFetchFile>>> = ({ signal }) => getFetchFile(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: computed(() => !!(unref(id))), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFetchFile>>, TError, TData> 
}

export type GetFetchFileQueryResult = NonNullable<Awaited<ReturnType<typeof getFetchFile>>>
export type GetFetchFileQueryError = ErrorType<unknown>

export const useGetFetchFile = <TData = Awaited<ReturnType<typeof getFetchFile>>, TError = ErrorType<unknown>>(
 id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFetchFile>>, TError, TData>>, request?: SecondParameter<typeof axios>}

  ): UseQueryReturnType<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetFetchFileQueryOptions(id,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: QueryKey };

  query.queryKey = unref(queryOptions).queryKey as QueryKey;

  return query;
}




/**
 * Fetch file in base64 format from ticket service
 * @summary Get file as base64 by ID
 */
export const getFetchFileBase64 = (
    id: MaybeRef<string>,
 options?: SecondParameter<typeof axios>,signal?: AbortSignal
) => {
      id = unref(id);
      
      return axios<void>(
      {url: `/api/file/${id}/base64`, method: 'GET', signal
    },
      options);
    }
  

export const getGetFetchFileBase64QueryKey = (id: MaybeRef<string>,) => {
    return ['api','file',id,'base64'] as const;
    }

    
export const getGetFetchFileBase64QueryOptions = <TData = Awaited<ReturnType<typeof getFetchFileBase64>>, TError = ErrorType<unknown>>(id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFetchFileBase64>>, TError, TData>>, request?: SecondParameter<typeof axios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getGetFetchFileBase64QueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFetchFileBase64>>> = ({ signal }) => getFetchFileBase64(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: computed(() => !!(unref(id))), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFetchFileBase64>>, TError, TData> 
}

export type GetFetchFileBase64QueryResult = NonNullable<Awaited<ReturnType<typeof getFetchFileBase64>>>
export type GetFetchFileBase64QueryError = ErrorType<unknown>

/**
 * @summary Get file as base64 by ID
 */
export const useGetFetchFileBase64 = <TData = Awaited<ReturnType<typeof getFetchFileBase64>>, TError = ErrorType<unknown>>(
 id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFetchFileBase64>>, TError, TData>>, request?: SecondParameter<typeof axios>}

  ): UseQueryReturnType<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetFetchFileBase64QueryOptions(id,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: QueryKey };

  query.queryKey = unref(queryOptions).queryKey as QueryKey;

  return query;
}




export const getFetchUser = (
    id: MaybeRef<string>,
 options?: SecondParameter<typeof axios>,signal?: AbortSignal
) => {
      id = unref(id);
      
      return axios<FetchUserResponse>(
      {url: `/api/user/${id}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetFetchUserQueryKey = (id: MaybeRef<string>,) => {
    return ['api','user',id] as const;
    }

    
export const getGetFetchUserQueryOptions = <TData = Awaited<ReturnType<typeof getFetchUser>>, TError = ErrorType<unknown>>(id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFetchUser>>, TError, TData>>, request?: SecondParameter<typeof axios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getGetFetchUserQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFetchUser>>> = ({ signal }) => getFetchUser(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: computed(() => !!(unref(id))), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFetchUser>>, TError, TData> 
}

export type GetFetchUserQueryResult = NonNullable<Awaited<ReturnType<typeof getFetchUser>>>
export type GetFetchUserQueryError = ErrorType<unknown>

export const useGetFetchUser = <TData = Awaited<ReturnType<typeof getFetchUser>>, TError = ErrorType<unknown>>(
 id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFetchUser>>, TError, TData>>, request?: SecondParameter<typeof axios>}

  ): UseQueryReturnType<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetFetchUserQueryOptions(id,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: QueryKey };

  query.queryKey = unref(queryOptions).queryKey as QueryKey;

  return query;
}




export const postFetchAllUsers = (
    userFiltersDTO: MaybeRef<UserFiltersDTO>,
    params?: MaybeRef<PostFetchAllUsersParams>,
 options?: SecondParameter<typeof axios>,) => {
      userFiltersDTO = unref(userFiltersDTO);
params = unref(params);
      
      return axios<FetchAllUsers>(
      {url: `/api/users`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: userFiltersDTO,
        params: unref(params)
    },
      options);
    }
  


export const getPostFetchAllUsersMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postFetchAllUsers>>, TError,{data: BodyType<UserFiltersDTO>;params?: PostFetchAllUsersParams}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postFetchAllUsers>>, TError,{data: BodyType<UserFiltersDTO>;params?: PostFetchAllUsersParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postFetchAllUsers>>, {data: BodyType<UserFiltersDTO>;params?: PostFetchAllUsersParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postFetchAllUsers(data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostFetchAllUsersMutationResult = NonNullable<Awaited<ReturnType<typeof postFetchAllUsers>>>
    export type PostFetchAllUsersMutationBody = BodyType<UserFiltersDTO>
    export type PostFetchAllUsersMutationError = ErrorType<unknown>

    export const usePostFetchAllUsers = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postFetchAllUsers>>, TError,{data: BodyType<UserFiltersDTO>;params?: PostFetchAllUsersParams}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postFetchAllUsers>>,
        TError,
        {data: BodyType<UserFiltersDTO>;params?: PostFetchAllUsersParams},
        TContext
      > => {

      const mutationOptions = getPostFetchAllUsersMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postCreateUser = (
    createUserDTO: MaybeRef<CreateUserDTO>,
 options?: SecondParameter<typeof axios>,) => {
      createUserDTO = unref(createUserDTO);
      
      return axios<CreateResponse>(
      {url: `/api/user`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createUserDTO
    },
      options);
    }
  


export const getPostCreateUserMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCreateUser>>, TError,{data: BodyType<CreateUserDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postCreateUser>>, TError,{data: BodyType<CreateUserDTO>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCreateUser>>, {data: BodyType<CreateUserDTO>}> = (props) => {
          const {data} = props ?? {};

          return  postCreateUser(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostCreateUserMutationResult = NonNullable<Awaited<ReturnType<typeof postCreateUser>>>
    export type PostCreateUserMutationBody = BodyType<CreateUserDTO>
    export type PostCreateUserMutationError = ErrorType<unknown>

    export const usePostCreateUser = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCreateUser>>, TError,{data: BodyType<CreateUserDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postCreateUser>>,
        TError,
        {data: BodyType<CreateUserDTO>},
        TContext
      > => {

      const mutationOptions = getPostCreateUserMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getFetchUserAssignee = (
    id: MaybeRef<string>,
 options?: SecondParameter<typeof axios>,signal?: AbortSignal
) => {
      id = unref(id);
      
      return axios<FetchAssigneeResponse>(
      {url: `/api/user/${id}/assignee`, method: 'GET', signal
    },
      options);
    }
  

export const getGetFetchUserAssigneeQueryKey = (id: MaybeRef<string>,) => {
    return ['api','user',id,'assignee'] as const;
    }

    
export const getGetFetchUserAssigneeQueryOptions = <TData = Awaited<ReturnType<typeof getFetchUserAssignee>>, TError = ErrorType<unknown>>(id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFetchUserAssignee>>, TError, TData>>, request?: SecondParameter<typeof axios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getGetFetchUserAssigneeQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFetchUserAssignee>>> = ({ signal }) => getFetchUserAssignee(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: computed(() => !!(unref(id))), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFetchUserAssignee>>, TError, TData> 
}

export type GetFetchUserAssigneeQueryResult = NonNullable<Awaited<ReturnType<typeof getFetchUserAssignee>>>
export type GetFetchUserAssigneeQueryError = ErrorType<unknown>

export const useGetFetchUserAssignee = <TData = Awaited<ReturnType<typeof getFetchUserAssignee>>, TError = ErrorType<unknown>>(
 id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFetchUserAssignee>>, TError, TData>>, request?: SecondParameter<typeof axios>}

  ): UseQueryReturnType<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetFetchUserAssigneeQueryOptions(id,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: QueryKey };

  query.queryKey = unref(queryOptions).queryKey as QueryKey;

  return query;
}




export const postUpdateOrganisationContactPerson = (
    id: MaybeRef<string>,
    updateTicketOrganisationContactPersonDTO: MaybeRef<UpdateTicketOrganisationContactPersonDTO>,
 options?: SecondParameter<typeof axios>,) => {
      id = unref(id);
updateTicketOrganisationContactPersonDTO = unref(updateTicketOrganisationContactPersonDTO);
      
      return axios<void>(
      {url: `/api/ticket/${id}/update-organisation-contact-person`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: updateTicketOrganisationContactPersonDTO
    },
      options);
    }
  


export const getPostUpdateOrganisationContactPersonMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUpdateOrganisationContactPerson>>, TError,{id: string;data: BodyType<UpdateTicketOrganisationContactPersonDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postUpdateOrganisationContactPerson>>, TError,{id: string;data: BodyType<UpdateTicketOrganisationContactPersonDTO>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postUpdateOrganisationContactPerson>>, {id: string;data: BodyType<UpdateTicketOrganisationContactPersonDTO>}> = (props) => {
          const {id,data} = props ?? {};

          return  postUpdateOrganisationContactPerson(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostUpdateOrganisationContactPersonMutationResult = NonNullable<Awaited<ReturnType<typeof postUpdateOrganisationContactPerson>>>
    export type PostUpdateOrganisationContactPersonMutationBody = BodyType<UpdateTicketOrganisationContactPersonDTO>
    export type PostUpdateOrganisationContactPersonMutationError = ErrorType<unknown>

    export const usePostUpdateOrganisationContactPerson = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUpdateOrganisationContactPerson>>, TError,{id: string;data: BodyType<UpdateTicketOrganisationContactPersonDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postUpdateOrganisationContactPerson>>,
        TError,
        {id: string;data: BodyType<UpdateTicketOrganisationContactPersonDTO>},
        TContext
      > => {

      const mutationOptions = getPostUpdateOrganisationContactPersonMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postUpdateSiteContactPerson = (
    id: MaybeRef<string>,
    updateTicketSiteContactPerson: MaybeRef<UpdateTicketSiteContactPerson>,
 options?: SecondParameter<typeof axios>,) => {
      id = unref(id);
updateTicketSiteContactPerson = unref(updateTicketSiteContactPerson);
      
      return axios<void>(
      {url: `/api/ticket/${id}/update-site-contact-person`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: updateTicketSiteContactPerson
    },
      options);
    }
  


export const getPostUpdateSiteContactPersonMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUpdateSiteContactPerson>>, TError,{id: string;data: BodyType<UpdateTicketSiteContactPerson>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postUpdateSiteContactPerson>>, TError,{id: string;data: BodyType<UpdateTicketSiteContactPerson>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postUpdateSiteContactPerson>>, {id: string;data: BodyType<UpdateTicketSiteContactPerson>}> = (props) => {
          const {id,data} = props ?? {};

          return  postUpdateSiteContactPerson(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostUpdateSiteContactPersonMutationResult = NonNullable<Awaited<ReturnType<typeof postUpdateSiteContactPerson>>>
    export type PostUpdateSiteContactPersonMutationBody = BodyType<UpdateTicketSiteContactPerson>
    export type PostUpdateSiteContactPersonMutationError = ErrorType<unknown>

    export const usePostUpdateSiteContactPerson = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUpdateSiteContactPerson>>, TError,{id: string;data: BodyType<UpdateTicketSiteContactPerson>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postUpdateSiteContactPerson>>,
        TError,
        {id: string;data: BodyType<UpdateTicketSiteContactPerson>},
        TContext
      > => {

      const mutationOptions = getPostUpdateSiteContactPersonMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const deleteRemoveActionLabourFromAssignment = (
    id: MaybeRef<string>,
    actionLabourId: MaybeRef<string>,
 options?: SecondParameter<typeof axios>,) => {
      id = unref(id);
actionLabourId = unref(actionLabourId);
      
      return axios<void>(
      {url: `/api/assignment/${id}/action-labour/${actionLabourId}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteRemoveActionLabourFromAssignmentMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteRemoveActionLabourFromAssignment>>, TError,{id: string;actionLabourId: string}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteRemoveActionLabourFromAssignment>>, TError,{id: string;actionLabourId: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteRemoveActionLabourFromAssignment>>, {id: string;actionLabourId: string}> = (props) => {
          const {id,actionLabourId} = props ?? {};

          return  deleteRemoveActionLabourFromAssignment(id,actionLabourId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteRemoveActionLabourFromAssignmentMutationResult = NonNullable<Awaited<ReturnType<typeof deleteRemoveActionLabourFromAssignment>>>
    
    export type DeleteRemoveActionLabourFromAssignmentMutationError = ErrorType<unknown>

    export const useDeleteRemoveActionLabourFromAssignment = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteRemoveActionLabourFromAssignment>>, TError,{id: string;actionLabourId: string}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof deleteRemoveActionLabourFromAssignment>>,
        TError,
        {id: string;actionLabourId: string},
        TContext
      > => {

      const mutationOptions = getDeleteRemoveActionLabourFromAssignmentMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const deleteRemoveAssigneeFromAssignment = (
    id: MaybeRef<string>,
    assigneeId: MaybeRef<string>,
 options?: SecondParameter<typeof axios>,) => {
      id = unref(id);
assigneeId = unref(assigneeId);
      
      return axios<void>(
      {url: `/api/assignment/${id}/assignee/${assigneeId}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteRemoveAssigneeFromAssignmentMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteRemoveAssigneeFromAssignment>>, TError,{id: string;assigneeId: string}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteRemoveAssigneeFromAssignment>>, TError,{id: string;assigneeId: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteRemoveAssigneeFromAssignment>>, {id: string;assigneeId: string}> = (props) => {
          const {id,assigneeId} = props ?? {};

          return  deleteRemoveAssigneeFromAssignment(id,assigneeId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteRemoveAssigneeFromAssignmentMutationResult = NonNullable<Awaited<ReturnType<typeof deleteRemoveAssigneeFromAssignment>>>
    
    export type DeleteRemoveAssigneeFromAssignmentMutationError = ErrorType<unknown>

    export const useDeleteRemoveAssigneeFromAssignment = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteRemoveAssigneeFromAssignment>>, TError,{id: string;assigneeId: string}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof deleteRemoveAssigneeFromAssignment>>,
        TError,
        {id: string;assigneeId: string},
        TContext
      > => {

      const mutationOptions = getDeleteRemoveAssigneeFromAssignmentMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const deleteRemoveArticleAssociationFromTicket = (
    id: MaybeRef<string>,
    articleAssociationId: MaybeRef<string>,
 options?: SecondParameter<typeof axios>,) => {
      id = unref(id);
articleAssociationId = unref(articleAssociationId);
      
      return axios<void>(
      {url: `/api/ticket/${id}/article-association/${articleAssociationId}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteRemoveArticleAssociationFromTicketMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteRemoveArticleAssociationFromTicket>>, TError,{id: string;articleAssociationId: string}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteRemoveArticleAssociationFromTicket>>, TError,{id: string;articleAssociationId: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteRemoveArticleAssociationFromTicket>>, {id: string;articleAssociationId: string}> = (props) => {
          const {id,articleAssociationId} = props ?? {};

          return  deleteRemoveArticleAssociationFromTicket(id,articleAssociationId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteRemoveArticleAssociationFromTicketMutationResult = NonNullable<Awaited<ReturnType<typeof deleteRemoveArticleAssociationFromTicket>>>
    
    export type DeleteRemoveArticleAssociationFromTicketMutationError = ErrorType<unknown>

    export const useDeleteRemoveArticleAssociationFromTicket = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteRemoveArticleAssociationFromTicket>>, TError,{id: string;articleAssociationId: string}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof deleteRemoveArticleAssociationFromTicket>>,
        TError,
        {id: string;articleAssociationId: string},
        TContext
      > => {

      const mutationOptions = getDeleteRemoveArticleAssociationFromTicketMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postFetchAllStatuses = (
    
 options?: SecondParameter<typeof axios>,) => {
      
      
      return axios<FetchAllTicketStatus>(
      {url: `/api/ticket-statuses`, method: 'POST'
    },
      options);
    }
  


export const getPostFetchAllStatusesMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postFetchAllStatuses>>, TError,void, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postFetchAllStatuses>>, TError,void, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postFetchAllStatuses>>, void> = () => {
          

          return  postFetchAllStatuses(requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostFetchAllStatusesMutationResult = NonNullable<Awaited<ReturnType<typeof postFetchAllStatuses>>>
    
    export type PostFetchAllStatusesMutationError = ErrorType<unknown>

    export const usePostFetchAllStatuses = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postFetchAllStatuses>>, TError,void, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postFetchAllStatuses>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getPostFetchAllStatusesMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postCreateTicketStatus = (
    createTicketStatusDTO: MaybeRef<CreateTicketStatusDTO>,
 options?: SecondParameter<typeof axios>,) => {
      createTicketStatusDTO = unref(createTicketStatusDTO);
      
      return axios<CreateResponse>(
      {url: `/api/ticket-status`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createTicketStatusDTO
    },
      options);
    }
  


export const getPostCreateTicketStatusMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCreateTicketStatus>>, TError,{data: BodyType<CreateTicketStatusDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postCreateTicketStatus>>, TError,{data: BodyType<CreateTicketStatusDTO>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCreateTicketStatus>>, {data: BodyType<CreateTicketStatusDTO>}> = (props) => {
          const {data} = props ?? {};

          return  postCreateTicketStatus(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostCreateTicketStatusMutationResult = NonNullable<Awaited<ReturnType<typeof postCreateTicketStatus>>>
    export type PostCreateTicketStatusMutationBody = BodyType<CreateTicketStatusDTO>
    export type PostCreateTicketStatusMutationError = ErrorType<unknown>

    export const usePostCreateTicketStatus = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCreateTicketStatus>>, TError,{data: BodyType<CreateTicketStatusDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postCreateTicketStatus>>,
        TError,
        {data: BodyType<CreateTicketStatusDTO>},
        TContext
      > => {

      const mutationOptions = getPostCreateTicketStatusMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postUpdateArticleAssociationQuantity = (
    id: MaybeRef<string>,
    updateTicketArticleAssociationQuantity: MaybeRef<UpdateTicketArticleAssociationQuantity>,
 options?: SecondParameter<typeof axios>,) => {
      id = unref(id);
updateTicketArticleAssociationQuantity = unref(updateTicketArticleAssociationQuantity);
      
      return axios<void>(
      {url: `/api/ticket/article-association/${id}/quantity`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: updateTicketArticleAssociationQuantity
    },
      options);
    }
  


export const getPostUpdateArticleAssociationQuantityMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUpdateArticleAssociationQuantity>>, TError,{id: string;data: BodyType<UpdateTicketArticleAssociationQuantity>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postUpdateArticleAssociationQuantity>>, TError,{id: string;data: BodyType<UpdateTicketArticleAssociationQuantity>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postUpdateArticleAssociationQuantity>>, {id: string;data: BodyType<UpdateTicketArticleAssociationQuantity>}> = (props) => {
          const {id,data} = props ?? {};

          return  postUpdateArticleAssociationQuantity(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostUpdateArticleAssociationQuantityMutationResult = NonNullable<Awaited<ReturnType<typeof postUpdateArticleAssociationQuantity>>>
    export type PostUpdateArticleAssociationQuantityMutationBody = BodyType<UpdateTicketArticleAssociationQuantity>
    export type PostUpdateArticleAssociationQuantityMutationError = ErrorType<unknown>

    export const usePostUpdateArticleAssociationQuantity = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUpdateArticleAssociationQuantity>>, TError,{id: string;data: BodyType<UpdateTicketArticleAssociationQuantity>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postUpdateArticleAssociationQuantity>>,
        TError,
        {id: string;data: BodyType<UpdateTicketArticleAssociationQuantity>},
        TContext
      > => {

      const mutationOptions = getPostUpdateArticleAssociationQuantityMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postUpdateArticleAssociationPrice = (
    id: MaybeRef<string>,
    updateTicketArticleAssociationPriceDTO: MaybeRef<UpdateTicketArticleAssociationPriceDTO>,
 options?: SecondParameter<typeof axios>,) => {
      id = unref(id);
updateTicketArticleAssociationPriceDTO = unref(updateTicketArticleAssociationPriceDTO);
      
      return axios<void>(
      {url: `/api/ticket/article-association/${id}/price`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: updateTicketArticleAssociationPriceDTO
    },
      options);
    }
  


export const getPostUpdateArticleAssociationPriceMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUpdateArticleAssociationPrice>>, TError,{id: string;data: BodyType<UpdateTicketArticleAssociationPriceDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postUpdateArticleAssociationPrice>>, TError,{id: string;data: BodyType<UpdateTicketArticleAssociationPriceDTO>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postUpdateArticleAssociationPrice>>, {id: string;data: BodyType<UpdateTicketArticleAssociationPriceDTO>}> = (props) => {
          const {id,data} = props ?? {};

          return  postUpdateArticleAssociationPrice(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostUpdateArticleAssociationPriceMutationResult = NonNullable<Awaited<ReturnType<typeof postUpdateArticleAssociationPrice>>>
    export type PostUpdateArticleAssociationPriceMutationBody = BodyType<UpdateTicketArticleAssociationPriceDTO>
    export type PostUpdateArticleAssociationPriceMutationError = ErrorType<unknown>

    export const usePostUpdateArticleAssociationPrice = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUpdateArticleAssociationPrice>>, TError,{id: string;data: BodyType<UpdateTicketArticleAssociationPriceDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postUpdateArticleAssociationPrice>>,
        TError,
        {id: string;data: BodyType<UpdateTicketArticleAssociationPriceDTO>},
        TContext
      > => {

      const mutationOptions = getPostUpdateArticleAssociationPriceMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postPinTicket = (
    id: MaybeRef<string>,
 options?: SecondParameter<typeof axios>,) => {
      id = unref(id);
      
      return axios<void>(
      {url: `/api/ticket/${id}/pin`, method: 'POST'
    },
      options);
    }
  


export const getPostPinTicketMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPinTicket>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postPinTicket>>, TError,{id: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postPinTicket>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  postPinTicket(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostPinTicketMutationResult = NonNullable<Awaited<ReturnType<typeof postPinTicket>>>
    
    export type PostPinTicketMutationError = ErrorType<unknown>

    export const usePostPinTicket = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPinTicket>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postPinTicket>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getPostPinTicketMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postUnpinTicket = (
    id: MaybeRef<string>,
 options?: SecondParameter<typeof axios>,) => {
      id = unref(id);
      
      return axios<void>(
      {url: `/api/ticket/${id}/unpin`, method: 'POST'
    },
      options);
    }
  


export const getPostUnpinTicketMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUnpinTicket>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postUnpinTicket>>, TError,{id: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postUnpinTicket>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  postUnpinTicket(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostUnpinTicketMutationResult = NonNullable<Awaited<ReturnType<typeof postUnpinTicket>>>
    
    export type PostUnpinTicketMutationError = ErrorType<unknown>

    export const usePostUnpinTicket = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUnpinTicket>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postUnpinTicket>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getPostUnpinTicketMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const putUpdateAssignmentAction = (
    id: MaybeRef<string>,
    updateAssignmentAbstractActionDTO: MaybeRef<UpdateAssignmentAbstractActionDTO>,
 options?: SecondParameter<typeof axios>,) => {
      id = unref(id);
updateAssignmentAbstractActionDTO = unref(updateAssignmentAbstractActionDTO);
      
      return axios<void>(
      {url: `/api/assignment/${id}/update-abstract-action`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateAssignmentAbstractActionDTO
    },
      options);
    }
  


export const getPutUpdateAssignmentActionMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putUpdateAssignmentAction>>, TError,{id: string;data: BodyType<UpdateAssignmentAbstractActionDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof putUpdateAssignmentAction>>, TError,{id: string;data: BodyType<UpdateAssignmentAbstractActionDTO>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putUpdateAssignmentAction>>, {id: string;data: BodyType<UpdateAssignmentAbstractActionDTO>}> = (props) => {
          const {id,data} = props ?? {};

          return  putUpdateAssignmentAction(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutUpdateAssignmentActionMutationResult = NonNullable<Awaited<ReturnType<typeof putUpdateAssignmentAction>>>
    export type PutUpdateAssignmentActionMutationBody = BodyType<UpdateAssignmentAbstractActionDTO>
    export type PutUpdateAssignmentActionMutationError = ErrorType<unknown>

    export const usePutUpdateAssignmentAction = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putUpdateAssignmentAction>>, TError,{id: string;data: BodyType<UpdateAssignmentAbstractActionDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof putUpdateAssignmentAction>>,
        TError,
        {id: string;data: BodyType<UpdateAssignmentAbstractActionDTO>},
        TContext
      > => {

      const mutationOptions = getPutUpdateAssignmentActionMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Fetch hours worked by a mechanic
 */
export const postFetchHoursWorkedByMechanic = (
    id: MaybeRef<string>,
    fetchAllBookedHoursDTO: MaybeRef<FetchAllBookedHoursDTO>,
    params?: MaybeRef<PostFetchHoursWorkedByMechanicParams>,
 options?: SecondParameter<typeof axios>,) => {
      id = unref(id);
fetchAllBookedHoursDTO = unref(fetchAllBookedHoursDTO);
params = unref(params);
      
      return axios<FetchAllBookedHours>(
      {url: `/api/action-labour/assignee/${id}/booked-hours`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: fetchAllBookedHoursDTO,
        params: unref(params)
    },
      options);
    }
  


export const getPostFetchHoursWorkedByMechanicMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postFetchHoursWorkedByMechanic>>, TError,{id: string;data: BodyType<FetchAllBookedHoursDTO>;params?: PostFetchHoursWorkedByMechanicParams}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postFetchHoursWorkedByMechanic>>, TError,{id: string;data: BodyType<FetchAllBookedHoursDTO>;params?: PostFetchHoursWorkedByMechanicParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postFetchHoursWorkedByMechanic>>, {id: string;data: BodyType<FetchAllBookedHoursDTO>;params?: PostFetchHoursWorkedByMechanicParams}> = (props) => {
          const {id,data,params} = props ?? {};

          return  postFetchHoursWorkedByMechanic(id,data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostFetchHoursWorkedByMechanicMutationResult = NonNullable<Awaited<ReturnType<typeof postFetchHoursWorkedByMechanic>>>
    export type PostFetchHoursWorkedByMechanicMutationBody = BodyType<FetchAllBookedHoursDTO>
    export type PostFetchHoursWorkedByMechanicMutationError = ErrorType<unknown>

    /**
 * @summary Fetch hours worked by a mechanic
 */
export const usePostFetchHoursWorkedByMechanic = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postFetchHoursWorkedByMechanic>>, TError,{id: string;data: BodyType<FetchAllBookedHoursDTO>;params?: PostFetchHoursWorkedByMechanicParams}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postFetchHoursWorkedByMechanic>>,
        TError,
        {id: string;data: BodyType<FetchAllBookedHoursDTO>;params?: PostFetchHoursWorkedByMechanicParams},
        TContext
      > => {

      const mutationOptions = getPostFetchHoursWorkedByMechanicMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Fetch price of the ticket
 * @summary Get price of the ticket
 */
export const postPriceTicket = (
    id: MaybeRef<string>,
 options?: SecondParameter<typeof axios>,) => {
      id = unref(id);
      
      return axios<void>(
      {url: `/api/ticket/${id}/price`, method: 'POST'
    },
      options);
    }
  


export const getPostPriceTicketMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPriceTicket>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postPriceTicket>>, TError,{id: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postPriceTicket>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  postPriceTicket(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostPriceTicketMutationResult = NonNullable<Awaited<ReturnType<typeof postPriceTicket>>>
    
    export type PostPriceTicketMutationError = ErrorType<unknown>

    /**
 * @summary Get price of the ticket
 */
export const usePostPriceTicket = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPriceTicket>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postPriceTicket>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getPostPriceTicketMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getFetchActionItem = (
    id: MaybeRef<string>,
 options?: SecondParameter<typeof axios>,signal?: AbortSignal
) => {
      id = unref(id);
      
      return axios<FetchActionItemResponse>(
      {url: `/api/action-item/${id}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetFetchActionItemQueryKey = (id: MaybeRef<string>,) => {
    return ['api','action-item',id] as const;
    }

    
export const getGetFetchActionItemQueryOptions = <TData = Awaited<ReturnType<typeof getFetchActionItem>>, TError = ErrorType<unknown>>(id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFetchActionItem>>, TError, TData>>, request?: SecondParameter<typeof axios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getGetFetchActionItemQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFetchActionItem>>> = ({ signal }) => getFetchActionItem(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: computed(() => !!(unref(id))), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFetchActionItem>>, TError, TData> 
}

export type GetFetchActionItemQueryResult = NonNullable<Awaited<ReturnType<typeof getFetchActionItem>>>
export type GetFetchActionItemQueryError = ErrorType<unknown>

export const useGetFetchActionItem = <TData = Awaited<ReturnType<typeof getFetchActionItem>>, TError = ErrorType<unknown>>(
 id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFetchActionItem>>, TError, TData>>, request?: SecondParameter<typeof axios>}

  ): UseQueryReturnType<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetFetchActionItemQueryOptions(id,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: QueryKey };

  query.queryKey = unref(queryOptions).queryKey as QueryKey;

  return query;
}




export const putUpdateActionItem = (
    id: MaybeRef<string>,
    updateActionItemDTO: MaybeRef<UpdateActionItemDTO>,
 options?: SecondParameter<typeof axios>,) => {
      id = unref(id);
updateActionItemDTO = unref(updateActionItemDTO);
      
      return axios<void>(
      {url: `/api/action-item/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateActionItemDTO
    },
      options);
    }
  


export const getPutUpdateActionItemMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putUpdateActionItem>>, TError,{id: string;data: BodyType<UpdateActionItemDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof putUpdateActionItem>>, TError,{id: string;data: BodyType<UpdateActionItemDTO>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putUpdateActionItem>>, {id: string;data: BodyType<UpdateActionItemDTO>}> = (props) => {
          const {id,data} = props ?? {};

          return  putUpdateActionItem(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutUpdateActionItemMutationResult = NonNullable<Awaited<ReturnType<typeof putUpdateActionItem>>>
    export type PutUpdateActionItemMutationBody = BodyType<UpdateActionItemDTO>
    export type PutUpdateActionItemMutationError = ErrorType<unknown>

    export const usePutUpdateActionItem = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putUpdateActionItem>>, TError,{id: string;data: BodyType<UpdateActionItemDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof putUpdateActionItem>>,
        TError,
        {id: string;data: BodyType<UpdateActionItemDTO>},
        TContext
      > => {

      const mutationOptions = getPutUpdateActionItemMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postFetchAllActionItems = (
    actionItemFiltersDTO: MaybeRef<ActionItemFiltersDTO>,
    params?: MaybeRef<PostFetchAllActionItemsParams>,
 options?: SecondParameter<typeof axios>,) => {
      actionItemFiltersDTO = unref(actionItemFiltersDTO);
params = unref(params);
      
      return axios<FetchAllActionItems>(
      {url: `/api/action-items`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: actionItemFiltersDTO,
        params: unref(params)
    },
      options);
    }
  


export const getPostFetchAllActionItemsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postFetchAllActionItems>>, TError,{data: BodyType<ActionItemFiltersDTO>;params?: PostFetchAllActionItemsParams}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postFetchAllActionItems>>, TError,{data: BodyType<ActionItemFiltersDTO>;params?: PostFetchAllActionItemsParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postFetchAllActionItems>>, {data: BodyType<ActionItemFiltersDTO>;params?: PostFetchAllActionItemsParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postFetchAllActionItems(data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostFetchAllActionItemsMutationResult = NonNullable<Awaited<ReturnType<typeof postFetchAllActionItems>>>
    export type PostFetchAllActionItemsMutationBody = BodyType<ActionItemFiltersDTO>
    export type PostFetchAllActionItemsMutationError = ErrorType<unknown>

    export const usePostFetchAllActionItems = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postFetchAllActionItems>>, TError,{data: BodyType<ActionItemFiltersDTO>;params?: PostFetchAllActionItemsParams}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postFetchAllActionItems>>,
        TError,
        {data: BodyType<ActionItemFiltersDTO>;params?: PostFetchAllActionItemsParams},
        TContext
      > => {

      const mutationOptions = getPostFetchAllActionItemsMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postCreateActionItem = (
    createActionItemDTO: MaybeRef<CreateActionItemDTO>,
 options?: SecondParameter<typeof axios>,) => {
      createActionItemDTO = unref(createActionItemDTO);
      
      return axios<CreateResponse>(
      {url: `/api/action-item`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createActionItemDTO
    },
      options);
    }
  


export const getPostCreateActionItemMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCreateActionItem>>, TError,{data: BodyType<CreateActionItemDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postCreateActionItem>>, TError,{data: BodyType<CreateActionItemDTO>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCreateActionItem>>, {data: BodyType<CreateActionItemDTO>}> = (props) => {
          const {data} = props ?? {};

          return  postCreateActionItem(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostCreateActionItemMutationResult = NonNullable<Awaited<ReturnType<typeof postCreateActionItem>>>
    export type PostCreateActionItemMutationBody = BodyType<CreateActionItemDTO>
    export type PostCreateActionItemMutationError = ErrorType<unknown>

    export const usePostCreateActionItem = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCreateActionItem>>, TError,{data: BodyType<CreateActionItemDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postCreateActionItem>>,
        TError,
        {data: BodyType<CreateActionItemDTO>},
        TContext
      > => {

      const mutationOptions = getPostCreateActionItemMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getFetchCategory = (
    id: MaybeRef<string>,
 options?: SecondParameter<typeof axios>,signal?: AbortSignal
) => {
      id = unref(id);
      
      return axios<FetchCategoryResponse>(
      {url: `/api/category/${id}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetFetchCategoryQueryKey = (id: MaybeRef<string>,) => {
    return ['api','category',id] as const;
    }

    
export const getGetFetchCategoryQueryOptions = <TData = Awaited<ReturnType<typeof getFetchCategory>>, TError = ErrorType<unknown>>(id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFetchCategory>>, TError, TData>>, request?: SecondParameter<typeof axios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getGetFetchCategoryQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFetchCategory>>> = ({ signal }) => getFetchCategory(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: computed(() => !!(unref(id))), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFetchCategory>>, TError, TData> 
}

export type GetFetchCategoryQueryResult = NonNullable<Awaited<ReturnType<typeof getFetchCategory>>>
export type GetFetchCategoryQueryError = ErrorType<unknown>

export const useGetFetchCategory = <TData = Awaited<ReturnType<typeof getFetchCategory>>, TError = ErrorType<unknown>>(
 id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFetchCategory>>, TError, TData>>, request?: SecondParameter<typeof axios>}

  ): UseQueryReturnType<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetFetchCategoryQueryOptions(id,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: QueryKey };

  query.queryKey = unref(queryOptions).queryKey as QueryKey;

  return query;
}




export const putUpdateCategory = (
    id: MaybeRef<string>,
    categoryDTO: MaybeRef<CategoryDTO>,
 options?: SecondParameter<typeof axios>,) => {
      id = unref(id);
categoryDTO = unref(categoryDTO);
      
      return axios<void>(
      {url: `/api/category/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: categoryDTO
    },
      options);
    }
  


export const getPutUpdateCategoryMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putUpdateCategory>>, TError,{id: string;data: BodyType<CategoryDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof putUpdateCategory>>, TError,{id: string;data: BodyType<CategoryDTO>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putUpdateCategory>>, {id: string;data: BodyType<CategoryDTO>}> = (props) => {
          const {id,data} = props ?? {};

          return  putUpdateCategory(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutUpdateCategoryMutationResult = NonNullable<Awaited<ReturnType<typeof putUpdateCategory>>>
    export type PutUpdateCategoryMutationBody = BodyType<CategoryDTO>
    export type PutUpdateCategoryMutationError = ErrorType<unknown>

    export const usePutUpdateCategory = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putUpdateCategory>>, TError,{id: string;data: BodyType<CategoryDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof putUpdateCategory>>,
        TError,
        {id: string;data: BodyType<CategoryDTO>},
        TContext
      > => {

      const mutationOptions = getPutUpdateCategoryMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postFetchAllCategories = (
    categoryFiltersDTO: MaybeRef<CategoryFiltersDTO>,
    params?: MaybeRef<PostFetchAllCategoriesParams>,
 options?: SecondParameter<typeof axios>,) => {
      categoryFiltersDTO = unref(categoryFiltersDTO);
params = unref(params);
      
      return axios<FetchAllCategoriesResponse>(
      {url: `/api/categories`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: categoryFiltersDTO,
        params: unref(params)
    },
      options);
    }
  


export const getPostFetchAllCategoriesMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postFetchAllCategories>>, TError,{data: BodyType<CategoryFiltersDTO>;params?: PostFetchAllCategoriesParams}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postFetchAllCategories>>, TError,{data: BodyType<CategoryFiltersDTO>;params?: PostFetchAllCategoriesParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postFetchAllCategories>>, {data: BodyType<CategoryFiltersDTO>;params?: PostFetchAllCategoriesParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postFetchAllCategories(data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostFetchAllCategoriesMutationResult = NonNullable<Awaited<ReturnType<typeof postFetchAllCategories>>>
    export type PostFetchAllCategoriesMutationBody = BodyType<CategoryFiltersDTO>
    export type PostFetchAllCategoriesMutationError = ErrorType<unknown>

    export const usePostFetchAllCategories = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postFetchAllCategories>>, TError,{data: BodyType<CategoryFiltersDTO>;params?: PostFetchAllCategoriesParams}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postFetchAllCategories>>,
        TError,
        {data: BodyType<CategoryFiltersDTO>;params?: PostFetchAllCategoriesParams},
        TContext
      > => {

      const mutationOptions = getPostFetchAllCategoriesMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postCreateCategory = (
    categoryDTO: MaybeRef<CategoryDTO>,
 options?: SecondParameter<typeof axios>,) => {
      categoryDTO = unref(categoryDTO);
      
      return axios<CreateResponse>(
      {url: `/api/category`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: categoryDTO
    },
      options);
    }
  


export const getPostCreateCategoryMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCreateCategory>>, TError,{data: BodyType<CategoryDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postCreateCategory>>, TError,{data: BodyType<CategoryDTO>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCreateCategory>>, {data: BodyType<CategoryDTO>}> = (props) => {
          const {data} = props ?? {};

          return  postCreateCategory(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostCreateCategoryMutationResult = NonNullable<Awaited<ReturnType<typeof postCreateCategory>>>
    export type PostCreateCategoryMutationBody = BodyType<CategoryDTO>
    export type PostCreateCategoryMutationError = ErrorType<unknown>

    export const usePostCreateCategory = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCreateCategory>>, TError,{data: BodyType<CategoryDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postCreateCategory>>,
        TError,
        {data: BodyType<CategoryDTO>},
        TContext
      > => {

      const mutationOptions = getPostCreateCategoryMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postAddPropertyToCategory = (
    id: MaybeRef<string>,
    addPropertiesDTO: MaybeRef<AddPropertiesDTO>,
 options?: SecondParameter<typeof axios>,) => {
      id = unref(id);
addPropertiesDTO = unref(addPropertiesDTO);
      
      return axios<void>(
      {url: `/api/category/${id}/add-property`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: addPropertiesDTO
    },
      options);
    }
  


export const getPostAddPropertyToCategoryMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAddPropertyToCategory>>, TError,{id: string;data: BodyType<AddPropertiesDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postAddPropertyToCategory>>, TError,{id: string;data: BodyType<AddPropertiesDTO>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAddPropertyToCategory>>, {id: string;data: BodyType<AddPropertiesDTO>}> = (props) => {
          const {id,data} = props ?? {};

          return  postAddPropertyToCategory(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAddPropertyToCategoryMutationResult = NonNullable<Awaited<ReturnType<typeof postAddPropertyToCategory>>>
    export type PostAddPropertyToCategoryMutationBody = BodyType<AddPropertiesDTO>
    export type PostAddPropertyToCategoryMutationError = ErrorType<unknown>

    export const usePostAddPropertyToCategory = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAddPropertyToCategory>>, TError,{id: string;data: BodyType<AddPropertiesDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postAddPropertyToCategory>>,
        TError,
        {id: string;data: BodyType<AddPropertiesDTO>},
        TContext
      > => {

      const mutationOptions = getPostAddPropertyToCategoryMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postAddPropertyAttributeToCategory = (
    id: MaybeRef<string>,
    addPropertyAttributesDTO: MaybeRef<AddPropertyAttributesDTO>,
 options?: SecondParameter<typeof axios>,) => {
      id = unref(id);
addPropertyAttributesDTO = unref(addPropertyAttributesDTO);
      
      return axios<void>(
      {url: `/api/category/${id}/add-property-attribute`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: addPropertyAttributesDTO
    },
      options);
    }
  


export const getPostAddPropertyAttributeToCategoryMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAddPropertyAttributeToCategory>>, TError,{id: string;data: BodyType<AddPropertyAttributesDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postAddPropertyAttributeToCategory>>, TError,{id: string;data: BodyType<AddPropertyAttributesDTO>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAddPropertyAttributeToCategory>>, {id: string;data: BodyType<AddPropertyAttributesDTO>}> = (props) => {
          const {id,data} = props ?? {};

          return  postAddPropertyAttributeToCategory(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAddPropertyAttributeToCategoryMutationResult = NonNullable<Awaited<ReturnType<typeof postAddPropertyAttributeToCategory>>>
    export type PostAddPropertyAttributeToCategoryMutationBody = BodyType<AddPropertyAttributesDTO>
    export type PostAddPropertyAttributeToCategoryMutationError = ErrorType<unknown>

    export const usePostAddPropertyAttributeToCategory = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAddPropertyAttributeToCategory>>, TError,{id: string;data: BodyType<AddPropertyAttributesDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postAddPropertyAttributeToCategory>>,
        TError,
        {id: string;data: BodyType<AddPropertyAttributesDTO>},
        TContext
      > => {

      const mutationOptions = getPostAddPropertyAttributeToCategoryMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postCreateContract = (
    createContractDTO: MaybeRef<CreateContractDTO>,
 options?: SecondParameter<typeof axios>,) => {
      createContractDTO = unref(createContractDTO);
      
      return axios<CreateResponse>(
      {url: `/api/contract`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createContractDTO
    },
      options);
    }
  


export const getPostCreateContractMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCreateContract>>, TError,{data: BodyType<CreateContractDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postCreateContract>>, TError,{data: BodyType<CreateContractDTO>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCreateContract>>, {data: BodyType<CreateContractDTO>}> = (props) => {
          const {data} = props ?? {};

          return  postCreateContract(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostCreateContractMutationResult = NonNullable<Awaited<ReturnType<typeof postCreateContract>>>
    export type PostCreateContractMutationBody = BodyType<CreateContractDTO>
    export type PostCreateContractMutationError = ErrorType<unknown>

    export const usePostCreateContract = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCreateContract>>, TError,{data: BodyType<CreateContractDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postCreateContract>>,
        TError,
        {data: BodyType<CreateContractDTO>},
        TContext
      > => {

      const mutationOptions = getPostCreateContractMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getFetchContract = (
    id: MaybeRef<string>,
 options?: SecondParameter<typeof axios>,signal?: AbortSignal
) => {
      id = unref(id);
      
      return axios<FetchContractResponse>(
      {url: `/api/contract/${id}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetFetchContractQueryKey = (id: MaybeRef<string>,) => {
    return ['api','contract',id] as const;
    }

    
export const getGetFetchContractQueryOptions = <TData = Awaited<ReturnType<typeof getFetchContract>>, TError = ErrorType<unknown>>(id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFetchContract>>, TError, TData>>, request?: SecondParameter<typeof axios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getGetFetchContractQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFetchContract>>> = ({ signal }) => getFetchContract(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: computed(() => !!(unref(id))), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFetchContract>>, TError, TData> 
}

export type GetFetchContractQueryResult = NonNullable<Awaited<ReturnType<typeof getFetchContract>>>
export type GetFetchContractQueryError = ErrorType<unknown>

export const useGetFetchContract = <TData = Awaited<ReturnType<typeof getFetchContract>>, TError = ErrorType<unknown>>(
 id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFetchContract>>, TError, TData>>, request?: SecondParameter<typeof axios>}

  ): UseQueryReturnType<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetFetchContractQueryOptions(id,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: QueryKey };

  query.queryKey = unref(queryOptions).queryKey as QueryKey;

  return query;
}




export const putUpdateContract = (
    id: MaybeRef<string>,
    updateContractDTO: MaybeRef<UpdateContractDTO>,
 options?: SecondParameter<typeof axios>,) => {
      id = unref(id);
updateContractDTO = unref(updateContractDTO);
      
      return axios<void>(
      {url: `/api/contract/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateContractDTO
    },
      options);
    }
  


export const getPutUpdateContractMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putUpdateContract>>, TError,{id: string;data: BodyType<UpdateContractDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof putUpdateContract>>, TError,{id: string;data: BodyType<UpdateContractDTO>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putUpdateContract>>, {id: string;data: BodyType<UpdateContractDTO>}> = (props) => {
          const {id,data} = props ?? {};

          return  putUpdateContract(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutUpdateContractMutationResult = NonNullable<Awaited<ReturnType<typeof putUpdateContract>>>
    export type PutUpdateContractMutationBody = BodyType<UpdateContractDTO>
    export type PutUpdateContractMutationError = ErrorType<unknown>

    export const usePutUpdateContract = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putUpdateContract>>, TError,{id: string;data: BodyType<UpdateContractDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof putUpdateContract>>,
        TError,
        {id: string;data: BodyType<UpdateContractDTO>},
        TContext
      > => {

      const mutationOptions = getPutUpdateContractMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const patchPatchContract = (
    id: MaybeRef<string>,
    patchContractDTO: MaybeRef<PatchContractDTO>,
 options?: SecondParameter<typeof axios>,) => {
      id = unref(id);
patchContractDTO = unref(patchContractDTO);
      
      return axios<void>(
      {url: `/api/contract/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchContractDTO
    },
      options);
    }
  


export const getPatchPatchContractMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchPatchContract>>, TError,{id: string;data: BodyType<PatchContractDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof patchPatchContract>>, TError,{id: string;data: BodyType<PatchContractDTO>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchPatchContract>>, {id: string;data: BodyType<PatchContractDTO>}> = (props) => {
          const {id,data} = props ?? {};

          return  patchPatchContract(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchPatchContractMutationResult = NonNullable<Awaited<ReturnType<typeof patchPatchContract>>>
    export type PatchPatchContractMutationBody = BodyType<PatchContractDTO>
    export type PatchPatchContractMutationError = ErrorType<unknown>

    export const usePatchPatchContract = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchPatchContract>>, TError,{id: string;data: BodyType<PatchContractDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof patchPatchContract>>,
        TError,
        {id: string;data: BodyType<PatchContractDTO>},
        TContext
      > => {

      const mutationOptions = getPatchPatchContractMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postFetchAllContracts = (
    contractFilterDTO: MaybeRef<ContractFilterDTO>,
    params?: MaybeRef<PostFetchAllContractsParams>,
 options?: SecondParameter<typeof axios>,) => {
      contractFilterDTO = unref(contractFilterDTO);
params = unref(params);
      
      return axios<FetchAllContracts>(
      {url: `/api/contracts`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: contractFilterDTO,
        params: unref(params)
    },
      options);
    }
  


export const getPostFetchAllContractsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postFetchAllContracts>>, TError,{data: BodyType<ContractFilterDTO>;params?: PostFetchAllContractsParams}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postFetchAllContracts>>, TError,{data: BodyType<ContractFilterDTO>;params?: PostFetchAllContractsParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postFetchAllContracts>>, {data: BodyType<ContractFilterDTO>;params?: PostFetchAllContractsParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postFetchAllContracts(data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostFetchAllContractsMutationResult = NonNullable<Awaited<ReturnType<typeof postFetchAllContracts>>>
    export type PostFetchAllContractsMutationBody = BodyType<ContractFilterDTO>
    export type PostFetchAllContractsMutationError = ErrorType<unknown>

    export const usePostFetchAllContracts = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postFetchAllContracts>>, TError,{data: BodyType<ContractFilterDTO>;params?: PostFetchAllContractsParams}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postFetchAllContracts>>,
        TError,
        {data: BodyType<ContractFilterDTO>;params?: PostFetchAllContractsParams},
        TContext
      > => {

      const mutationOptions = getPostFetchAllContractsMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postUpdateContractStatus = (
    id: MaybeRef<string>,
    updateContractStatusDTO: MaybeRef<UpdateContractStatusDTO>,
 options?: SecondParameter<typeof axios>,) => {
      id = unref(id);
updateContractStatusDTO = unref(updateContractStatusDTO);
      
      return axios<void>(
      {url: `/api/contract/${id}/status`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: updateContractStatusDTO
    },
      options);
    }
  


export const getPostUpdateContractStatusMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUpdateContractStatus>>, TError,{id: string;data: BodyType<UpdateContractStatusDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postUpdateContractStatus>>, TError,{id: string;data: BodyType<UpdateContractStatusDTO>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postUpdateContractStatus>>, {id: string;data: BodyType<UpdateContractStatusDTO>}> = (props) => {
          const {id,data} = props ?? {};

          return  postUpdateContractStatus(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostUpdateContractStatusMutationResult = NonNullable<Awaited<ReturnType<typeof postUpdateContractStatus>>>
    export type PostUpdateContractStatusMutationBody = BodyType<UpdateContractStatusDTO>
    export type PostUpdateContractStatusMutationError = ErrorType<unknown>

    export const usePostUpdateContractStatus = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUpdateContractStatus>>, TError,{id: string;data: BodyType<UpdateContractStatusDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postUpdateContractStatus>>,
        TError,
        {id: string;data: BodyType<UpdateContractStatusDTO>},
        TContext
      > => {

      const mutationOptions = getPostUpdateContractStatusMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postAddActionItemToContract = (
    id: MaybeRef<string>,
    addActionItemsToContractDTO: MaybeRef<AddActionItemsToContractDTO>,
 options?: SecondParameter<typeof axios>,) => {
      id = unref(id);
addActionItemsToContractDTO = unref(addActionItemsToContractDTO);
      
      return axios<void>(
      {url: `/api/contract/${id}/add-action-items`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: addActionItemsToContractDTO
    },
      options);
    }
  


export const getPostAddActionItemToContractMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAddActionItemToContract>>, TError,{id: string;data: BodyType<AddActionItemsToContractDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postAddActionItemToContract>>, TError,{id: string;data: BodyType<AddActionItemsToContractDTO>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAddActionItemToContract>>, {id: string;data: BodyType<AddActionItemsToContractDTO>}> = (props) => {
          const {id,data} = props ?? {};

          return  postAddActionItemToContract(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAddActionItemToContractMutationResult = NonNullable<Awaited<ReturnType<typeof postAddActionItemToContract>>>
    export type PostAddActionItemToContractMutationBody = BodyType<AddActionItemsToContractDTO>
    export type PostAddActionItemToContractMutationError = ErrorType<unknown>

    export const usePostAddActionItemToContract = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAddActionItemToContract>>, TError,{id: string;data: BodyType<AddActionItemsToContractDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postAddActionItemToContract>>,
        TError,
        {id: string;data: BodyType<AddActionItemsToContractDTO>},
        TContext
      > => {

      const mutationOptions = getPostAddActionItemToContractMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postAddNoteToContract = (
    id: MaybeRef<string>,
    updateOrAddNoteToContractDTO: MaybeRef<UpdateOrAddNoteToContractDTO>,
 options?: SecondParameter<typeof axios>,) => {
      id = unref(id);
updateOrAddNoteToContractDTO = unref(updateOrAddNoteToContractDTO);
      
      return axios<void>(
      {url: `/api/contract/${id}/add-note`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: updateOrAddNoteToContractDTO
    },
      options);
    }
  


export const getPostAddNoteToContractMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAddNoteToContract>>, TError,{id: string;data: BodyType<UpdateOrAddNoteToContractDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postAddNoteToContract>>, TError,{id: string;data: BodyType<UpdateOrAddNoteToContractDTO>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAddNoteToContract>>, {id: string;data: BodyType<UpdateOrAddNoteToContractDTO>}> = (props) => {
          const {id,data} = props ?? {};

          return  postAddNoteToContract(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAddNoteToContractMutationResult = NonNullable<Awaited<ReturnType<typeof postAddNoteToContract>>>
    export type PostAddNoteToContractMutationBody = BodyType<UpdateOrAddNoteToContractDTO>
    export type PostAddNoteToContractMutationError = ErrorType<unknown>

    export const usePostAddNoteToContract = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAddNoteToContract>>, TError,{id: string;data: BodyType<UpdateOrAddNoteToContractDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postAddNoteToContract>>,
        TError,
        {id: string;data: BodyType<UpdateOrAddNoteToContractDTO>},
        TContext
      > => {

      const mutationOptions = getPostAddNoteToContractMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postUpdateNoteToContract = (
    id: MaybeRef<string>,
    updateOrAddNoteToContractDTO: MaybeRef<UpdateOrAddNoteToContractDTO>,
 options?: SecondParameter<typeof axios>,) => {
      id = unref(id);
updateOrAddNoteToContractDTO = unref(updateOrAddNoteToContractDTO);
      
      return axios<void>(
      {url: `/api/contract/${id}/update-note`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: updateOrAddNoteToContractDTO
    },
      options);
    }
  


export const getPostUpdateNoteToContractMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUpdateNoteToContract>>, TError,{id: string;data: BodyType<UpdateOrAddNoteToContractDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postUpdateNoteToContract>>, TError,{id: string;data: BodyType<UpdateOrAddNoteToContractDTO>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postUpdateNoteToContract>>, {id: string;data: BodyType<UpdateOrAddNoteToContractDTO>}> = (props) => {
          const {id,data} = props ?? {};

          return  postUpdateNoteToContract(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostUpdateNoteToContractMutationResult = NonNullable<Awaited<ReturnType<typeof postUpdateNoteToContract>>>
    export type PostUpdateNoteToContractMutationBody = BodyType<UpdateOrAddNoteToContractDTO>
    export type PostUpdateNoteToContractMutationError = ErrorType<unknown>

    export const usePostUpdateNoteToContract = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUpdateNoteToContract>>, TError,{id: string;data: BodyType<UpdateOrAddNoteToContractDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postUpdateNoteToContract>>,
        TError,
        {id: string;data: BodyType<UpdateOrAddNoteToContractDTO>},
        TContext
      > => {

      const mutationOptions = getPostUpdateNoteToContractMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postAddAcknowledgementToContract = (
    id: MaybeRef<string>,
    addAcknowledgementToContract: MaybeRef<AddAcknowledgementToContract>,
 options?: SecondParameter<typeof axios>,) => {
      id = unref(id);
addAcknowledgementToContract = unref(addAcknowledgementToContract);
      
      return axios<void>(
      {url: `/api/contract/${id}/add-acknowledgement`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: addAcknowledgementToContract
    },
      options);
    }
  


export const getPostAddAcknowledgementToContractMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAddAcknowledgementToContract>>, TError,{id: string;data: BodyType<AddAcknowledgementToContract>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postAddAcknowledgementToContract>>, TError,{id: string;data: BodyType<AddAcknowledgementToContract>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAddAcknowledgementToContract>>, {id: string;data: BodyType<AddAcknowledgementToContract>}> = (props) => {
          const {id,data} = props ?? {};

          return  postAddAcknowledgementToContract(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAddAcknowledgementToContractMutationResult = NonNullable<Awaited<ReturnType<typeof postAddAcknowledgementToContract>>>
    export type PostAddAcknowledgementToContractMutationBody = BodyType<AddAcknowledgementToContract>
    export type PostAddAcknowledgementToContractMutationError = ErrorType<unknown>

    export const usePostAddAcknowledgementToContract = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAddAcknowledgementToContract>>, TError,{id: string;data: BodyType<AddAcknowledgementToContract>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postAddAcknowledgementToContract>>,
        TError,
        {id: string;data: BodyType<AddAcknowledgementToContract>},
        TContext
      > => {

      const mutationOptions = getPostAddAcknowledgementToContractMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postCreateServiceHistory = (
    createServiceHistoryDTO: MaybeRef<CreateServiceHistoryDTO>,
 options?: SecondParameter<typeof axios>,) => {
      createServiceHistoryDTO = unref(createServiceHistoryDTO);
      
      return axios<CreateResponse>(
      {url: `/api/service-history`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createServiceHistoryDTO
    },
      options);
    }
  


export const getPostCreateServiceHistoryMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCreateServiceHistory>>, TError,{data: BodyType<CreateServiceHistoryDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postCreateServiceHistory>>, TError,{data: BodyType<CreateServiceHistoryDTO>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCreateServiceHistory>>, {data: BodyType<CreateServiceHistoryDTO>}> = (props) => {
          const {data} = props ?? {};

          return  postCreateServiceHistory(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostCreateServiceHistoryMutationResult = NonNullable<Awaited<ReturnType<typeof postCreateServiceHistory>>>
    export type PostCreateServiceHistoryMutationBody = BodyType<CreateServiceHistoryDTO>
    export type PostCreateServiceHistoryMutationError = ErrorType<unknown>

    export const usePostCreateServiceHistory = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCreateServiceHistory>>, TError,{data: BodyType<CreateServiceHistoryDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postCreateServiceHistory>>,
        TError,
        {data: BodyType<CreateServiceHistoryDTO>},
        TContext
      > => {

      const mutationOptions = getPostCreateServiceHistoryMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getFetchServiceHistory = (
    id: MaybeRef<string>,
 options?: SecondParameter<typeof axios>,signal?: AbortSignal
) => {
      id = unref(id);
      
      return axios<FetchServiceHistoryResponse>(
      {url: `/api/service-history/${id}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetFetchServiceHistoryQueryKey = (id: MaybeRef<string>,) => {
    return ['api','service-history',id] as const;
    }

    
export const getGetFetchServiceHistoryQueryOptions = <TData = Awaited<ReturnType<typeof getFetchServiceHistory>>, TError = ErrorType<unknown>>(id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFetchServiceHistory>>, TError, TData>>, request?: SecondParameter<typeof axios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getGetFetchServiceHistoryQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFetchServiceHistory>>> = ({ signal }) => getFetchServiceHistory(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: computed(() => !!(unref(id))), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFetchServiceHistory>>, TError, TData> 
}

export type GetFetchServiceHistoryQueryResult = NonNullable<Awaited<ReturnType<typeof getFetchServiceHistory>>>
export type GetFetchServiceHistoryQueryError = ErrorType<unknown>

export const useGetFetchServiceHistory = <TData = Awaited<ReturnType<typeof getFetchServiceHistory>>, TError = ErrorType<unknown>>(
 id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFetchServiceHistory>>, TError, TData>>, request?: SecondParameter<typeof axios>}

  ): UseQueryReturnType<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetFetchServiceHistoryQueryOptions(id,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: QueryKey };

  query.queryKey = unref(queryOptions).queryKey as QueryKey;

  return query;
}




export const putUpdateServiceHistory = (
    id: MaybeRef<string>,
    updateServiceHistoryDTO: MaybeRef<UpdateServiceHistoryDTO>,
 options?: SecondParameter<typeof axios>,) => {
      id = unref(id);
updateServiceHistoryDTO = unref(updateServiceHistoryDTO);
      
      return axios<void>(
      {url: `/api/service-history/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateServiceHistoryDTO
    },
      options);
    }
  


export const getPutUpdateServiceHistoryMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putUpdateServiceHistory>>, TError,{id: string;data: BodyType<UpdateServiceHistoryDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof putUpdateServiceHistory>>, TError,{id: string;data: BodyType<UpdateServiceHistoryDTO>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putUpdateServiceHistory>>, {id: string;data: BodyType<UpdateServiceHistoryDTO>}> = (props) => {
          const {id,data} = props ?? {};

          return  putUpdateServiceHistory(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutUpdateServiceHistoryMutationResult = NonNullable<Awaited<ReturnType<typeof putUpdateServiceHistory>>>
    export type PutUpdateServiceHistoryMutationBody = BodyType<UpdateServiceHistoryDTO>
    export type PutUpdateServiceHistoryMutationError = ErrorType<unknown>

    export const usePutUpdateServiceHistory = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putUpdateServiceHistory>>, TError,{id: string;data: BodyType<UpdateServiceHistoryDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof putUpdateServiceHistory>>,
        TError,
        {id: string;data: BodyType<UpdateServiceHistoryDTO>},
        TContext
      > => {

      const mutationOptions = getPutUpdateServiceHistoryMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postFetchAllServiceHistories = (
    params?: MaybeRef<PostFetchAllServiceHistoriesParams>,
 options?: SecondParameter<typeof axios>,) => {
      params = unref(params);
      
      return axios<FetchAllServiceHistoriesResponse>(
      {url: `/api/service-histories`, method: 'POST',
        params: unref(params)
    },
      options);
    }
  


export const getPostFetchAllServiceHistoriesMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postFetchAllServiceHistories>>, TError,{params?: PostFetchAllServiceHistoriesParams}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postFetchAllServiceHistories>>, TError,{params?: PostFetchAllServiceHistoriesParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postFetchAllServiceHistories>>, {params?: PostFetchAllServiceHistoriesParams}> = (props) => {
          const {params} = props ?? {};

          return  postFetchAllServiceHistories(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostFetchAllServiceHistoriesMutationResult = NonNullable<Awaited<ReturnType<typeof postFetchAllServiceHistories>>>
    
    export type PostFetchAllServiceHistoriesMutationError = ErrorType<unknown>

    export const usePostFetchAllServiceHistories = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postFetchAllServiceHistories>>, TError,{params?: PostFetchAllServiceHistoriesParams}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postFetchAllServiceHistories>>,
        TError,
        {params?: PostFetchAllServiceHistoriesParams},
        TContext
      > => {

      const mutationOptions = getPostFetchAllServiceHistoriesMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postAddPropertyToServiceHistory = (
    id: MaybeRef<string>,
    addPropertiesDTO: MaybeRef<AddPropertiesDTO>,
 options?: SecondParameter<typeof axios>,) => {
      id = unref(id);
addPropertiesDTO = unref(addPropertiesDTO);
      
      return axios<void>(
      {url: `/api/service-history/${id}/add-property`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: addPropertiesDTO
    },
      options);
    }
  


export const getPostAddPropertyToServiceHistoryMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAddPropertyToServiceHistory>>, TError,{id: string;data: BodyType<AddPropertiesDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postAddPropertyToServiceHistory>>, TError,{id: string;data: BodyType<AddPropertiesDTO>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAddPropertyToServiceHistory>>, {id: string;data: BodyType<AddPropertiesDTO>}> = (props) => {
          const {id,data} = props ?? {};

          return  postAddPropertyToServiceHistory(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAddPropertyToServiceHistoryMutationResult = NonNullable<Awaited<ReturnType<typeof postAddPropertyToServiceHistory>>>
    export type PostAddPropertyToServiceHistoryMutationBody = BodyType<AddPropertiesDTO>
    export type PostAddPropertyToServiceHistoryMutationError = ErrorType<unknown>

    export const usePostAddPropertyToServiceHistory = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAddPropertyToServiceHistory>>, TError,{id: string;data: BodyType<AddPropertiesDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postAddPropertyToServiceHistory>>,
        TError,
        {id: string;data: BodyType<AddPropertiesDTO>},
        TContext
      > => {

      const mutationOptions = getPostAddPropertyToServiceHistoryMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postAddPropertiesWithAttributesToServiceHistory = (
    id: MaybeRef<string>,
    addPropertiesWithAttributesToServiceHistoryDTO: MaybeRef<AddPropertiesWithAttributesToServiceHistoryDTO>,
 options?: SecondParameter<typeof axios>,) => {
      id = unref(id);
addPropertiesWithAttributesToServiceHistoryDTO = unref(addPropertiesWithAttributesToServiceHistoryDTO);
      
      return axios<void>(
      {url: `/api/service-history/${id}/add-properties-with-attributes`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: addPropertiesWithAttributesToServiceHistoryDTO
    },
      options);
    }
  


export const getPostAddPropertiesWithAttributesToServiceHistoryMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAddPropertiesWithAttributesToServiceHistory>>, TError,{id: string;data: BodyType<AddPropertiesWithAttributesToServiceHistoryDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postAddPropertiesWithAttributesToServiceHistory>>, TError,{id: string;data: BodyType<AddPropertiesWithAttributesToServiceHistoryDTO>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAddPropertiesWithAttributesToServiceHistory>>, {id: string;data: BodyType<AddPropertiesWithAttributesToServiceHistoryDTO>}> = (props) => {
          const {id,data} = props ?? {};

          return  postAddPropertiesWithAttributesToServiceHistory(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAddPropertiesWithAttributesToServiceHistoryMutationResult = NonNullable<Awaited<ReturnType<typeof postAddPropertiesWithAttributesToServiceHistory>>>
    export type PostAddPropertiesWithAttributesToServiceHistoryMutationBody = BodyType<AddPropertiesWithAttributesToServiceHistoryDTO>
    export type PostAddPropertiesWithAttributesToServiceHistoryMutationError = ErrorType<unknown>

    export const usePostAddPropertiesWithAttributesToServiceHistory = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAddPropertiesWithAttributesToServiceHistory>>, TError,{id: string;data: BodyType<AddPropertiesWithAttributesToServiceHistoryDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postAddPropertiesWithAttributesToServiceHistory>>,
        TError,
        {id: string;data: BodyType<AddPropertiesWithAttributesToServiceHistoryDTO>},
        TContext
      > => {

      const mutationOptions = getPostAddPropertiesWithAttributesToServiceHistoryMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postCreateMaintenancePackage = (
    createMaintenancePackageDTO: MaybeRef<CreateMaintenancePackageDTO>,
 options?: SecondParameter<typeof axios>,) => {
      createMaintenancePackageDTO = unref(createMaintenancePackageDTO);
      
      return axios<CreateResponse>(
      {url: `/api/maintenance-package`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createMaintenancePackageDTO
    },
      options);
    }
  


export const getPostCreateMaintenancePackageMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCreateMaintenancePackage>>, TError,{data: BodyType<CreateMaintenancePackageDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postCreateMaintenancePackage>>, TError,{data: BodyType<CreateMaintenancePackageDTO>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCreateMaintenancePackage>>, {data: BodyType<CreateMaintenancePackageDTO>}> = (props) => {
          const {data} = props ?? {};

          return  postCreateMaintenancePackage(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostCreateMaintenancePackageMutationResult = NonNullable<Awaited<ReturnType<typeof postCreateMaintenancePackage>>>
    export type PostCreateMaintenancePackageMutationBody = BodyType<CreateMaintenancePackageDTO>
    export type PostCreateMaintenancePackageMutationError = ErrorType<unknown>

    export const usePostCreateMaintenancePackage = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCreateMaintenancePackage>>, TError,{data: BodyType<CreateMaintenancePackageDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postCreateMaintenancePackage>>,
        TError,
        {data: BodyType<CreateMaintenancePackageDTO>},
        TContext
      > => {

      const mutationOptions = getPostCreateMaintenancePackageMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getFetchMaintenancePackage = (
    id: MaybeRef<string>,
 options?: SecondParameter<typeof axios>,signal?: AbortSignal
) => {
      id = unref(id);
      
      return axios<FetchMaintenancePackageResponse>(
      {url: `/api/maintenance-package/${id}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetFetchMaintenancePackageQueryKey = (id: MaybeRef<string>,) => {
    return ['api','maintenance-package',id] as const;
    }

    
export const getGetFetchMaintenancePackageQueryOptions = <TData = Awaited<ReturnType<typeof getFetchMaintenancePackage>>, TError = ErrorType<unknown>>(id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFetchMaintenancePackage>>, TError, TData>>, request?: SecondParameter<typeof axios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getGetFetchMaintenancePackageQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFetchMaintenancePackage>>> = ({ signal }) => getFetchMaintenancePackage(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: computed(() => !!(unref(id))), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFetchMaintenancePackage>>, TError, TData> 
}

export type GetFetchMaintenancePackageQueryResult = NonNullable<Awaited<ReturnType<typeof getFetchMaintenancePackage>>>
export type GetFetchMaintenancePackageQueryError = ErrorType<unknown>

export const useGetFetchMaintenancePackage = <TData = Awaited<ReturnType<typeof getFetchMaintenancePackage>>, TError = ErrorType<unknown>>(
 id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFetchMaintenancePackage>>, TError, TData>>, request?: SecondParameter<typeof axios>}

  ): UseQueryReturnType<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetFetchMaintenancePackageQueryOptions(id,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: QueryKey };

  query.queryKey = unref(queryOptions).queryKey as QueryKey;

  return query;
}




export const putUpdateMaintenancePackage = (
    id: MaybeRef<string>,
    updateMaintenancePackageDTO: MaybeRef<UpdateMaintenancePackageDTO>,
 options?: SecondParameter<typeof axios>,) => {
      id = unref(id);
updateMaintenancePackageDTO = unref(updateMaintenancePackageDTO);
      
      return axios<void>(
      {url: `/api/maintenance-package/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateMaintenancePackageDTO
    },
      options);
    }
  


export const getPutUpdateMaintenancePackageMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putUpdateMaintenancePackage>>, TError,{id: string;data: BodyType<UpdateMaintenancePackageDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof putUpdateMaintenancePackage>>, TError,{id: string;data: BodyType<UpdateMaintenancePackageDTO>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putUpdateMaintenancePackage>>, {id: string;data: BodyType<UpdateMaintenancePackageDTO>}> = (props) => {
          const {id,data} = props ?? {};

          return  putUpdateMaintenancePackage(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutUpdateMaintenancePackageMutationResult = NonNullable<Awaited<ReturnType<typeof putUpdateMaintenancePackage>>>
    export type PutUpdateMaintenancePackageMutationBody = BodyType<UpdateMaintenancePackageDTO>
    export type PutUpdateMaintenancePackageMutationError = ErrorType<unknown>

    export const usePutUpdateMaintenancePackage = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putUpdateMaintenancePackage>>, TError,{id: string;data: BodyType<UpdateMaintenancePackageDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof putUpdateMaintenancePackage>>,
        TError,
        {id: string;data: BodyType<UpdateMaintenancePackageDTO>},
        TContext
      > => {

      const mutationOptions = getPutUpdateMaintenancePackageMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postFetchAllMaintenancePackages = (
    params?: MaybeRef<PostFetchAllMaintenancePackagesParams>,
 options?: SecondParameter<typeof axios>,) => {
      params = unref(params);
      
      return axios<FetchAllMaintenancePackagesResponse>(
      {url: `/api/maintenance-packages`, method: 'POST',
        params: unref(params)
    },
      options);
    }
  


export const getPostFetchAllMaintenancePackagesMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postFetchAllMaintenancePackages>>, TError,{params?: PostFetchAllMaintenancePackagesParams}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postFetchAllMaintenancePackages>>, TError,{params?: PostFetchAllMaintenancePackagesParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postFetchAllMaintenancePackages>>, {params?: PostFetchAllMaintenancePackagesParams}> = (props) => {
          const {params} = props ?? {};

          return  postFetchAllMaintenancePackages(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostFetchAllMaintenancePackagesMutationResult = NonNullable<Awaited<ReturnType<typeof postFetchAllMaintenancePackages>>>
    
    export type PostFetchAllMaintenancePackagesMutationError = ErrorType<unknown>

    export const usePostFetchAllMaintenancePackages = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postFetchAllMaintenancePackages>>, TError,{params?: PostFetchAllMaintenancePackagesParams}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postFetchAllMaintenancePackages>>,
        TError,
        {params?: PostFetchAllMaintenancePackagesParams},
        TContext
      > => {

      const mutationOptions = getPostFetchAllMaintenancePackagesMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postAddRecipeToMaintenancePackage = (
    id: MaybeRef<string>,
    addRecipesToMaintenancePackageDTO: MaybeRef<AddRecipesToMaintenancePackageDTO>,
 options?: SecondParameter<typeof axios>,) => {
      id = unref(id);
addRecipesToMaintenancePackageDTO = unref(addRecipesToMaintenancePackageDTO);
      
      return axios<void>(
      {url: `/api/maintenance-package/${id}/add-recipe`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: addRecipesToMaintenancePackageDTO
    },
      options);
    }
  


export const getPostAddRecipeToMaintenancePackageMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAddRecipeToMaintenancePackage>>, TError,{id: string;data: BodyType<AddRecipesToMaintenancePackageDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postAddRecipeToMaintenancePackage>>, TError,{id: string;data: BodyType<AddRecipesToMaintenancePackageDTO>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAddRecipeToMaintenancePackage>>, {id: string;data: BodyType<AddRecipesToMaintenancePackageDTO>}> = (props) => {
          const {id,data} = props ?? {};

          return  postAddRecipeToMaintenancePackage(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAddRecipeToMaintenancePackageMutationResult = NonNullable<Awaited<ReturnType<typeof postAddRecipeToMaintenancePackage>>>
    export type PostAddRecipeToMaintenancePackageMutationBody = BodyType<AddRecipesToMaintenancePackageDTO>
    export type PostAddRecipeToMaintenancePackageMutationError = ErrorType<unknown>

    export const usePostAddRecipeToMaintenancePackage = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAddRecipeToMaintenancePackage>>, TError,{id: string;data: BodyType<AddRecipesToMaintenancePackageDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postAddRecipeToMaintenancePackage>>,
        TError,
        {id: string;data: BodyType<AddRecipesToMaintenancePackageDTO>},
        TContext
      > => {

      const mutationOptions = getPostAddRecipeToMaintenancePackageMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postCreateUnit = (
    createUnitDTO: MaybeRef<CreateUnitDTO>,
 options?: SecondParameter<typeof axios>,) => {
      createUnitDTO = unref(createUnitDTO);
      
      return axios<CreateResponse>(
      {url: `/api/unit`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createUnitDTO
    },
      options);
    }
  


export const getPostCreateUnitMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCreateUnit>>, TError,{data: BodyType<CreateUnitDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postCreateUnit>>, TError,{data: BodyType<CreateUnitDTO>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCreateUnit>>, {data: BodyType<CreateUnitDTO>}> = (props) => {
          const {data} = props ?? {};

          return  postCreateUnit(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostCreateUnitMutationResult = NonNullable<Awaited<ReturnType<typeof postCreateUnit>>>
    export type PostCreateUnitMutationBody = BodyType<CreateUnitDTO>
    export type PostCreateUnitMutationError = ErrorType<unknown>

    export const usePostCreateUnit = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCreateUnit>>, TError,{data: BodyType<CreateUnitDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postCreateUnit>>,
        TError,
        {data: BodyType<CreateUnitDTO>},
        TContext
      > => {

      const mutationOptions = getPostCreateUnitMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getFetchUnit = (
    id: MaybeRef<string>,
 options?: SecondParameter<typeof axios>,signal?: AbortSignal
) => {
      id = unref(id);
      
      return axios<FetchUnitResponse>(
      {url: `/api/unit/${id}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetFetchUnitQueryKey = (id: MaybeRef<string>,) => {
    return ['api','unit',id] as const;
    }

    
export const getGetFetchUnitQueryOptions = <TData = Awaited<ReturnType<typeof getFetchUnit>>, TError = ErrorType<unknown>>(id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFetchUnit>>, TError, TData>>, request?: SecondParameter<typeof axios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getGetFetchUnitQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFetchUnit>>> = ({ signal }) => getFetchUnit(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: computed(() => !!(unref(id))), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFetchUnit>>, TError, TData> 
}

export type GetFetchUnitQueryResult = NonNullable<Awaited<ReturnType<typeof getFetchUnit>>>
export type GetFetchUnitQueryError = ErrorType<unknown>

export const useGetFetchUnit = <TData = Awaited<ReturnType<typeof getFetchUnit>>, TError = ErrorType<unknown>>(
 id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFetchUnit>>, TError, TData>>, request?: SecondParameter<typeof axios>}

  ): UseQueryReturnType<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetFetchUnitQueryOptions(id,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: QueryKey };

  query.queryKey = unref(queryOptions).queryKey as QueryKey;

  return query;
}




export const putUpdateUnit = (
    id: MaybeRef<string>,
    updateUnitDTO: MaybeRef<UpdateUnitDTO>,
 options?: SecondParameter<typeof axios>,) => {
      id = unref(id);
updateUnitDTO = unref(updateUnitDTO);
      
      return axios<void>(
      {url: `/api/unit/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateUnitDTO
    },
      options);
    }
  


export const getPutUpdateUnitMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putUpdateUnit>>, TError,{id: string;data: BodyType<UpdateUnitDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof putUpdateUnit>>, TError,{id: string;data: BodyType<UpdateUnitDTO>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putUpdateUnit>>, {id: string;data: BodyType<UpdateUnitDTO>}> = (props) => {
          const {id,data} = props ?? {};

          return  putUpdateUnit(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutUpdateUnitMutationResult = NonNullable<Awaited<ReturnType<typeof putUpdateUnit>>>
    export type PutUpdateUnitMutationBody = BodyType<UpdateUnitDTO>
    export type PutUpdateUnitMutationError = ErrorType<unknown>

    export const usePutUpdateUnit = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putUpdateUnit>>, TError,{id: string;data: BodyType<UpdateUnitDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof putUpdateUnit>>,
        TError,
        {id: string;data: BodyType<UpdateUnitDTO>},
        TContext
      > => {

      const mutationOptions = getPutUpdateUnitMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const patchPatchUnit = (
    id: MaybeRef<string>,
    patchUnitDTO: MaybeRef<PatchUnitDTO>,
 options?: SecondParameter<typeof axios>,) => {
      id = unref(id);
patchUnitDTO = unref(patchUnitDTO);
      
      return axios<void>(
      {url: `/api/unit/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchUnitDTO
    },
      options);
    }
  


export const getPatchPatchUnitMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchPatchUnit>>, TError,{id: string;data: BodyType<PatchUnitDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof patchPatchUnit>>, TError,{id: string;data: BodyType<PatchUnitDTO>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchPatchUnit>>, {id: string;data: BodyType<PatchUnitDTO>}> = (props) => {
          const {id,data} = props ?? {};

          return  patchPatchUnit(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchPatchUnitMutationResult = NonNullable<Awaited<ReturnType<typeof patchPatchUnit>>>
    export type PatchPatchUnitMutationBody = BodyType<PatchUnitDTO>
    export type PatchPatchUnitMutationError = ErrorType<unknown>

    export const usePatchPatchUnit = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchPatchUnit>>, TError,{id: string;data: BodyType<PatchUnitDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof patchPatchUnit>>,
        TError,
        {id: string;data: BodyType<PatchUnitDTO>},
        TContext
      > => {

      const mutationOptions = getPatchPatchUnitMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postFetchAllUnits = (
    unitFiltersDTO: MaybeRef<UnitFiltersDTO>,
    params?: MaybeRef<PostFetchAllUnitsParams>,
 options?: SecondParameter<typeof axios>,) => {
      unitFiltersDTO = unref(unitFiltersDTO);
params = unref(params);
      
      return axios<FetchAllUnits>(
      {url: `/api/units`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: unitFiltersDTO,
        params: unref(params)
    },
      options);
    }
  


export const getPostFetchAllUnitsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postFetchAllUnits>>, TError,{data: BodyType<UnitFiltersDTO>;params?: PostFetchAllUnitsParams}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postFetchAllUnits>>, TError,{data: BodyType<UnitFiltersDTO>;params?: PostFetchAllUnitsParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postFetchAllUnits>>, {data: BodyType<UnitFiltersDTO>;params?: PostFetchAllUnitsParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postFetchAllUnits(data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostFetchAllUnitsMutationResult = NonNullable<Awaited<ReturnType<typeof postFetchAllUnits>>>
    export type PostFetchAllUnitsMutationBody = BodyType<UnitFiltersDTO>
    export type PostFetchAllUnitsMutationError = ErrorType<unknown>

    export const usePostFetchAllUnits = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postFetchAllUnits>>, TError,{data: BodyType<UnitFiltersDTO>;params?: PostFetchAllUnitsParams}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postFetchAllUnits>>,
        TError,
        {data: BodyType<UnitFiltersDTO>;params?: PostFetchAllUnitsParams},
        TContext
      > => {

      const mutationOptions = getPostFetchAllUnitsMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postAddPropertyToUnit = (
    id: MaybeRef<string>,
    addPropertiesDTO: MaybeRef<AddPropertiesDTO>,
 options?: SecondParameter<typeof axios>,) => {
      id = unref(id);
addPropertiesDTO = unref(addPropertiesDTO);
      
      return axios<void>(
      {url: `/api/unit/${id}/add-property`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: addPropertiesDTO
    },
      options);
    }
  


export const getPostAddPropertyToUnitMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAddPropertyToUnit>>, TError,{id: string;data: BodyType<AddPropertiesDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postAddPropertyToUnit>>, TError,{id: string;data: BodyType<AddPropertiesDTO>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAddPropertyToUnit>>, {id: string;data: BodyType<AddPropertiesDTO>}> = (props) => {
          const {id,data} = props ?? {};

          return  postAddPropertyToUnit(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAddPropertyToUnitMutationResult = NonNullable<Awaited<ReturnType<typeof postAddPropertyToUnit>>>
    export type PostAddPropertyToUnitMutationBody = BodyType<AddPropertiesDTO>
    export type PostAddPropertyToUnitMutationError = ErrorType<unknown>

    export const usePostAddPropertyToUnit = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAddPropertyToUnit>>, TError,{id: string;data: BodyType<AddPropertiesDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postAddPropertyToUnit>>,
        TError,
        {id: string;data: BodyType<AddPropertiesDTO>},
        TContext
      > => {

      const mutationOptions = getPostAddPropertyToUnitMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postAddServicePropertyToUnit = (
    id: MaybeRef<string>,
    addServicePropertyToUnitDTO: MaybeRef<AddServicePropertyToUnitDTO>,
 options?: SecondParameter<typeof axios>,) => {
      id = unref(id);
addServicePropertyToUnitDTO = unref(addServicePropertyToUnitDTO);
      
      return axios<void>(
      {url: `/api/unit/${id}/add-service-property`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: addServicePropertyToUnitDTO
    },
      options);
    }
  


export const getPostAddServicePropertyToUnitMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAddServicePropertyToUnit>>, TError,{id: string;data: BodyType<AddServicePropertyToUnitDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postAddServicePropertyToUnit>>, TError,{id: string;data: BodyType<AddServicePropertyToUnitDTO>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAddServicePropertyToUnit>>, {id: string;data: BodyType<AddServicePropertyToUnitDTO>}> = (props) => {
          const {id,data} = props ?? {};

          return  postAddServicePropertyToUnit(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAddServicePropertyToUnitMutationResult = NonNullable<Awaited<ReturnType<typeof postAddServicePropertyToUnit>>>
    export type PostAddServicePropertyToUnitMutationBody = BodyType<AddServicePropertyToUnitDTO>
    export type PostAddServicePropertyToUnitMutationError = ErrorType<unknown>

    export const usePostAddServicePropertyToUnit = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAddServicePropertyToUnit>>, TError,{id: string;data: BodyType<AddServicePropertyToUnitDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postAddServicePropertyToUnit>>,
        TError,
        {id: string;data: BodyType<AddServicePropertyToUnitDTO>},
        TContext
      > => {

      const mutationOptions = getPostAddServicePropertyToUnitMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postAddServiceHistoryToUnit = (
    id: MaybeRef<string>,
    addServiceHistoryToUnitDTO: MaybeRef<AddServiceHistoryToUnitDTO>,
 options?: SecondParameter<typeof axios>,) => {
      id = unref(id);
addServiceHistoryToUnitDTO = unref(addServiceHistoryToUnitDTO);
      
      return axios<void>(
      {url: `/api/unit/${id}/add-service-history`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: addServiceHistoryToUnitDTO
    },
      options);
    }
  


export const getPostAddServiceHistoryToUnitMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAddServiceHistoryToUnit>>, TError,{id: string;data: BodyType<AddServiceHistoryToUnitDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postAddServiceHistoryToUnit>>, TError,{id: string;data: BodyType<AddServiceHistoryToUnitDTO>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAddServiceHistoryToUnit>>, {id: string;data: BodyType<AddServiceHistoryToUnitDTO>}> = (props) => {
          const {id,data} = props ?? {};

          return  postAddServiceHistoryToUnit(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAddServiceHistoryToUnitMutationResult = NonNullable<Awaited<ReturnType<typeof postAddServiceHistoryToUnit>>>
    export type PostAddServiceHistoryToUnitMutationBody = BodyType<AddServiceHistoryToUnitDTO>
    export type PostAddServiceHistoryToUnitMutationError = ErrorType<unknown>

    export const usePostAddServiceHistoryToUnit = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAddServiceHistoryToUnit>>, TError,{id: string;data: BodyType<AddServiceHistoryToUnitDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postAddServiceHistoryToUnit>>,
        TError,
        {id: string;data: BodyType<AddServiceHistoryToUnitDTO>},
        TContext
      > => {

      const mutationOptions = getPostAddServiceHistoryToUnitMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getFetchUnitsByOrganisation = (
    id: MaybeRef<string>,
 options?: SecondParameter<typeof axios>,signal?: AbortSignal
) => {
      id = unref(id);
      
      return axios<FetchUnitsByOrganisationResponse>(
      {url: `/api/organisation/${id}/units`, method: 'GET', signal
    },
      options);
    }
  

export const getGetFetchUnitsByOrganisationQueryKey = (id: MaybeRef<string>,) => {
    return ['api','organisation',id,'units'] as const;
    }

    
export const getGetFetchUnitsByOrganisationQueryOptions = <TData = Awaited<ReturnType<typeof getFetchUnitsByOrganisation>>, TError = ErrorType<unknown>>(id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFetchUnitsByOrganisation>>, TError, TData>>, request?: SecondParameter<typeof axios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getGetFetchUnitsByOrganisationQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFetchUnitsByOrganisation>>> = ({ signal }) => getFetchUnitsByOrganisation(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: computed(() => !!(unref(id))), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFetchUnitsByOrganisation>>, TError, TData> 
}

export type GetFetchUnitsByOrganisationQueryResult = NonNullable<Awaited<ReturnType<typeof getFetchUnitsByOrganisation>>>
export type GetFetchUnitsByOrganisationQueryError = ErrorType<unknown>

export const useGetFetchUnitsByOrganisation = <TData = Awaited<ReturnType<typeof getFetchUnitsByOrganisation>>, TError = ErrorType<unknown>>(
 id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFetchUnitsByOrganisation>>, TError, TData>>, request?: SecondParameter<typeof axios>}

  ): UseQueryReturnType<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetFetchUnitsByOrganisationQueryOptions(id,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: QueryKey };

  query.queryKey = unref(queryOptions).queryKey as QueryKey;

  return query;
}




export const postCreateProperty = (
    createPropertyDTO: MaybeRef<CreatePropertyDTO>,
 options?: SecondParameter<typeof axios>,) => {
      createPropertyDTO = unref(createPropertyDTO);
      
      return axios<CreateResponse>(
      {url: `/api/property`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createPropertyDTO
    },
      options);
    }
  


export const getPostCreatePropertyMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCreateProperty>>, TError,{data: BodyType<CreatePropertyDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postCreateProperty>>, TError,{data: BodyType<CreatePropertyDTO>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCreateProperty>>, {data: BodyType<CreatePropertyDTO>}> = (props) => {
          const {data} = props ?? {};

          return  postCreateProperty(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostCreatePropertyMutationResult = NonNullable<Awaited<ReturnType<typeof postCreateProperty>>>
    export type PostCreatePropertyMutationBody = BodyType<CreatePropertyDTO>
    export type PostCreatePropertyMutationError = ErrorType<unknown>

    export const usePostCreateProperty = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCreateProperty>>, TError,{data: BodyType<CreatePropertyDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postCreateProperty>>,
        TError,
        {data: BodyType<CreatePropertyDTO>},
        TContext
      > => {

      const mutationOptions = getPostCreatePropertyMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getFetchProperty = (
    id: MaybeRef<string>,
 options?: SecondParameter<typeof axios>,signal?: AbortSignal
) => {
      id = unref(id);
      
      return axios<FetchPropertyResponse>(
      {url: `/api/property/${id}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetFetchPropertyQueryKey = (id: MaybeRef<string>,) => {
    return ['api','property',id] as const;
    }

    
export const getGetFetchPropertyQueryOptions = <TData = Awaited<ReturnType<typeof getFetchProperty>>, TError = ErrorType<unknown>>(id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFetchProperty>>, TError, TData>>, request?: SecondParameter<typeof axios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getGetFetchPropertyQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFetchProperty>>> = ({ signal }) => getFetchProperty(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: computed(() => !!(unref(id))), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFetchProperty>>, TError, TData> 
}

export type GetFetchPropertyQueryResult = NonNullable<Awaited<ReturnType<typeof getFetchProperty>>>
export type GetFetchPropertyQueryError = ErrorType<unknown>

export const useGetFetchProperty = <TData = Awaited<ReturnType<typeof getFetchProperty>>, TError = ErrorType<unknown>>(
 id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFetchProperty>>, TError, TData>>, request?: SecondParameter<typeof axios>}

  ): UseQueryReturnType<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetFetchPropertyQueryOptions(id,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: QueryKey };

  query.queryKey = unref(queryOptions).queryKey as QueryKey;

  return query;
}




export const putUpdateProperty = (
    id: MaybeRef<string>,
    updatePropertyDTO: MaybeRef<UpdatePropertyDTO>,
 options?: SecondParameter<typeof axios>,) => {
      id = unref(id);
updatePropertyDTO = unref(updatePropertyDTO);
      
      return axios<void>(
      {url: `/api/property/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updatePropertyDTO
    },
      options);
    }
  


export const getPutUpdatePropertyMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putUpdateProperty>>, TError,{id: string;data: BodyType<UpdatePropertyDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof putUpdateProperty>>, TError,{id: string;data: BodyType<UpdatePropertyDTO>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putUpdateProperty>>, {id: string;data: BodyType<UpdatePropertyDTO>}> = (props) => {
          const {id,data} = props ?? {};

          return  putUpdateProperty(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutUpdatePropertyMutationResult = NonNullable<Awaited<ReturnType<typeof putUpdateProperty>>>
    export type PutUpdatePropertyMutationBody = BodyType<UpdatePropertyDTO>
    export type PutUpdatePropertyMutationError = ErrorType<unknown>

    export const usePutUpdateProperty = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putUpdateProperty>>, TError,{id: string;data: BodyType<UpdatePropertyDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof putUpdateProperty>>,
        TError,
        {id: string;data: BodyType<UpdatePropertyDTO>},
        TContext
      > => {

      const mutationOptions = getPutUpdatePropertyMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postFetchAllProperties = (
    params?: MaybeRef<PostFetchAllPropertiesParams>,
 options?: SecondParameter<typeof axios>,) => {
      params = unref(params);
      
      return axios<FetchAllPropertiesResponse>(
      {url: `/api/properties`, method: 'POST',
        params: unref(params)
    },
      options);
    }
  


export const getPostFetchAllPropertiesMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postFetchAllProperties>>, TError,{params?: PostFetchAllPropertiesParams}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postFetchAllProperties>>, TError,{params?: PostFetchAllPropertiesParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postFetchAllProperties>>, {params?: PostFetchAllPropertiesParams}> = (props) => {
          const {params} = props ?? {};

          return  postFetchAllProperties(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostFetchAllPropertiesMutationResult = NonNullable<Awaited<ReturnType<typeof postFetchAllProperties>>>
    
    export type PostFetchAllPropertiesMutationError = ErrorType<unknown>

    export const usePostFetchAllProperties = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postFetchAllProperties>>, TError,{params?: PostFetchAllPropertiesParams}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postFetchAllProperties>>,
        TError,
        {params?: PostFetchAllPropertiesParams},
        TContext
      > => {

      const mutationOptions = getPostFetchAllPropertiesMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postCreatePropertyAttribute = (
    createPropertyAttributeDTO: MaybeRef<CreatePropertyAttributeDTO>,
 options?: SecondParameter<typeof axios>,) => {
      createPropertyAttributeDTO = unref(createPropertyAttributeDTO);
      
      return axios<CreateResponse>(
      {url: `/api/property-attribute`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createPropertyAttributeDTO
    },
      options);
    }
  


export const getPostCreatePropertyAttributeMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCreatePropertyAttribute>>, TError,{data: BodyType<CreatePropertyAttributeDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postCreatePropertyAttribute>>, TError,{data: BodyType<CreatePropertyAttributeDTO>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCreatePropertyAttribute>>, {data: BodyType<CreatePropertyAttributeDTO>}> = (props) => {
          const {data} = props ?? {};

          return  postCreatePropertyAttribute(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostCreatePropertyAttributeMutationResult = NonNullable<Awaited<ReturnType<typeof postCreatePropertyAttribute>>>
    export type PostCreatePropertyAttributeMutationBody = BodyType<CreatePropertyAttributeDTO>
    export type PostCreatePropertyAttributeMutationError = ErrorType<unknown>

    export const usePostCreatePropertyAttribute = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCreatePropertyAttribute>>, TError,{data: BodyType<CreatePropertyAttributeDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postCreatePropertyAttribute>>,
        TError,
        {data: BodyType<CreatePropertyAttributeDTO>},
        TContext
      > => {

      const mutationOptions = getPostCreatePropertyAttributeMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postFetchAllPropertyAttributes = (
    propertyAttributeFiltersDTO: MaybeRef<PropertyAttributeFiltersDTO>,
    params?: MaybeRef<PostFetchAllPropertyAttributesParams>,
 options?: SecondParameter<typeof axios>,) => {
      propertyAttributeFiltersDTO = unref(propertyAttributeFiltersDTO);
params = unref(params);
      
      return axios<FetchAllPropertyAttributes>(
      {url: `/api/property-attributes`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: propertyAttributeFiltersDTO,
        params: unref(params)
    },
      options);
    }
  


export const getPostFetchAllPropertyAttributesMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postFetchAllPropertyAttributes>>, TError,{data: BodyType<PropertyAttributeFiltersDTO>;params?: PostFetchAllPropertyAttributesParams}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postFetchAllPropertyAttributes>>, TError,{data: BodyType<PropertyAttributeFiltersDTO>;params?: PostFetchAllPropertyAttributesParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postFetchAllPropertyAttributes>>, {data: BodyType<PropertyAttributeFiltersDTO>;params?: PostFetchAllPropertyAttributesParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postFetchAllPropertyAttributes(data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostFetchAllPropertyAttributesMutationResult = NonNullable<Awaited<ReturnType<typeof postFetchAllPropertyAttributes>>>
    export type PostFetchAllPropertyAttributesMutationBody = BodyType<PropertyAttributeFiltersDTO>
    export type PostFetchAllPropertyAttributesMutationError = ErrorType<unknown>

    export const usePostFetchAllPropertyAttributes = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postFetchAllPropertyAttributes>>, TError,{data: BodyType<PropertyAttributeFiltersDTO>;params?: PostFetchAllPropertyAttributesParams}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postFetchAllPropertyAttributes>>,
        TError,
        {data: BodyType<PropertyAttributeFiltersDTO>;params?: PostFetchAllPropertyAttributesParams},
        TContext
      > => {

      const mutationOptions = getPostFetchAllPropertyAttributesMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getFetchServiceProperty = (
    id: MaybeRef<string>,
 options?: SecondParameter<typeof axios>,signal?: AbortSignal
) => {
      id = unref(id);
      
      return axios<FetchPropertyResponse>(
      {url: `/api/service-property/${id}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetFetchServicePropertyQueryKey = (id: MaybeRef<string>,) => {
    return ['api','service-property',id] as const;
    }

    
export const getGetFetchServicePropertyQueryOptions = <TData = Awaited<ReturnType<typeof getFetchServiceProperty>>, TError = ErrorType<unknown>>(id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFetchServiceProperty>>, TError, TData>>, request?: SecondParameter<typeof axios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getGetFetchServicePropertyQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFetchServiceProperty>>> = ({ signal }) => getFetchServiceProperty(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: computed(() => !!(unref(id))), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFetchServiceProperty>>, TError, TData> 
}

export type GetFetchServicePropertyQueryResult = NonNullable<Awaited<ReturnType<typeof getFetchServiceProperty>>>
export type GetFetchServicePropertyQueryError = ErrorType<unknown>

export const useGetFetchServiceProperty = <TData = Awaited<ReturnType<typeof getFetchServiceProperty>>, TError = ErrorType<unknown>>(
 id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFetchServiceProperty>>, TError, TData>>, request?: SecondParameter<typeof axios>}

  ): UseQueryReturnType<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetFetchServicePropertyQueryOptions(id,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: QueryKey };

  query.queryKey = unref(queryOptions).queryKey as QueryKey;

  return query;
}




export const putUpdateServiceProperty = (
    id: MaybeRef<string>,
    updatePropertyDTO: MaybeRef<UpdatePropertyDTO>,
 options?: SecondParameter<typeof axios>,) => {
      id = unref(id);
updatePropertyDTO = unref(updatePropertyDTO);
      
      return axios<void>(
      {url: `/api/service-property/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updatePropertyDTO
    },
      options);
    }
  


export const getPutUpdateServicePropertyMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putUpdateServiceProperty>>, TError,{id: string;data: BodyType<UpdatePropertyDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof putUpdateServiceProperty>>, TError,{id: string;data: BodyType<UpdatePropertyDTO>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putUpdateServiceProperty>>, {id: string;data: BodyType<UpdatePropertyDTO>}> = (props) => {
          const {id,data} = props ?? {};

          return  putUpdateServiceProperty(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutUpdateServicePropertyMutationResult = NonNullable<Awaited<ReturnType<typeof putUpdateServiceProperty>>>
    export type PutUpdateServicePropertyMutationBody = BodyType<UpdatePropertyDTO>
    export type PutUpdateServicePropertyMutationError = ErrorType<unknown>

    export const usePutUpdateServiceProperty = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putUpdateServiceProperty>>, TError,{id: string;data: BodyType<UpdatePropertyDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof putUpdateServiceProperty>>,
        TError,
        {id: string;data: BodyType<UpdatePropertyDTO>},
        TContext
      > => {

      const mutationOptions = getPutUpdateServicePropertyMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postFetchAllServiceProperties = (
    params?: MaybeRef<PostFetchAllServicePropertiesParams>,
 options?: SecondParameter<typeof axios>,) => {
      params = unref(params);
      
      return axios<FetchAllPropertiesResponse>(
      {url: `/api/service-properties`, method: 'POST',
        params: unref(params)
    },
      options);
    }
  


export const getPostFetchAllServicePropertiesMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postFetchAllServiceProperties>>, TError,{params?: PostFetchAllServicePropertiesParams}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postFetchAllServiceProperties>>, TError,{params?: PostFetchAllServicePropertiesParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postFetchAllServiceProperties>>, {params?: PostFetchAllServicePropertiesParams}> = (props) => {
          const {params} = props ?? {};

          return  postFetchAllServiceProperties(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostFetchAllServicePropertiesMutationResult = NonNullable<Awaited<ReturnType<typeof postFetchAllServiceProperties>>>
    
    export type PostFetchAllServicePropertiesMutationError = ErrorType<unknown>

    export const usePostFetchAllServiceProperties = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postFetchAllServiceProperties>>, TError,{params?: PostFetchAllServicePropertiesParams}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postFetchAllServiceProperties>>,
        TError,
        {params?: PostFetchAllServicePropertiesParams},
        TContext
      > => {

      const mutationOptions = getPostFetchAllServicePropertiesMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postCreateServiceProperty = (
    createPropertyDTO: MaybeRef<CreatePropertyDTO>,
 options?: SecondParameter<typeof axios>,) => {
      createPropertyDTO = unref(createPropertyDTO);
      
      return axios<CreateResponse>(
      {url: `/api/service-property`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createPropertyDTO
    },
      options);
    }
  


export const getPostCreateServicePropertyMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCreateServiceProperty>>, TError,{data: BodyType<CreatePropertyDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postCreateServiceProperty>>, TError,{data: BodyType<CreatePropertyDTO>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCreateServiceProperty>>, {data: BodyType<CreatePropertyDTO>}> = (props) => {
          const {data} = props ?? {};

          return  postCreateServiceProperty(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostCreateServicePropertyMutationResult = NonNullable<Awaited<ReturnType<typeof postCreateServiceProperty>>>
    export type PostCreateServicePropertyMutationBody = BodyType<CreatePropertyDTO>
    export type PostCreateServicePropertyMutationError = ErrorType<unknown>

    export const usePostCreateServiceProperty = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCreateServiceProperty>>, TError,{data: BodyType<CreatePropertyDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postCreateServiceProperty>>,
        TError,
        {data: BodyType<CreatePropertyDTO>},
        TContext
      > => {

      const mutationOptions = getPostCreateServicePropertyMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getFetchServicePropertyAttribute = (
    id: MaybeRef<string>,
 options?: SecondParameter<typeof axios>,signal?: AbortSignal
) => {
      id = unref(id);
      
      return axios<FetchServicePropertyAttributeResponse>(
      {url: `/api/service-property-attribute/${id}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetFetchServicePropertyAttributeQueryKey = (id: MaybeRef<string>,) => {
    return ['api','service-property-attribute',id] as const;
    }

    
export const getGetFetchServicePropertyAttributeQueryOptions = <TData = Awaited<ReturnType<typeof getFetchServicePropertyAttribute>>, TError = ErrorType<unknown>>(id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFetchServicePropertyAttribute>>, TError, TData>>, request?: SecondParameter<typeof axios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getGetFetchServicePropertyAttributeQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFetchServicePropertyAttribute>>> = ({ signal }) => getFetchServicePropertyAttribute(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: computed(() => !!(unref(id))), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFetchServicePropertyAttribute>>, TError, TData> 
}

export type GetFetchServicePropertyAttributeQueryResult = NonNullable<Awaited<ReturnType<typeof getFetchServicePropertyAttribute>>>
export type GetFetchServicePropertyAttributeQueryError = ErrorType<unknown>

export const useGetFetchServicePropertyAttribute = <TData = Awaited<ReturnType<typeof getFetchServicePropertyAttribute>>, TError = ErrorType<unknown>>(
 id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFetchServicePropertyAttribute>>, TError, TData>>, request?: SecondParameter<typeof axios>}

  ): UseQueryReturnType<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetFetchServicePropertyAttributeQueryOptions(id,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: QueryKey };

  query.queryKey = unref(queryOptions).queryKey as QueryKey;

  return query;
}




export const postFetchAllServicePropertyAttributes = (
    servicePropertyAttributeFiltersDTO: MaybeRef<ServicePropertyAttributeFiltersDTO>,
    params?: MaybeRef<PostFetchAllServicePropertyAttributesParams>,
 options?: SecondParameter<typeof axios>,) => {
      servicePropertyAttributeFiltersDTO = unref(servicePropertyAttributeFiltersDTO);
params = unref(params);
      
      return axios<FetchAllServicePropertyAttributesResponse>(
      {url: `/api/service-property-attributes`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: servicePropertyAttributeFiltersDTO,
        params: unref(params)
    },
      options);
    }
  


export const getPostFetchAllServicePropertyAttributesMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postFetchAllServicePropertyAttributes>>, TError,{data: BodyType<ServicePropertyAttributeFiltersDTO>;params?: PostFetchAllServicePropertyAttributesParams}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postFetchAllServicePropertyAttributes>>, TError,{data: BodyType<ServicePropertyAttributeFiltersDTO>;params?: PostFetchAllServicePropertyAttributesParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postFetchAllServicePropertyAttributes>>, {data: BodyType<ServicePropertyAttributeFiltersDTO>;params?: PostFetchAllServicePropertyAttributesParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postFetchAllServicePropertyAttributes(data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostFetchAllServicePropertyAttributesMutationResult = NonNullable<Awaited<ReturnType<typeof postFetchAllServicePropertyAttributes>>>
    export type PostFetchAllServicePropertyAttributesMutationBody = BodyType<ServicePropertyAttributeFiltersDTO>
    export type PostFetchAllServicePropertyAttributesMutationError = ErrorType<unknown>

    export const usePostFetchAllServicePropertyAttributes = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postFetchAllServicePropertyAttributes>>, TError,{data: BodyType<ServicePropertyAttributeFiltersDTO>;params?: PostFetchAllServicePropertyAttributesParams}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postFetchAllServicePropertyAttributes>>,
        TError,
        {data: BodyType<ServicePropertyAttributeFiltersDTO>;params?: PostFetchAllServicePropertyAttributesParams},
        TContext
      > => {

      const mutationOptions = getPostFetchAllServicePropertyAttributesMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postCreateServicePropertyAttribute = (
    createServicePropertyAttributeDTO: MaybeRef<CreateServicePropertyAttributeDTO>,
 options?: SecondParameter<typeof axios>,) => {
      createServicePropertyAttributeDTO = unref(createServicePropertyAttributeDTO);
      
      return axios<CreateResponse>(
      {url: `/api/service-property-attribute`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createServicePropertyAttributeDTO
    },
      options);
    }
  


export const getPostCreateServicePropertyAttributeMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCreateServicePropertyAttribute>>, TError,{data: BodyType<CreateServicePropertyAttributeDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postCreateServicePropertyAttribute>>, TError,{data: BodyType<CreateServicePropertyAttributeDTO>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCreateServicePropertyAttribute>>, {data: BodyType<CreateServicePropertyAttributeDTO>}> = (props) => {
          const {data} = props ?? {};

          return  postCreateServicePropertyAttribute(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostCreateServicePropertyAttributeMutationResult = NonNullable<Awaited<ReturnType<typeof postCreateServicePropertyAttribute>>>
    export type PostCreateServicePropertyAttributeMutationBody = BodyType<CreateServicePropertyAttributeDTO>
    export type PostCreateServicePropertyAttributeMutationError = ErrorType<unknown>

    export const usePostCreateServicePropertyAttribute = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCreateServicePropertyAttribute>>, TError,{data: BodyType<CreateServicePropertyAttributeDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postCreateServicePropertyAttribute>>,
        TError,
        {data: BodyType<CreateServicePropertyAttributeDTO>},
        TContext
      > => {

      const mutationOptions = getPostCreateServicePropertyAttributeMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postFetchAllCategoryPropertyAttributes = (
    id: MaybeRef<string>,
 options?: SecondParameter<typeof axios>,) => {
      id = unref(id);
      
      return axios<FetchPropertyAttributeResponse[]>(
      {url: `/api/category/${id}/property-attributes`, method: 'POST'
    },
      options);
    }
  


export const getPostFetchAllCategoryPropertyAttributesMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postFetchAllCategoryPropertyAttributes>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postFetchAllCategoryPropertyAttributes>>, TError,{id: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postFetchAllCategoryPropertyAttributes>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  postFetchAllCategoryPropertyAttributes(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostFetchAllCategoryPropertyAttributesMutationResult = NonNullable<Awaited<ReturnType<typeof postFetchAllCategoryPropertyAttributes>>>
    
    export type PostFetchAllCategoryPropertyAttributesMutationError = ErrorType<unknown>

    export const usePostFetchAllCategoryPropertyAttributes = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postFetchAllCategoryPropertyAttributes>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postFetchAllCategoryPropertyAttributes>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getPostFetchAllCategoryPropertyAttributesMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postFetchAllCases = (
    
 options?: SecondParameter<typeof axios>,) => {
      
      
      return axios<FetchAllCases>(
      {url: `/api/cases`, method: 'POST'
    },
      options);
    }
  


export const getPostFetchAllCasesMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postFetchAllCases>>, TError,void, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postFetchAllCases>>, TError,void, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postFetchAllCases>>, void> = () => {
          

          return  postFetchAllCases(requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostFetchAllCasesMutationResult = NonNullable<Awaited<ReturnType<typeof postFetchAllCases>>>
    
    export type PostFetchAllCasesMutationError = ErrorType<unknown>

    export const usePostFetchAllCases = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postFetchAllCases>>, TError,void, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postFetchAllCases>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getPostFetchAllCasesMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postUpdateUnitStatus = (
    id: MaybeRef<string>,
    updateUnitStatusDTO: MaybeRef<UpdateUnitStatusDTO>,
 options?: SecondParameter<typeof axios>,) => {
      id = unref(id);
updateUnitStatusDTO = unref(updateUnitStatusDTO);
      
      return axios<void>(
      {url: `/api/unit/${id}/status`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: updateUnitStatusDTO
    },
      options);
    }
  


export const getPostUpdateUnitStatusMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUpdateUnitStatus>>, TError,{id: string;data: BodyType<UpdateUnitStatusDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postUpdateUnitStatus>>, TError,{id: string;data: BodyType<UpdateUnitStatusDTO>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postUpdateUnitStatus>>, {id: string;data: BodyType<UpdateUnitStatusDTO>}> = (props) => {
          const {id,data} = props ?? {};

          return  postUpdateUnitStatus(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostUpdateUnitStatusMutationResult = NonNullable<Awaited<ReturnType<typeof postUpdateUnitStatus>>>
    export type PostUpdateUnitStatusMutationBody = BodyType<UpdateUnitStatusDTO>
    export type PostUpdateUnitStatusMutationError = ErrorType<unknown>

    export const usePostUpdateUnitStatus = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUpdateUnitStatus>>, TError,{id: string;data: BodyType<UpdateUnitStatusDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postUpdateUnitStatus>>,
        TError,
        {id: string;data: BodyType<UpdateUnitStatusDTO>},
        TContext
      > => {

      const mutationOptions = getPostUpdateUnitStatusMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postSyncUnits = (
    
 options?: SecondParameter<typeof axios>,) => {
      
      
      return axios<void>(
      {url: `/api/units/sync`, method: 'POST'
    },
      options);
    }
  


export const getPostSyncUnitsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postSyncUnits>>, TError,void, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postSyncUnits>>, TError,void, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postSyncUnits>>, void> = () => {
          

          return  postSyncUnits(requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostSyncUnitsMutationResult = NonNullable<Awaited<ReturnType<typeof postSyncUnits>>>
    
    export type PostSyncUnitsMutationError = ErrorType<unknown>

    export const usePostSyncUnits = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postSyncUnits>>, TError,void, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postSyncUnits>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getPostSyncUnitsMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postFetchAllFiles = (
    
 options?: SecondParameter<typeof axios>,) => {
      
      
      return axios<void>(
      {url: `/api/files`, method: 'POST'
    },
      options);
    }
  


export const getPostFetchAllFilesMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postFetchAllFiles>>, TError,void, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postFetchAllFiles>>, TError,void, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postFetchAllFiles>>, void> = () => {
          

          return  postFetchAllFiles(requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostFetchAllFilesMutationResult = NonNullable<Awaited<ReturnType<typeof postFetchAllFiles>>>
    
    export type PostFetchAllFilesMutationError = ErrorType<void>

    export const usePostFetchAllFiles = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postFetchAllFiles>>, TError,void, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postFetchAllFiles>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getPostFetchAllFilesMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postAddFileToContract = (
    id: MaybeRef<string>,
    addSignatureDTO: MaybeRef<AddSignatureDTO>,
 options?: SecondParameter<typeof axios>,) => {
      id = unref(id);
addSignatureDTO = unref(addSignatureDTO);
      
      return axios<void>(
      {url: `/api/contract/${id}/add-file`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: addSignatureDTO
    },
      options);
    }
  


export const getPostAddFileToContractMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAddFileToContract>>, TError,{id: string;data: BodyType<AddSignatureDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postAddFileToContract>>, TError,{id: string;data: BodyType<AddSignatureDTO>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAddFileToContract>>, {id: string;data: BodyType<AddSignatureDTO>}> = (props) => {
          const {id,data} = props ?? {};

          return  postAddFileToContract(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAddFileToContractMutationResult = NonNullable<Awaited<ReturnType<typeof postAddFileToContract>>>
    export type PostAddFileToContractMutationBody = BodyType<AddSignatureDTO>
    export type PostAddFileToContractMutationError = ErrorType<unknown>

    export const usePostAddFileToContract = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAddFileToContract>>, TError,{id: string;data: BodyType<AddSignatureDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postAddFileToContract>>,
        TError,
        {id: string;data: BodyType<AddSignatureDTO>},
        TContext
      > => {

      const mutationOptions = getPostAddFileToContractMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postAddSignatureToContract = (
    id: MaybeRef<string>,
    addSignatureDTO: MaybeRef<AddSignatureDTO>,
 options?: SecondParameter<typeof axios>,) => {
      id = unref(id);
addSignatureDTO = unref(addSignatureDTO);
      
      return axios<void>(
      {url: `/api/contract/${id}/add-signature`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: addSignatureDTO
    },
      options);
    }
  


export const getPostAddSignatureToContractMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAddSignatureToContract>>, TError,{id: string;data: BodyType<AddSignatureDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postAddSignatureToContract>>, TError,{id: string;data: BodyType<AddSignatureDTO>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAddSignatureToContract>>, {id: string;data: BodyType<AddSignatureDTO>}> = (props) => {
          const {id,data} = props ?? {};

          return  postAddSignatureToContract(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAddSignatureToContractMutationResult = NonNullable<Awaited<ReturnType<typeof postAddSignatureToContract>>>
    export type PostAddSignatureToContractMutationBody = BodyType<AddSignatureDTO>
    export type PostAddSignatureToContractMutationError = ErrorType<unknown>

    export const usePostAddSignatureToContract = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAddSignatureToContract>>, TError,{id: string;data: BodyType<AddSignatureDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postAddSignatureToContract>>,
        TError,
        {id: string;data: BodyType<AddSignatureDTO>},
        TContext
      > => {

      const mutationOptions = getPostAddSignatureToContractMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getFetchAdjustment = (
    id: MaybeRef<string>,
 options?: SecondParameter<typeof axios>,signal?: AbortSignal
) => {
      id = unref(id);
      
      return axios<FetchAdjustmentResponse>(
      {url: `/api/adjustment/${id}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetFetchAdjustmentQueryKey = (id: MaybeRef<string>,) => {
    return ['api','adjustment',id] as const;
    }

    
export const getGetFetchAdjustmentQueryOptions = <TData = Awaited<ReturnType<typeof getFetchAdjustment>>, TError = ErrorType<unknown>>(id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFetchAdjustment>>, TError, TData>>, request?: SecondParameter<typeof axios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getGetFetchAdjustmentQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFetchAdjustment>>> = ({ signal }) => getFetchAdjustment(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: computed(() => !!(unref(id))), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFetchAdjustment>>, TError, TData> 
}

export type GetFetchAdjustmentQueryResult = NonNullable<Awaited<ReturnType<typeof getFetchAdjustment>>>
export type GetFetchAdjustmentQueryError = ErrorType<unknown>

export const useGetFetchAdjustment = <TData = Awaited<ReturnType<typeof getFetchAdjustment>>, TError = ErrorType<unknown>>(
 id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFetchAdjustment>>, TError, TData>>, request?: SecondParameter<typeof axios>}

  ): UseQueryReturnType<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetFetchAdjustmentQueryOptions(id,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: QueryKey };

  query.queryKey = unref(queryOptions).queryKey as QueryKey;

  return query;
}




export const postFetchAdjustments = (
    params?: MaybeRef<PostFetchAdjustmentsParams>,
 options?: SecondParameter<typeof axios>,) => {
      params = unref(params);
      
      return axios<FetchAllAdjustments>(
      {url: `/api/adjustments`, method: 'POST',
        params: unref(params)
    },
      options);
    }
  


export const getPostFetchAdjustmentsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postFetchAdjustments>>, TError,{params?: PostFetchAdjustmentsParams}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postFetchAdjustments>>, TError,{params?: PostFetchAdjustmentsParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postFetchAdjustments>>, {params?: PostFetchAdjustmentsParams}> = (props) => {
          const {params} = props ?? {};

          return  postFetchAdjustments(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostFetchAdjustmentsMutationResult = NonNullable<Awaited<ReturnType<typeof postFetchAdjustments>>>
    
    export type PostFetchAdjustmentsMutationError = ErrorType<unknown>

    export const usePostFetchAdjustments = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postFetchAdjustments>>, TError,{params?: PostFetchAdjustmentsParams}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postFetchAdjustments>>,
        TError,
        {params?: PostFetchAdjustmentsParams},
        TContext
      > => {

      const mutationOptions = getPostFetchAdjustmentsMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postCreateAdjustment = (
    createAdjustmentDTO: MaybeRef<CreateAdjustmentDTO>,
 options?: SecondParameter<typeof axios>,) => {
      createAdjustmentDTO = unref(createAdjustmentDTO);
      
      return axios<CreateResponse>(
      {url: `/api/adjustment`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createAdjustmentDTO
    },
      options);
    }
  


export const getPostCreateAdjustmentMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCreateAdjustment>>, TError,{data: BodyType<CreateAdjustmentDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postCreateAdjustment>>, TError,{data: BodyType<CreateAdjustmentDTO>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCreateAdjustment>>, {data: BodyType<CreateAdjustmentDTO>}> = (props) => {
          const {data} = props ?? {};

          return  postCreateAdjustment(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostCreateAdjustmentMutationResult = NonNullable<Awaited<ReturnType<typeof postCreateAdjustment>>>
    export type PostCreateAdjustmentMutationBody = BodyType<CreateAdjustmentDTO>
    export type PostCreateAdjustmentMutationError = ErrorType<unknown>

    export const usePostCreateAdjustment = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCreateAdjustment>>, TError,{data: BodyType<CreateAdjustmentDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postCreateAdjustment>>,
        TError,
        {data: BodyType<CreateAdjustmentDTO>},
        TContext
      > => {

      const mutationOptions = getPostCreateAdjustmentMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postFetchAllAdjustmentsByTicketId = (
    id: MaybeRef<string>,
 options?: SecondParameter<typeof axios>,) => {
      id = unref(id);
      
      return axios<FetchAdjustmentResponse[]>(
      {url: `/api/adjustment/ticket/${id}/adjustments`, method: 'POST'
    },
      options);
    }
  


export const getPostFetchAllAdjustmentsByTicketIdMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postFetchAllAdjustmentsByTicketId>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postFetchAllAdjustmentsByTicketId>>, TError,{id: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postFetchAllAdjustmentsByTicketId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  postFetchAllAdjustmentsByTicketId(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostFetchAllAdjustmentsByTicketIdMutationResult = NonNullable<Awaited<ReturnType<typeof postFetchAllAdjustmentsByTicketId>>>
    
    export type PostFetchAllAdjustmentsByTicketIdMutationError = ErrorType<unknown>

    export const usePostFetchAllAdjustmentsByTicketId = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postFetchAllAdjustmentsByTicketId>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postFetchAllAdjustmentsByTicketId>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getPostFetchAllAdjustmentsByTicketIdMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postFetchAllAdjustmentsByUnitId = (
    id: MaybeRef<string>,
 options?: SecondParameter<typeof axios>,) => {
      id = unref(id);
      
      return axios<FetchAdjustmentResponse[]>(
      {url: `/api/adjustment/unit/${id}/adjustments`, method: 'POST'
    },
      options);
    }
  


export const getPostFetchAllAdjustmentsByUnitIdMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postFetchAllAdjustmentsByUnitId>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postFetchAllAdjustmentsByUnitId>>, TError,{id: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postFetchAllAdjustmentsByUnitId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  postFetchAllAdjustmentsByUnitId(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostFetchAllAdjustmentsByUnitIdMutationResult = NonNullable<Awaited<ReturnType<typeof postFetchAllAdjustmentsByUnitId>>>
    
    export type PostFetchAllAdjustmentsByUnitIdMutationError = ErrorType<unknown>

    export const usePostFetchAllAdjustmentsByUnitId = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postFetchAllAdjustmentsByUnitId>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postFetchAllAdjustmentsByUnitId>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getPostFetchAllAdjustmentsByUnitIdMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postFetchAllAdjustmentsByOrganisationId = (
    id: MaybeRef<string>,
 options?: SecondParameter<typeof axios>,) => {
      id = unref(id);
      
      return axios<FetchAdjustmentResponse[]>(
      {url: `/api/adjustment/organisation/${id}/adjustments`, method: 'POST'
    },
      options);
    }
  


export const getPostFetchAllAdjustmentsByOrganisationIdMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postFetchAllAdjustmentsByOrganisationId>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postFetchAllAdjustmentsByOrganisationId>>, TError,{id: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postFetchAllAdjustmentsByOrganisationId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  postFetchAllAdjustmentsByOrganisationId(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostFetchAllAdjustmentsByOrganisationIdMutationResult = NonNullable<Awaited<ReturnType<typeof postFetchAllAdjustmentsByOrganisationId>>>
    
    export type PostFetchAllAdjustmentsByOrganisationIdMutationError = ErrorType<unknown>

    export const usePostFetchAllAdjustmentsByOrganisationId = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postFetchAllAdjustmentsByOrganisationId>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postFetchAllAdjustmentsByOrganisationId>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getPostFetchAllAdjustmentsByOrganisationIdMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postFetchAllAdjustmentsByContractId = (
    id: MaybeRef<string>,
 options?: SecondParameter<typeof axios>,) => {
      id = unref(id);
      
      return axios<FetchAdjustmentResponse[]>(
      {url: `/api/adjustment/contract/${id}/adjustments`, method: 'POST'
    },
      options);
    }
  


export const getPostFetchAllAdjustmentsByContractIdMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postFetchAllAdjustmentsByContractId>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postFetchAllAdjustmentsByContractId>>, TError,{id: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postFetchAllAdjustmentsByContractId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  postFetchAllAdjustmentsByContractId(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostFetchAllAdjustmentsByContractIdMutationResult = NonNullable<Awaited<ReturnType<typeof postFetchAllAdjustmentsByContractId>>>
    
    export type PostFetchAllAdjustmentsByContractIdMutationError = ErrorType<unknown>

    export const usePostFetchAllAdjustmentsByContractId = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postFetchAllAdjustmentsByContractId>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postFetchAllAdjustmentsByContractId>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getPostFetchAllAdjustmentsByContractIdMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postFetchAllAdjustmentsByArticleId = (
    id: MaybeRef<string>,
 options?: SecondParameter<typeof axios>,) => {
      id = unref(id);
      
      return axios<FetchAdjustmentResponse[]>(
      {url: `/api/adjustment/article/${id}/adjustments`, method: 'POST'
    },
      options);
    }
  


export const getPostFetchAllAdjustmentsByArticleIdMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postFetchAllAdjustmentsByArticleId>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postFetchAllAdjustmentsByArticleId>>, TError,{id: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postFetchAllAdjustmentsByArticleId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  postFetchAllAdjustmentsByArticleId(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostFetchAllAdjustmentsByArticleIdMutationResult = NonNullable<Awaited<ReturnType<typeof postFetchAllAdjustmentsByArticleId>>>
    
    export type PostFetchAllAdjustmentsByArticleIdMutationError = ErrorType<unknown>

    export const usePostFetchAllAdjustmentsByArticleId = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postFetchAllAdjustmentsByArticleId>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postFetchAllAdjustmentsByArticleId>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getPostFetchAllAdjustmentsByArticleIdMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postFetchAllAdjustmentsByAbstractActionId = (
    id: MaybeRef<string>,
 options?: SecondParameter<typeof axios>,) => {
      id = unref(id);
      
      return axios<FetchAdjustmentResponse[]>(
      {url: `/api/adjustment/abstract-action/${id}/adjustments`, method: 'POST'
    },
      options);
    }
  


export const getPostFetchAllAdjustmentsByAbstractActionIdMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postFetchAllAdjustmentsByAbstractActionId>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postFetchAllAdjustmentsByAbstractActionId>>, TError,{id: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postFetchAllAdjustmentsByAbstractActionId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  postFetchAllAdjustmentsByAbstractActionId(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostFetchAllAdjustmentsByAbstractActionIdMutationResult = NonNullable<Awaited<ReturnType<typeof postFetchAllAdjustmentsByAbstractActionId>>>
    
    export type PostFetchAllAdjustmentsByAbstractActionIdMutationError = ErrorType<unknown>

    export const usePostFetchAllAdjustmentsByAbstractActionId = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postFetchAllAdjustmentsByAbstractActionId>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postFetchAllAdjustmentsByAbstractActionId>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getPostFetchAllAdjustmentsByAbstractActionIdMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postAddAdjustmentToUnit = (
    id: MaybeRef<string>,
    unitId: MaybeRef<string>,
 options?: SecondParameter<typeof axios>,) => {
      id = unref(id);
unitId = unref(unitId);
      
      return axios<void>(
      {url: `/api/adjustment/${id}/unit/${unitId}`, method: 'POST'
    },
      options);
    }
  


export const getPostAddAdjustmentToUnitMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAddAdjustmentToUnit>>, TError,{id: string;unitId: string}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postAddAdjustmentToUnit>>, TError,{id: string;unitId: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAddAdjustmentToUnit>>, {id: string;unitId: string}> = (props) => {
          const {id,unitId} = props ?? {};

          return  postAddAdjustmentToUnit(id,unitId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAddAdjustmentToUnitMutationResult = NonNullable<Awaited<ReturnType<typeof postAddAdjustmentToUnit>>>
    
    export type PostAddAdjustmentToUnitMutationError = ErrorType<unknown>

    export const usePostAddAdjustmentToUnit = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAddAdjustmentToUnit>>, TError,{id: string;unitId: string}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postAddAdjustmentToUnit>>,
        TError,
        {id: string;unitId: string},
        TContext
      > => {

      const mutationOptions = getPostAddAdjustmentToUnitMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postAddAdjustmentToTicket = (
    id: MaybeRef<string>,
    ticketId: MaybeRef<string>,
 options?: SecondParameter<typeof axios>,) => {
      id = unref(id);
ticketId = unref(ticketId);
      
      return axios<void>(
      {url: `/api/adjustment/${id}/ticket/${ticketId}`, method: 'POST'
    },
      options);
    }
  


export const getPostAddAdjustmentToTicketMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAddAdjustmentToTicket>>, TError,{id: string;ticketId: string}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postAddAdjustmentToTicket>>, TError,{id: string;ticketId: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAddAdjustmentToTicket>>, {id: string;ticketId: string}> = (props) => {
          const {id,ticketId} = props ?? {};

          return  postAddAdjustmentToTicket(id,ticketId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAddAdjustmentToTicketMutationResult = NonNullable<Awaited<ReturnType<typeof postAddAdjustmentToTicket>>>
    
    export type PostAddAdjustmentToTicketMutationError = ErrorType<unknown>

    export const usePostAddAdjustmentToTicket = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAddAdjustmentToTicket>>, TError,{id: string;ticketId: string}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postAddAdjustmentToTicket>>,
        TError,
        {id: string;ticketId: string},
        TContext
      > => {

      const mutationOptions = getPostAddAdjustmentToTicketMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postAddAdjustmentToOrganisation = (
    id: MaybeRef<string>,
    organisationId: MaybeRef<string>,
 options?: SecondParameter<typeof axios>,) => {
      id = unref(id);
organisationId = unref(organisationId);
      
      return axios<void>(
      {url: `/api/adjustment/${id}/organisation/${organisationId}`, method: 'POST'
    },
      options);
    }
  


export const getPostAddAdjustmentToOrganisationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAddAdjustmentToOrganisation>>, TError,{id: string;organisationId: string}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postAddAdjustmentToOrganisation>>, TError,{id: string;organisationId: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAddAdjustmentToOrganisation>>, {id: string;organisationId: string}> = (props) => {
          const {id,organisationId} = props ?? {};

          return  postAddAdjustmentToOrganisation(id,organisationId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAddAdjustmentToOrganisationMutationResult = NonNullable<Awaited<ReturnType<typeof postAddAdjustmentToOrganisation>>>
    
    export type PostAddAdjustmentToOrganisationMutationError = ErrorType<unknown>

    export const usePostAddAdjustmentToOrganisation = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAddAdjustmentToOrganisation>>, TError,{id: string;organisationId: string}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postAddAdjustmentToOrganisation>>,
        TError,
        {id: string;organisationId: string},
        TContext
      > => {

      const mutationOptions = getPostAddAdjustmentToOrganisationMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postAddAdjustmentToContract = (
    id: MaybeRef<string>,
    contractId: MaybeRef<string>,
 options?: SecondParameter<typeof axios>,) => {
      id = unref(id);
contractId = unref(contractId);
      
      return axios<void>(
      {url: `/api/adjustment/${id}/contract/${contractId}`, method: 'POST'
    },
      options);
    }
  


export const getPostAddAdjustmentToContractMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAddAdjustmentToContract>>, TError,{id: string;contractId: string}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postAddAdjustmentToContract>>, TError,{id: string;contractId: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAddAdjustmentToContract>>, {id: string;contractId: string}> = (props) => {
          const {id,contractId} = props ?? {};

          return  postAddAdjustmentToContract(id,contractId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAddAdjustmentToContractMutationResult = NonNullable<Awaited<ReturnType<typeof postAddAdjustmentToContract>>>
    
    export type PostAddAdjustmentToContractMutationError = ErrorType<unknown>

    export const usePostAddAdjustmentToContract = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAddAdjustmentToContract>>, TError,{id: string;contractId: string}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postAddAdjustmentToContract>>,
        TError,
        {id: string;contractId: string},
        TContext
      > => {

      const mutationOptions = getPostAddAdjustmentToContractMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postAddAdjustmentToArticle = (
    id: MaybeRef<string>,
    articleId: MaybeRef<string>,
 options?: SecondParameter<typeof axios>,) => {
      id = unref(id);
articleId = unref(articleId);
      
      return axios<void>(
      {url: `/api/adjustment/${id}/article/${articleId}`, method: 'POST'
    },
      options);
    }
  


export const getPostAddAdjustmentToArticleMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAddAdjustmentToArticle>>, TError,{id: string;articleId: string}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postAddAdjustmentToArticle>>, TError,{id: string;articleId: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAddAdjustmentToArticle>>, {id: string;articleId: string}> = (props) => {
          const {id,articleId} = props ?? {};

          return  postAddAdjustmentToArticle(id,articleId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAddAdjustmentToArticleMutationResult = NonNullable<Awaited<ReturnType<typeof postAddAdjustmentToArticle>>>
    
    export type PostAddAdjustmentToArticleMutationError = ErrorType<unknown>

    export const usePostAddAdjustmentToArticle = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAddAdjustmentToArticle>>, TError,{id: string;articleId: string}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postAddAdjustmentToArticle>>,
        TError,
        {id: string;articleId: string},
        TContext
      > => {

      const mutationOptions = getPostAddAdjustmentToArticleMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postAddAdjustmentToAction = (
    id: MaybeRef<string>,
    actionId: MaybeRef<string>,
 options?: SecondParameter<typeof axios>,) => {
      id = unref(id);
actionId = unref(actionId);
      
      return axios<void>(
      {url: `/api/adjustment/${id}/action/${actionId}`, method: 'POST'
    },
      options);
    }
  


export const getPostAddAdjustmentToActionMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAddAdjustmentToAction>>, TError,{id: string;actionId: string}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postAddAdjustmentToAction>>, TError,{id: string;actionId: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAddAdjustmentToAction>>, {id: string;actionId: string}> = (props) => {
          const {id,actionId} = props ?? {};

          return  postAddAdjustmentToAction(id,actionId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAddAdjustmentToActionMutationResult = NonNullable<Awaited<ReturnType<typeof postAddAdjustmentToAction>>>
    
    export type PostAddAdjustmentToActionMutationError = ErrorType<unknown>

    export const usePostAddAdjustmentToAction = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAddAdjustmentToAction>>, TError,{id: string;actionId: string}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postAddAdjustmentToAction>>,
        TError,
        {id: string;actionId: string},
        TContext
      > => {

      const mutationOptions = getPostAddAdjustmentToActionMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postAddAdjustmentToRecipe = (
    id: MaybeRef<string>,
    recipeId: MaybeRef<string>,
 options?: SecondParameter<typeof axios>,) => {
      id = unref(id);
recipeId = unref(recipeId);
      
      return axios<void>(
      {url: `/api/adjustment/${id}/recipe/${recipeId}`, method: 'POST'
    },
      options);
    }
  


export const getPostAddAdjustmentToRecipeMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAddAdjustmentToRecipe>>, TError,{id: string;recipeId: string}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postAddAdjustmentToRecipe>>, TError,{id: string;recipeId: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAddAdjustmentToRecipe>>, {id: string;recipeId: string}> = (props) => {
          const {id,recipeId} = props ?? {};

          return  postAddAdjustmentToRecipe(id,recipeId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAddAdjustmentToRecipeMutationResult = NonNullable<Awaited<ReturnType<typeof postAddAdjustmentToRecipe>>>
    
    export type PostAddAdjustmentToRecipeMutationError = ErrorType<unknown>

    export const usePostAddAdjustmentToRecipe = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAddAdjustmentToRecipe>>, TError,{id: string;recipeId: string}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postAddAdjustmentToRecipe>>,
        TError,
        {id: string;recipeId: string},
        TContext
      > => {

      const mutationOptions = getPostAddAdjustmentToRecipeMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Export invoice data
 */
export const postExportInvoice = (
    
 options?: SecondParameter<typeof axios>,) => {
      
      
      return axios<PostExportInvoice200Item[]>(
      {url: `/api/invoice/export`, method: 'POST'
    },
      options);
    }
  


export const getPostExportInvoiceMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postExportInvoice>>, TError,void, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postExportInvoice>>, TError,void, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postExportInvoice>>, void> = () => {
          

          return  postExportInvoice(requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostExportInvoiceMutationResult = NonNullable<Awaited<ReturnType<typeof postExportInvoice>>>
    
    export type PostExportInvoiceMutationError = ErrorType<unknown>

    export const usePostExportInvoice = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postExportInvoice>>, TError,void, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postExportInvoice>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getPostExportInvoiceMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Fetch a template by ID
 * @summary Get template by ID
 */
export const getFetchTemplate = (
    id: MaybeRef<string>,
 options?: SecondParameter<typeof axios>,signal?: AbortSignal
) => {
      id = unref(id);
      
      return axios<void>(
      {url: `/api/template/${id}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetFetchTemplateQueryKey = (id: MaybeRef<string>,) => {
    return ['api','template',id] as const;
    }

    
export const getGetFetchTemplateQueryOptions = <TData = Awaited<ReturnType<typeof getFetchTemplate>>, TError = ErrorType<unknown>>(id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFetchTemplate>>, TError, TData>>, request?: SecondParameter<typeof axios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getGetFetchTemplateQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFetchTemplate>>> = ({ signal }) => getFetchTemplate(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: computed(() => !!(unref(id))), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFetchTemplate>>, TError, TData> 
}

export type GetFetchTemplateQueryResult = NonNullable<Awaited<ReturnType<typeof getFetchTemplate>>>
export type GetFetchTemplateQueryError = ErrorType<unknown>

/**
 * @summary Get template by ID
 */
export const useGetFetchTemplate = <TData = Awaited<ReturnType<typeof getFetchTemplate>>, TError = ErrorType<unknown>>(
 id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFetchTemplate>>, TError, TData>>, request?: SecondParameter<typeof axios>}

  ): UseQueryReturnType<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetFetchTemplateQueryOptions(id,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: QueryKey };

  query.queryKey = unref(queryOptions).queryKey as QueryKey;

  return query;
}




/**
 * Update an existing template
 * @summary Update template
 */
export const putUpdateTemplate = (
    id: MaybeRef<string>,
    updateTemplateDTO: MaybeRef<UpdateTemplateDTO>,
 options?: SecondParameter<typeof axios>,) => {
      id = unref(id);
updateTemplateDTO = unref(updateTemplateDTO);
      
      return axios<void>(
      {url: `/api/template/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateTemplateDTO
    },
      options);
    }
  


export const getPutUpdateTemplateMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putUpdateTemplate>>, TError,{id: string;data: BodyType<UpdateTemplateDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof putUpdateTemplate>>, TError,{id: string;data: BodyType<UpdateTemplateDTO>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putUpdateTemplate>>, {id: string;data: BodyType<UpdateTemplateDTO>}> = (props) => {
          const {id,data} = props ?? {};

          return  putUpdateTemplate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutUpdateTemplateMutationResult = NonNullable<Awaited<ReturnType<typeof putUpdateTemplate>>>
    export type PutUpdateTemplateMutationBody = BodyType<UpdateTemplateDTO>
    export type PutUpdateTemplateMutationError = ErrorType<unknown>

    /**
 * @summary Update template
 */
export const usePutUpdateTemplate = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putUpdateTemplate>>, TError,{id: string;data: BodyType<UpdateTemplateDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof putUpdateTemplate>>,
        TError,
        {id: string;data: BodyType<UpdateTemplateDTO>},
        TContext
      > => {

      const mutationOptions = getPutUpdateTemplateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Create a new template
 * @summary Create template
 */
export const postCreateTemplate = (
    createTemplateDTO: MaybeRef<CreateTemplateDTO>,
 options?: SecondParameter<typeof axios>,) => {
      createTemplateDTO = unref(createTemplateDTO);
      
      return axios<void>(
      {url: `/api/template`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createTemplateDTO
    },
      options);
    }
  


export const getPostCreateTemplateMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCreateTemplate>>, TError,{data: BodyType<CreateTemplateDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postCreateTemplate>>, TError,{data: BodyType<CreateTemplateDTO>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCreateTemplate>>, {data: BodyType<CreateTemplateDTO>}> = (props) => {
          const {data} = props ?? {};

          return  postCreateTemplate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostCreateTemplateMutationResult = NonNullable<Awaited<ReturnType<typeof postCreateTemplate>>>
    export type PostCreateTemplateMutationBody = BodyType<CreateTemplateDTO>
    export type PostCreateTemplateMutationError = ErrorType<unknown>

    /**
 * @summary Create template
 */
export const usePostCreateTemplate = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCreateTemplate>>, TError,{data: BodyType<CreateTemplateDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postCreateTemplate>>,
        TError,
        {data: BodyType<CreateTemplateDTO>},
        TContext
      > => {

      const mutationOptions = getPostCreateTemplateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postExecuteTemplate = (
    generateTemplateDTO: MaybeRef<GenerateTemplateDTO>,
 options?: SecondParameter<typeof axios>,) => {
      generateTemplateDTO = unref(generateTemplateDTO);
      
      return axios<void>(
      {url: `/api/template/execute`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: generateTemplateDTO
    },
      options);
    }
  


export const getPostExecuteTemplateMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postExecuteTemplate>>, TError,{data: BodyType<GenerateTemplateDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postExecuteTemplate>>, TError,{data: BodyType<GenerateTemplateDTO>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postExecuteTemplate>>, {data: BodyType<GenerateTemplateDTO>}> = (props) => {
          const {data} = props ?? {};

          return  postExecuteTemplate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostExecuteTemplateMutationResult = NonNullable<Awaited<ReturnType<typeof postExecuteTemplate>>>
    export type PostExecuteTemplateMutationBody = BodyType<GenerateTemplateDTO>
    export type PostExecuteTemplateMutationError = ErrorType<unknown>

    export const usePostExecuteTemplate = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postExecuteTemplate>>, TError,{data: BodyType<GenerateTemplateDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postExecuteTemplate>>,
        TError,
        {data: BodyType<GenerateTemplateDTO>},
        TContext
      > => {

      const mutationOptions = getPostExecuteTemplateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Generate a PDF from template
 * @summary Generate PDF from template
 */
export const postGenerateTemplatePdf = (
    postGenerateTemplatePdfBody: MaybeRef<PostGenerateTemplatePdfBody>,
 options?: SecondParameter<typeof axios>,) => {
      postGenerateTemplatePdfBody = unref(postGenerateTemplatePdfBody);
      
      return axios<void>(
      {url: `/api/template/pdf`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postGenerateTemplatePdfBody
    },
      options);
    }
  


export const getPostGenerateTemplatePdfMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postGenerateTemplatePdf>>, TError,{data: BodyType<PostGenerateTemplatePdfBody>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postGenerateTemplatePdf>>, TError,{data: BodyType<PostGenerateTemplatePdfBody>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postGenerateTemplatePdf>>, {data: BodyType<PostGenerateTemplatePdfBody>}> = (props) => {
          const {data} = props ?? {};

          return  postGenerateTemplatePdf(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostGenerateTemplatePdfMutationResult = NonNullable<Awaited<ReturnType<typeof postGenerateTemplatePdf>>>
    export type PostGenerateTemplatePdfMutationBody = BodyType<PostGenerateTemplatePdfBody>
    export type PostGenerateTemplatePdfMutationError = ErrorType<unknown>

    /**
 * @summary Generate PDF from template
 */
export const usePostGenerateTemplatePdf = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postGenerateTemplatePdf>>, TError,{data: BodyType<PostGenerateTemplatePdfBody>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postGenerateTemplatePdf>>,
        TError,
        {data: BodyType<PostGenerateTemplatePdfBody>},
        TContext
      > => {

      const mutationOptions = getPostGenerateTemplatePdfMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Add a new version to an existing template
 * @summary Add new template version
 */
export const postAddNewVersion = (
    addNewVersionDTO: MaybeRef<AddNewVersionDTO>,
 options?: SecondParameter<typeof axios>,) => {
      addNewVersionDTO = unref(addNewVersionDTO);
      
      return axios<void>(
      {url: `/api/template/add-new-version`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: addNewVersionDTO
    },
      options);
    }
  


export const getPostAddNewVersionMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAddNewVersion>>, TError,{data: BodyType<AddNewVersionDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postAddNewVersion>>, TError,{data: BodyType<AddNewVersionDTO>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAddNewVersion>>, {data: BodyType<AddNewVersionDTO>}> = (props) => {
          const {data} = props ?? {};

          return  postAddNewVersion(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAddNewVersionMutationResult = NonNullable<Awaited<ReturnType<typeof postAddNewVersion>>>
    export type PostAddNewVersionMutationBody = BodyType<AddNewVersionDTO>
    export type PostAddNewVersionMutationError = ErrorType<unknown>

    /**
 * @summary Add new template version
 */
export const usePostAddNewVersion = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAddNewVersion>>, TError,{data: BodyType<AddNewVersionDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postAddNewVersion>>,
        TError,
        {data: BodyType<AddNewVersionDTO>},
        TContext
      > => {

      const mutationOptions = getPostAddNewVersionMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Aggregates ticket data and sends to template service
 * @summary Fetch content for ticket template
 */
export const postFetchTemplateContent = (
    fetchContentDTO: MaybeRef<FetchContentDTO>,
 options?: SecondParameter<typeof axios>,) => {
      fetchContentDTO = unref(fetchContentDTO);
      
      return axios<void>(
      {url: `/api/template/content`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: fetchContentDTO
    },
      options);
    }
  


export const getPostFetchTemplateContentMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postFetchTemplateContent>>, TError,{data: BodyType<FetchContentDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postFetchTemplateContent>>, TError,{data: BodyType<FetchContentDTO>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postFetchTemplateContent>>, {data: BodyType<FetchContentDTO>}> = (props) => {
          const {data} = props ?? {};

          return  postFetchTemplateContent(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostFetchTemplateContentMutationResult = NonNullable<Awaited<ReturnType<typeof postFetchTemplateContent>>>
    export type PostFetchTemplateContentMutationBody = BodyType<FetchContentDTO>
    export type PostFetchTemplateContentMutationError = ErrorType<unknown>

    /**
 * @summary Fetch content for ticket template
 */
export const usePostFetchTemplateContent = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postFetchTemplateContent>>, TError,{data: BodyType<FetchContentDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postFetchTemplateContent>>,
        TError,
        {data: BodyType<FetchContentDTO>},
        TContext
      > => {

      const mutationOptions = getPostFetchTemplateContentMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Preview template with provided configuration
 * @summary Preview template
 */
export const postPreviewTemplate = (
    previewTemplateDTO: MaybeRef<PreviewTemplateDTO>,
 options?: SecondParameter<typeof axios>,) => {
      previewTemplateDTO = unref(previewTemplateDTO);
      
      return axios<void>(
      {url: `/api/template/preview`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: previewTemplateDTO
    },
      options);
    }
  


export const getPostPreviewTemplateMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPreviewTemplate>>, TError,{data: BodyType<PreviewTemplateDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postPreviewTemplate>>, TError,{data: BodyType<PreviewTemplateDTO>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postPreviewTemplate>>, {data: BodyType<PreviewTemplateDTO>}> = (props) => {
          const {data} = props ?? {};

          return  postPreviewTemplate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostPreviewTemplateMutationResult = NonNullable<Awaited<ReturnType<typeof postPreviewTemplate>>>
    export type PostPreviewTemplateMutationBody = BodyType<PreviewTemplateDTO>
    export type PostPreviewTemplateMutationError = ErrorType<unknown>

    /**
 * @summary Preview template
 */
export const usePostPreviewTemplate = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPreviewTemplate>>, TError,{data: BodyType<PreviewTemplateDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postPreviewTemplate>>,
        TError,
        {data: BodyType<PreviewTemplateDTO>},
        TContext
      > => {

      const mutationOptions = getPostPreviewTemplateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Add a component to a template
 * @summary Add component to template
 */
export const putAddComponentToTemplate = (
    id: MaybeRef<string>,
    addComponentToTemplateDTO: MaybeRef<AddComponentToTemplateDTO>,
 options?: SecondParameter<typeof axios>,) => {
      id = unref(id);
addComponentToTemplateDTO = unref(addComponentToTemplateDTO);
      
      return axios<void>(
      {url: `/api/template/${id}/add-component`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: addComponentToTemplateDTO
    },
      options);
    }
  


export const getPutAddComponentToTemplateMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAddComponentToTemplate>>, TError,{id: string;data: BodyType<AddComponentToTemplateDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof putAddComponentToTemplate>>, TError,{id: string;data: BodyType<AddComponentToTemplateDTO>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putAddComponentToTemplate>>, {id: string;data: BodyType<AddComponentToTemplateDTO>}> = (props) => {
          const {id,data} = props ?? {};

          return  putAddComponentToTemplate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutAddComponentToTemplateMutationResult = NonNullable<Awaited<ReturnType<typeof putAddComponentToTemplate>>>
    export type PutAddComponentToTemplateMutationBody = BodyType<AddComponentToTemplateDTO>
    export type PutAddComponentToTemplateMutationError = ErrorType<unknown>

    /**
 * @summary Add component to template
 */
export const usePutAddComponentToTemplate = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAddComponentToTemplate>>, TError,{id: string;data: BodyType<AddComponentToTemplateDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof putAddComponentToTemplate>>,
        TError,
        {id: string;data: BodyType<AddComponentToTemplateDTO>},
        TContext
      > => {

      const mutationOptions = getPutAddComponentToTemplateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Fetch a component by ID
 * @summary Get component by ID
 */
export const getFetchComponent = (
    id: MaybeRef<string>,
 options?: SecondParameter<typeof axios>,signal?: AbortSignal
) => {
      id = unref(id);
      
      return axios<void>(
      {url: `/api/component/${id}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetFetchComponentQueryKey = (id: MaybeRef<string>,) => {
    return ['api','component',id] as const;
    }

    
export const getGetFetchComponentQueryOptions = <TData = Awaited<ReturnType<typeof getFetchComponent>>, TError = ErrorType<unknown>>(id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFetchComponent>>, TError, TData>>, request?: SecondParameter<typeof axios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getGetFetchComponentQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFetchComponent>>> = ({ signal }) => getFetchComponent(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: computed(() => !!(unref(id))), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFetchComponent>>, TError, TData> 
}

export type GetFetchComponentQueryResult = NonNullable<Awaited<ReturnType<typeof getFetchComponent>>>
export type GetFetchComponentQueryError = ErrorType<unknown>

/**
 * @summary Get component by ID
 */
export const useGetFetchComponent = <TData = Awaited<ReturnType<typeof getFetchComponent>>, TError = ErrorType<unknown>>(
 id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFetchComponent>>, TError, TData>>, request?: SecondParameter<typeof axios>}

  ): UseQueryReturnType<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetFetchComponentQueryOptions(id,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: QueryKey };

  query.queryKey = unref(queryOptions).queryKey as QueryKey;

  return query;
}




/**
 * Update an existing component
 * @summary Update component
 */
export const putUpdateComponent = (
    id: MaybeRef<string>,
    updateComponentDTO: MaybeRef<UpdateComponentDTO>,
 options?: SecondParameter<typeof axios>,) => {
      id = unref(id);
updateComponentDTO = unref(updateComponentDTO);
      
      return axios<void>(
      {url: `/api/component/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateComponentDTO
    },
      options);
    }
  


export const getPutUpdateComponentMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putUpdateComponent>>, TError,{id: string;data: BodyType<UpdateComponentDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof putUpdateComponent>>, TError,{id: string;data: BodyType<UpdateComponentDTO>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putUpdateComponent>>, {id: string;data: BodyType<UpdateComponentDTO>}> = (props) => {
          const {id,data} = props ?? {};

          return  putUpdateComponent(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutUpdateComponentMutationResult = NonNullable<Awaited<ReturnType<typeof putUpdateComponent>>>
    export type PutUpdateComponentMutationBody = BodyType<UpdateComponentDTO>
    export type PutUpdateComponentMutationError = ErrorType<unknown>

    /**
 * @summary Update component
 */
export const usePutUpdateComponent = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putUpdateComponent>>, TError,{id: string;data: BodyType<UpdateComponentDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof putUpdateComponent>>,
        TError,
        {id: string;data: BodyType<UpdateComponentDTO>},
        TContext
      > => {

      const mutationOptions = getPutUpdateComponentMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Fetch all components
 * @summary Get all components
 */
export const postFetchAllComponents = (
    params?: MaybeRef<PostFetchAllComponentsParams>,
 options?: SecondParameter<typeof axios>,) => {
      params = unref(params);
      
      return axios<void>(
      {url: `/api/components`, method: 'POST',
        params: unref(params)
    },
      options);
    }
  


export const getPostFetchAllComponentsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postFetchAllComponents>>, TError,{params?: PostFetchAllComponentsParams}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postFetchAllComponents>>, TError,{params?: PostFetchAllComponentsParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postFetchAllComponents>>, {params?: PostFetchAllComponentsParams}> = (props) => {
          const {params} = props ?? {};

          return  postFetchAllComponents(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostFetchAllComponentsMutationResult = NonNullable<Awaited<ReturnType<typeof postFetchAllComponents>>>
    
    export type PostFetchAllComponentsMutationError = ErrorType<unknown>

    /**
 * @summary Get all components
 */
export const usePostFetchAllComponents = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postFetchAllComponents>>, TError,{params?: PostFetchAllComponentsParams}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postFetchAllComponents>>,
        TError,
        {params?: PostFetchAllComponentsParams},
        TContext
      > => {

      const mutationOptions = getPostFetchAllComponentsMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Create a new component
 * @summary Create component
 */
export const postCreateComponent = (
    createComponentDTO: MaybeRef<CreateComponentDTO>,
 options?: SecondParameter<typeof axios>,) => {
      createComponentDTO = unref(createComponentDTO);
      
      return axios<void>(
      {url: `/api/component`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createComponentDTO
    },
      options);
    }
  


export const getPostCreateComponentMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCreateComponent>>, TError,{data: BodyType<CreateComponentDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postCreateComponent>>, TError,{data: BodyType<CreateComponentDTO>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCreateComponent>>, {data: BodyType<CreateComponentDTO>}> = (props) => {
          const {data} = props ?? {};

          return  postCreateComponent(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostCreateComponentMutationResult = NonNullable<Awaited<ReturnType<typeof postCreateComponent>>>
    export type PostCreateComponentMutationBody = BodyType<CreateComponentDTO>
    export type PostCreateComponentMutationError = ErrorType<unknown>

    /**
 * @summary Create component
 */
export const usePostCreateComponent = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCreateComponent>>, TError,{data: BodyType<CreateComponentDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postCreateComponent>>,
        TError,
        {data: BodyType<CreateComponentDTO>},
        TContext
      > => {

      const mutationOptions = getPostCreateComponentMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Fetch a layout by ID
 * @summary Get layout by ID
 */
export const getFetchLayout = (
    id: MaybeRef<string>,
 options?: SecondParameter<typeof axios>,signal?: AbortSignal
) => {
      id = unref(id);
      
      return axios<void>(
      {url: `/api/layout/${id}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetFetchLayoutQueryKey = (id: MaybeRef<string>,) => {
    return ['api','layout',id] as const;
    }

    
export const getGetFetchLayoutQueryOptions = <TData = Awaited<ReturnType<typeof getFetchLayout>>, TError = ErrorType<unknown>>(id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFetchLayout>>, TError, TData>>, request?: SecondParameter<typeof axios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getGetFetchLayoutQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFetchLayout>>> = ({ signal }) => getFetchLayout(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: computed(() => !!(unref(id))), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFetchLayout>>, TError, TData> 
}

export type GetFetchLayoutQueryResult = NonNullable<Awaited<ReturnType<typeof getFetchLayout>>>
export type GetFetchLayoutQueryError = ErrorType<unknown>

/**
 * @summary Get layout by ID
 */
export const useGetFetchLayout = <TData = Awaited<ReturnType<typeof getFetchLayout>>, TError = ErrorType<unknown>>(
 id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFetchLayout>>, TError, TData>>, request?: SecondParameter<typeof axios>}

  ): UseQueryReturnType<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetFetchLayoutQueryOptions(id,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: QueryKey };

  query.queryKey = unref(queryOptions).queryKey as QueryKey;

  return query;
}




/**
 * Update an existing layout
 * @summary Update layout
 */
export const putUpdateLayout = (
    id: MaybeRef<string>,
    updateLayoutDTO: MaybeRef<UpdateLayoutDTO>,
 options?: SecondParameter<typeof axios>,) => {
      id = unref(id);
updateLayoutDTO = unref(updateLayoutDTO);
      
      return axios<void>(
      {url: `/api/layout/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateLayoutDTO
    },
      options);
    }
  


export const getPutUpdateLayoutMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putUpdateLayout>>, TError,{id: string;data: BodyType<UpdateLayoutDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof putUpdateLayout>>, TError,{id: string;data: BodyType<UpdateLayoutDTO>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putUpdateLayout>>, {id: string;data: BodyType<UpdateLayoutDTO>}> = (props) => {
          const {id,data} = props ?? {};

          return  putUpdateLayout(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutUpdateLayoutMutationResult = NonNullable<Awaited<ReturnType<typeof putUpdateLayout>>>
    export type PutUpdateLayoutMutationBody = BodyType<UpdateLayoutDTO>
    export type PutUpdateLayoutMutationError = ErrorType<unknown>

    /**
 * @summary Update layout
 */
export const usePutUpdateLayout = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putUpdateLayout>>, TError,{id: string;data: BodyType<UpdateLayoutDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof putUpdateLayout>>,
        TError,
        {id: string;data: BodyType<UpdateLayoutDTO>},
        TContext
      > => {

      const mutationOptions = getPutUpdateLayoutMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Fetch all layouts
 * @summary Get all layouts
 */
export const postFetchAllLayouts = (
    params?: MaybeRef<PostFetchAllLayoutsParams>,
 options?: SecondParameter<typeof axios>,) => {
      params = unref(params);
      
      return axios<void>(
      {url: `/api/layouts`, method: 'POST',
        params: unref(params)
    },
      options);
    }
  


export const getPostFetchAllLayoutsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postFetchAllLayouts>>, TError,{params?: PostFetchAllLayoutsParams}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postFetchAllLayouts>>, TError,{params?: PostFetchAllLayoutsParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postFetchAllLayouts>>, {params?: PostFetchAllLayoutsParams}> = (props) => {
          const {params} = props ?? {};

          return  postFetchAllLayouts(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostFetchAllLayoutsMutationResult = NonNullable<Awaited<ReturnType<typeof postFetchAllLayouts>>>
    
    export type PostFetchAllLayoutsMutationError = ErrorType<unknown>

    /**
 * @summary Get all layouts
 */
export const usePostFetchAllLayouts = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postFetchAllLayouts>>, TError,{params?: PostFetchAllLayoutsParams}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postFetchAllLayouts>>,
        TError,
        {params?: PostFetchAllLayoutsParams},
        TContext
      > => {

      const mutationOptions = getPostFetchAllLayoutsMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Create a new layout
 * @summary Create layout
 */
export const postCreateLayout = (
    createLayoutDTO: MaybeRef<CreateLayoutDTO>,
 options?: SecondParameter<typeof axios>,) => {
      createLayoutDTO = unref(createLayoutDTO);
      
      return axios<void>(
      {url: `/api/layout`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createLayoutDTO
    },
      options);
    }
  


export const getPostCreateLayoutMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCreateLayout>>, TError,{data: BodyType<CreateLayoutDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postCreateLayout>>, TError,{data: BodyType<CreateLayoutDTO>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCreateLayout>>, {data: BodyType<CreateLayoutDTO>}> = (props) => {
          const {data} = props ?? {};

          return  postCreateLayout(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostCreateLayoutMutationResult = NonNullable<Awaited<ReturnType<typeof postCreateLayout>>>
    export type PostCreateLayoutMutationBody = BodyType<CreateLayoutDTO>
    export type PostCreateLayoutMutationError = ErrorType<unknown>

    /**
 * @summary Create layout
 */
export const usePostCreateLayout = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCreateLayout>>, TError,{data: BodyType<CreateLayoutDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postCreateLayout>>,
        TError,
        {data: BodyType<CreateLayoutDTO>},
        TContext
      > => {

      const mutationOptions = getPostCreateLayoutMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Add a template to a layout
 * @summary Associate template with layout
 */
export const postAddTemplateToLayout = (
    id: MaybeRef<string>,
    addTemplateToLayoutDTO: MaybeRef<AddTemplateToLayoutDTO>,
 options?: SecondParameter<typeof axios>,) => {
      id = unref(id);
addTemplateToLayoutDTO = unref(addTemplateToLayoutDTO);
      
      return axios<void>(
      {url: `/api/layout/${id}/template`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: addTemplateToLayoutDTO
    },
      options);
    }
  


export const getPostAddTemplateToLayoutMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAddTemplateToLayout>>, TError,{id: string;data: BodyType<AddTemplateToLayoutDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postAddTemplateToLayout>>, TError,{id: string;data: BodyType<AddTemplateToLayoutDTO>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAddTemplateToLayout>>, {id: string;data: BodyType<AddTemplateToLayoutDTO>}> = (props) => {
          const {id,data} = props ?? {};

          return  postAddTemplateToLayout(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAddTemplateToLayoutMutationResult = NonNullable<Awaited<ReturnType<typeof postAddTemplateToLayout>>>
    export type PostAddTemplateToLayoutMutationBody = BodyType<AddTemplateToLayoutDTO>
    export type PostAddTemplateToLayoutMutationError = ErrorType<unknown>

    /**
 * @summary Associate template with layout
 */
export const usePostAddTemplateToLayout = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAddTemplateToLayout>>, TError,{id: string;data: BodyType<AddTemplateToLayoutDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postAddTemplateToLayout>>,
        TError,
        {id: string;data: BodyType<AddTemplateToLayoutDTO>},
        TContext
      > => {

      const mutationOptions = getPostAddTemplateToLayoutMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Fetch a stylesheet by ID
 * @summary Get stylesheet by ID
 */
export const getFetchStylesheet = (
    id: MaybeRef<string>,
 options?: SecondParameter<typeof axios>,signal?: AbortSignal
) => {
      id = unref(id);
      
      return axios<void>(
      {url: `/api/stylesheet/${id}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetFetchStylesheetQueryKey = (id: MaybeRef<string>,) => {
    return ['api','stylesheet',id] as const;
    }

    
export const getGetFetchStylesheetQueryOptions = <TData = Awaited<ReturnType<typeof getFetchStylesheet>>, TError = ErrorType<unknown>>(id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFetchStylesheet>>, TError, TData>>, request?: SecondParameter<typeof axios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getGetFetchStylesheetQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFetchStylesheet>>> = ({ signal }) => getFetchStylesheet(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: computed(() => !!(unref(id))), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFetchStylesheet>>, TError, TData> 
}

export type GetFetchStylesheetQueryResult = NonNullable<Awaited<ReturnType<typeof getFetchStylesheet>>>
export type GetFetchStylesheetQueryError = ErrorType<unknown>

/**
 * @summary Get stylesheet by ID
 */
export const useGetFetchStylesheet = <TData = Awaited<ReturnType<typeof getFetchStylesheet>>, TError = ErrorType<unknown>>(
 id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFetchStylesheet>>, TError, TData>>, request?: SecondParameter<typeof axios>}

  ): UseQueryReturnType<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetFetchStylesheetQueryOptions(id,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: QueryKey };

  query.queryKey = unref(queryOptions).queryKey as QueryKey;

  return query;
}




/**
 * Update an existing stylesheet
 * @summary Update stylesheet
 */
export const putUpdateStylesheet = (
    id: MaybeRef<string>,
    updateStylesheetDTO: MaybeRef<UpdateStylesheetDTO>,
 options?: SecondParameter<typeof axios>,) => {
      id = unref(id);
updateStylesheetDTO = unref(updateStylesheetDTO);
      
      return axios<void>(
      {url: `/api/stylesheet/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateStylesheetDTO
    },
      options);
    }
  


export const getPutUpdateStylesheetMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putUpdateStylesheet>>, TError,{id: string;data: BodyType<UpdateStylesheetDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof putUpdateStylesheet>>, TError,{id: string;data: BodyType<UpdateStylesheetDTO>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putUpdateStylesheet>>, {id: string;data: BodyType<UpdateStylesheetDTO>}> = (props) => {
          const {id,data} = props ?? {};

          return  putUpdateStylesheet(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutUpdateStylesheetMutationResult = NonNullable<Awaited<ReturnType<typeof putUpdateStylesheet>>>
    export type PutUpdateStylesheetMutationBody = BodyType<UpdateStylesheetDTO>
    export type PutUpdateStylesheetMutationError = ErrorType<unknown>

    /**
 * @summary Update stylesheet
 */
export const usePutUpdateStylesheet = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putUpdateStylesheet>>, TError,{id: string;data: BodyType<UpdateStylesheetDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof putUpdateStylesheet>>,
        TError,
        {id: string;data: BodyType<UpdateStylesheetDTO>},
        TContext
      > => {

      const mutationOptions = getPutUpdateStylesheetMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Fetch all stylesheets
 * @summary Get all stylesheets
 */
export const postFetchAllStylesheets = (
    params?: MaybeRef<PostFetchAllStylesheetsParams>,
 options?: SecondParameter<typeof axios>,) => {
      params = unref(params);
      
      return axios<void>(
      {url: `/api/stylesheets`, method: 'POST',
        params: unref(params)
    },
      options);
    }
  


export const getPostFetchAllStylesheetsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postFetchAllStylesheets>>, TError,{params?: PostFetchAllStylesheetsParams}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postFetchAllStylesheets>>, TError,{params?: PostFetchAllStylesheetsParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postFetchAllStylesheets>>, {params?: PostFetchAllStylesheetsParams}> = (props) => {
          const {params} = props ?? {};

          return  postFetchAllStylesheets(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostFetchAllStylesheetsMutationResult = NonNullable<Awaited<ReturnType<typeof postFetchAllStylesheets>>>
    
    export type PostFetchAllStylesheetsMutationError = ErrorType<unknown>

    /**
 * @summary Get all stylesheets
 */
export const usePostFetchAllStylesheets = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postFetchAllStylesheets>>, TError,{params?: PostFetchAllStylesheetsParams}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postFetchAllStylesheets>>,
        TError,
        {params?: PostFetchAllStylesheetsParams},
        TContext
      > => {

      const mutationOptions = getPostFetchAllStylesheetsMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Create a new stylesheet
 * @summary Create stylesheet
 */
export const postCreateStylesheet = (
    createStylesheetDTO: MaybeRef<CreateStylesheetDTO>,
 options?: SecondParameter<typeof axios>,) => {
      createStylesheetDTO = unref(createStylesheetDTO);
      
      return axios<void>(
      {url: `/api/stylesheet`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createStylesheetDTO
    },
      options);
    }
  


export const getPostCreateStylesheetMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCreateStylesheet>>, TError,{data: BodyType<CreateStylesheetDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postCreateStylesheet>>, TError,{data: BodyType<CreateStylesheetDTO>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCreateStylesheet>>, {data: BodyType<CreateStylesheetDTO>}> = (props) => {
          const {data} = props ?? {};

          return  postCreateStylesheet(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostCreateStylesheetMutationResult = NonNullable<Awaited<ReturnType<typeof postCreateStylesheet>>>
    export type PostCreateStylesheetMutationBody = BodyType<CreateStylesheetDTO>
    export type PostCreateStylesheetMutationError = ErrorType<unknown>

    /**
 * @summary Create stylesheet
 */
export const usePostCreateStylesheet = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCreateStylesheet>>, TError,{data: BodyType<CreateStylesheetDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postCreateStylesheet>>,
        TError,
        {data: BodyType<CreateStylesheetDTO>},
        TContext
      > => {

      const mutationOptions = getPostCreateStylesheetMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Add a template to a stylesheet
 * @summary Associate template with stylesheet
 */
export const postAddTemplateToStylesheet = (
    id: MaybeRef<string>,
    addTemplateToStylesheetDTO: MaybeRef<AddTemplateToStylesheetDTO>,
 options?: SecondParameter<typeof axios>,) => {
      id = unref(id);
addTemplateToStylesheetDTO = unref(addTemplateToStylesheetDTO);
      
      return axios<void>(
      {url: `/api/stylesheet/${id}/template`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: addTemplateToStylesheetDTO
    },
      options);
    }
  


export const getPostAddTemplateToStylesheetMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAddTemplateToStylesheet>>, TError,{id: string;data: BodyType<AddTemplateToStylesheetDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postAddTemplateToStylesheet>>, TError,{id: string;data: BodyType<AddTemplateToStylesheetDTO>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAddTemplateToStylesheet>>, {id: string;data: BodyType<AddTemplateToStylesheetDTO>}> = (props) => {
          const {id,data} = props ?? {};

          return  postAddTemplateToStylesheet(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAddTemplateToStylesheetMutationResult = NonNullable<Awaited<ReturnType<typeof postAddTemplateToStylesheet>>>
    export type PostAddTemplateToStylesheetMutationBody = BodyType<AddTemplateToStylesheetDTO>
    export type PostAddTemplateToStylesheetMutationError = ErrorType<unknown>

    /**
 * @summary Associate template with stylesheet
 */
export const usePostAddTemplateToStylesheet = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAddTemplateToStylesheet>>, TError,{id: string;data: BodyType<AddTemplateToStylesheetDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postAddTemplateToStylesheet>>,
        TError,
        {id: string;data: BodyType<AddTemplateToStylesheetDTO>},
        TContext
      > => {

      const mutationOptions = getPostAddTemplateToStylesheetMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Fetch all themes
 * @summary Get all themes
 */
export const postFetchAllThemes = (
    params?: MaybeRef<PostFetchAllThemesParams>,
 options?: SecondParameter<typeof axios>,) => {
      params = unref(params);
      
      return axios<void>(
      {url: `/api/themes`, method: 'POST',
        params: unref(params)
    },
      options);
    }
  


export const getPostFetchAllThemesMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postFetchAllThemes>>, TError,{params?: PostFetchAllThemesParams}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postFetchAllThemes>>, TError,{params?: PostFetchAllThemesParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postFetchAllThemes>>, {params?: PostFetchAllThemesParams}> = (props) => {
          const {params} = props ?? {};

          return  postFetchAllThemes(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostFetchAllThemesMutationResult = NonNullable<Awaited<ReturnType<typeof postFetchAllThemes>>>
    
    export type PostFetchAllThemesMutationError = ErrorType<unknown>

    /**
 * @summary Get all themes
 */
export const usePostFetchAllThemes = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postFetchAllThemes>>, TError,{params?: PostFetchAllThemesParams}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postFetchAllThemes>>,
        TError,
        {params?: PostFetchAllThemesParams},
        TContext
      > => {

      const mutationOptions = getPostFetchAllThemesMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Create a new theme
 * @summary Create theme
 */
export const postCreateTheme = (
    createThemeDTO: MaybeRef<CreateThemeDTO>,
 options?: SecondParameter<typeof axios>,) => {
      createThemeDTO = unref(createThemeDTO);
      
      return axios<void>(
      {url: `/api/theme`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createThemeDTO
    },
      options);
    }
  


export const getPostCreateThemeMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCreateTheme>>, TError,{data: BodyType<CreateThemeDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postCreateTheme>>, TError,{data: BodyType<CreateThemeDTO>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCreateTheme>>, {data: BodyType<CreateThemeDTO>}> = (props) => {
          const {data} = props ?? {};

          return  postCreateTheme(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostCreateThemeMutationResult = NonNullable<Awaited<ReturnType<typeof postCreateTheme>>>
    export type PostCreateThemeMutationBody = BodyType<CreateThemeDTO>
    export type PostCreateThemeMutationError = ErrorType<unknown>

    /**
 * @summary Create theme
 */
export const usePostCreateTheme = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCreateTheme>>, TError,{data: BodyType<CreateThemeDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postCreateTheme>>,
        TError,
        {data: BodyType<CreateThemeDTO>},
        TContext
      > => {

      const mutationOptions = getPostCreateThemeMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Update an existing theme
 * @summary Update theme
 */
export const putUpdateTheme = (
    id: MaybeRef<string>,
    updateThemeDTO: MaybeRef<UpdateThemeDTO>,
 options?: SecondParameter<typeof axios>,) => {
      id = unref(id);
updateThemeDTO = unref(updateThemeDTO);
      
      return axios<void>(
      {url: `/api/theme/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateThemeDTO
    },
      options);
    }
  


export const getPutUpdateThemeMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putUpdateTheme>>, TError,{id: string;data: BodyType<UpdateThemeDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof putUpdateTheme>>, TError,{id: string;data: BodyType<UpdateThemeDTO>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putUpdateTheme>>, {id: string;data: BodyType<UpdateThemeDTO>}> = (props) => {
          const {id,data} = props ?? {};

          return  putUpdateTheme(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutUpdateThemeMutationResult = NonNullable<Awaited<ReturnType<typeof putUpdateTheme>>>
    export type PutUpdateThemeMutationBody = BodyType<UpdateThemeDTO>
    export type PutUpdateThemeMutationError = ErrorType<unknown>

    /**
 * @summary Update theme
 */
export const usePutUpdateTheme = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putUpdateTheme>>, TError,{id: string;data: BodyType<UpdateThemeDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof putUpdateTheme>>,
        TError,
        {id: string;data: BodyType<UpdateThemeDTO>},
        TContext
      > => {

      const mutationOptions = getPutUpdateThemeMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Add a template to a theme
 * @summary Associate template with theme
 */
export const postAddTemplateToTheme = (
    id: MaybeRef<string>,
    addTemplateToThemeDTO: MaybeRef<AddTemplateToThemeDTO>,
 options?: SecondParameter<typeof axios>,) => {
      id = unref(id);
addTemplateToThemeDTO = unref(addTemplateToThemeDTO);
      
      return axios<void>(
      {url: `/api/theme/${id}/template`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: addTemplateToThemeDTO
    },
      options);
    }
  


export const getPostAddTemplateToThemeMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAddTemplateToTheme>>, TError,{id: string;data: BodyType<AddTemplateToThemeDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postAddTemplateToTheme>>, TError,{id: string;data: BodyType<AddTemplateToThemeDTO>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAddTemplateToTheme>>, {id: string;data: BodyType<AddTemplateToThemeDTO>}> = (props) => {
          const {id,data} = props ?? {};

          return  postAddTemplateToTheme(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAddTemplateToThemeMutationResult = NonNullable<Awaited<ReturnType<typeof postAddTemplateToTheme>>>
    export type PostAddTemplateToThemeMutationBody = BodyType<AddTemplateToThemeDTO>
    export type PostAddTemplateToThemeMutationError = ErrorType<unknown>

    /**
 * @summary Associate template with theme
 */
export const usePostAddTemplateToTheme = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAddTemplateToTheme>>, TError,{id: string;data: BodyType<AddTemplateToThemeDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postAddTemplateToTheme>>,
        TError,
        {id: string;data: BodyType<AddTemplateToThemeDTO>},
        TContext
      > => {

      const mutationOptions = getPostAddTemplateToThemeMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Fetch a project by ID
 * @summary Get project by ID
 */
export const getFetchProject = (
    id: MaybeRef<string>,
 options?: SecondParameter<typeof axios>,signal?: AbortSignal
) => {
      id = unref(id);
      
      return axios<void>(
      {url: `/api/project/${id}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetFetchProjectQueryKey = (id: MaybeRef<string>,) => {
    return ['api','project',id] as const;
    }

    
export const getGetFetchProjectQueryOptions = <TData = Awaited<ReturnType<typeof getFetchProject>>, TError = ErrorType<unknown>>(id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFetchProject>>, TError, TData>>, request?: SecondParameter<typeof axios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getGetFetchProjectQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFetchProject>>> = ({ signal }) => getFetchProject(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: computed(() => !!(unref(id))), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFetchProject>>, TError, TData> 
}

export type GetFetchProjectQueryResult = NonNullable<Awaited<ReturnType<typeof getFetchProject>>>
export type GetFetchProjectQueryError = ErrorType<unknown>

/**
 * @summary Get project by ID
 */
export const useGetFetchProject = <TData = Awaited<ReturnType<typeof getFetchProject>>, TError = ErrorType<unknown>>(
 id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFetchProject>>, TError, TData>>, request?: SecondParameter<typeof axios>}

  ): UseQueryReturnType<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetFetchProjectQueryOptions(id,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: QueryKey };

  query.queryKey = unref(queryOptions).queryKey as QueryKey;

  return query;
}




/**
 * Update an existing project
 * @summary Update project
 */
export const putUpdateProject = (
    id: MaybeRef<string>,
    updateProjectDTO: MaybeRef<UpdateProjectDTO>,
 options?: SecondParameter<typeof axios>,) => {
      id = unref(id);
updateProjectDTO = unref(updateProjectDTO);
      
      return axios<void>(
      {url: `/api/project/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateProjectDTO
    },
      options);
    }
  


export const getPutUpdateProjectMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putUpdateProject>>, TError,{id: string;data: BodyType<UpdateProjectDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof putUpdateProject>>, TError,{id: string;data: BodyType<UpdateProjectDTO>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putUpdateProject>>, {id: string;data: BodyType<UpdateProjectDTO>}> = (props) => {
          const {id,data} = props ?? {};

          return  putUpdateProject(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutUpdateProjectMutationResult = NonNullable<Awaited<ReturnType<typeof putUpdateProject>>>
    export type PutUpdateProjectMutationBody = BodyType<UpdateProjectDTO>
    export type PutUpdateProjectMutationError = ErrorType<unknown>

    /**
 * @summary Update project
 */
export const usePutUpdateProject = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putUpdateProject>>, TError,{id: string;data: BodyType<UpdateProjectDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof putUpdateProject>>,
        TError,
        {id: string;data: BodyType<UpdateProjectDTO>},
        TContext
      > => {

      const mutationOptions = getPutUpdateProjectMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Fetch all projects
 * @summary Get all projects
 */
export const postFetchAllProjects = (
    params?: MaybeRef<PostFetchAllProjectsParams>,
 options?: SecondParameter<typeof axios>,) => {
      params = unref(params);
      
      return axios<void>(
      {url: `/api/projects`, method: 'POST',
        params: unref(params)
    },
      options);
    }
  


export const getPostFetchAllProjectsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postFetchAllProjects>>, TError,{params?: PostFetchAllProjectsParams}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postFetchAllProjects>>, TError,{params?: PostFetchAllProjectsParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postFetchAllProjects>>, {params?: PostFetchAllProjectsParams}> = (props) => {
          const {params} = props ?? {};

          return  postFetchAllProjects(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostFetchAllProjectsMutationResult = NonNullable<Awaited<ReturnType<typeof postFetchAllProjects>>>
    
    export type PostFetchAllProjectsMutationError = ErrorType<unknown>

    /**
 * @summary Get all projects
 */
export const usePostFetchAllProjects = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postFetchAllProjects>>, TError,{params?: PostFetchAllProjectsParams}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postFetchAllProjects>>,
        TError,
        {params?: PostFetchAllProjectsParams},
        TContext
      > => {

      const mutationOptions = getPostFetchAllProjectsMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * Create a new project
 * @summary Create project
 */
export const postCreateProject = (
    createProjectDTO: MaybeRef<CreateProjectDTO>,
 options?: SecondParameter<typeof axios>,) => {
      createProjectDTO = unref(createProjectDTO);
      
      return axios<void>(
      {url: `/api/project`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createProjectDTO
    },
      options);
    }
  


export const getPostCreateProjectMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCreateProject>>, TError,{data: BodyType<CreateProjectDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postCreateProject>>, TError,{data: BodyType<CreateProjectDTO>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCreateProject>>, {data: BodyType<CreateProjectDTO>}> = (props) => {
          const {data} = props ?? {};

          return  postCreateProject(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostCreateProjectMutationResult = NonNullable<Awaited<ReturnType<typeof postCreateProject>>>
    export type PostCreateProjectMutationBody = BodyType<CreateProjectDTO>
    export type PostCreateProjectMutationError = ErrorType<unknown>

    /**
 * @summary Create project
 */
export const usePostCreateProject = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCreateProject>>, TError,{data: BodyType<CreateProjectDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postCreateProject>>,
        TError,
        {data: BodyType<CreateProjectDTO>},
        TContext
      > => {

      const mutationOptions = getPostCreateProjectMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * This endpoint sends an payment request
 * @summary Send an payment request
 */
export const postSendPaymentRequest = (
    sendEmailDTO: MaybeRef<SendEmailDTO>,
 options?: SecondParameter<typeof axios>,) => {
      sendEmailDTO = unref(sendEmailDTO);
      
      return axios<void>(
      {url: `/api/mail/payment-request`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: sendEmailDTO
    },
      options);
    }
  


export const getPostSendPaymentRequestMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postSendPaymentRequest>>, TError,{data: BodyType<SendEmailDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postSendPaymentRequest>>, TError,{data: BodyType<SendEmailDTO>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postSendPaymentRequest>>, {data: BodyType<SendEmailDTO>}> = (props) => {
          const {data} = props ?? {};

          return  postSendPaymentRequest(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostSendPaymentRequestMutationResult = NonNullable<Awaited<ReturnType<typeof postSendPaymentRequest>>>
    export type PostSendPaymentRequestMutationBody = BodyType<SendEmailDTO>
    export type PostSendPaymentRequestMutationError = ErrorType<unknown>

    /**
 * @summary Send an payment request
 */
export const usePostSendPaymentRequest = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postSendPaymentRequest>>, TError,{data: BodyType<SendEmailDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postSendPaymentRequest>>,
        TError,
        {data: BodyType<SendEmailDTO>},
        TContext
      > => {

      const mutationOptions = getPostSendPaymentRequestMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postCompareOfferAndTicket = (
    id: MaybeRef<string>,
 options?: SecondParameter<typeof axios>,) => {
      id = unref(id);
      
      return axios<void>(
      {url: `/api/ticket/${id}/compare`, method: 'POST'
    },
      options);
    }
  


export const getPostCompareOfferAndTicketMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCompareOfferAndTicket>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postCompareOfferAndTicket>>, TError,{id: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCompareOfferAndTicket>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  postCompareOfferAndTicket(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostCompareOfferAndTicketMutationResult = NonNullable<Awaited<ReturnType<typeof postCompareOfferAndTicket>>>
    
    export type PostCompareOfferAndTicketMutationError = ErrorType<void>

    export const usePostCompareOfferAndTicket = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCompareOfferAndTicket>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postCompareOfferAndTicket>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getPostCompareOfferAndTicketMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postInvoiceTicket = (
    id: MaybeRef<string>,
    postInvoiceTicketBody: MaybeRef<unknown>,
 options?: SecondParameter<typeof axios>,) => {
      id = unref(id);
postInvoiceTicketBody = unref(postInvoiceTicketBody);
      
      return axios<void>(
      {url: `/api/ticket/${id}/invoice`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postInvoiceTicketBody
    },
      options);
    }
  


export const getPostInvoiceTicketMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postInvoiceTicket>>, TError,{id: string;data: BodyType<unknown>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postInvoiceTicket>>, TError,{id: string;data: BodyType<unknown>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postInvoiceTicket>>, {id: string;data: BodyType<unknown>}> = (props) => {
          const {id,data} = props ?? {};

          return  postInvoiceTicket(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostInvoiceTicketMutationResult = NonNullable<Awaited<ReturnType<typeof postInvoiceTicket>>>
    export type PostInvoiceTicketMutationBody = BodyType<unknown>
    export type PostInvoiceTicketMutationError = ErrorType<unknown>

    export const usePostInvoiceTicket = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postInvoiceTicket>>, TError,{id: string;data: BodyType<unknown>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postInvoiceTicket>>,
        TError,
        {id: string;data: BodyType<unknown>},
        TContext
      > => {

      const mutationOptions = getPostInvoiceTicketMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * This endpoint sends a contract
 * @summary Send a contract
 */
export const postSendContract = (
    sendContractDTO: MaybeRef<SendContractDTO>,
 options?: SecondParameter<typeof axios>,) => {
      sendContractDTO = unref(sendContractDTO);
      
      return axios<void>(
      {url: `/api/mail/contract`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: sendContractDTO
    },
      options);
    }
  


export const getPostSendContractMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postSendContract>>, TError,{data: BodyType<SendContractDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postSendContract>>, TError,{data: BodyType<SendContractDTO>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postSendContract>>, {data: BodyType<SendContractDTO>}> = (props) => {
          const {data} = props ?? {};

          return  postSendContract(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostSendContractMutationResult = NonNullable<Awaited<ReturnType<typeof postSendContract>>>
    export type PostSendContractMutationBody = BodyType<SendContractDTO>
    export type PostSendContractMutationError = ErrorType<unknown>

    /**
 * @summary Send a contract
 */
export const usePostSendContract = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postSendContract>>, TError,{data: BodyType<SendContractDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postSendContract>>,
        TError,
        {data: BodyType<SendContractDTO>},
        TContext
      > => {

      const mutationOptions = getPostSendContractMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * This endpoint sends a receipt
 * @summary Send a receipt
 */
export const postSendReceipt = (
    sendEmailDTO: MaybeRef<SendEmailDTO>,
 options?: SecondParameter<typeof axios>,) => {
      sendEmailDTO = unref(sendEmailDTO);
      
      return axios<void>(
      {url: `/api/mail/receipt`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: sendEmailDTO
    },
      options);
    }
  


export const getPostSendReceiptMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postSendReceipt>>, TError,{data: BodyType<SendEmailDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postSendReceipt>>, TError,{data: BodyType<SendEmailDTO>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postSendReceipt>>, {data: BodyType<SendEmailDTO>}> = (props) => {
          const {data} = props ?? {};

          return  postSendReceipt(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostSendReceiptMutationResult = NonNullable<Awaited<ReturnType<typeof postSendReceipt>>>
    export type PostSendReceiptMutationBody = BodyType<SendEmailDTO>
    export type PostSendReceiptMutationError = ErrorType<unknown>

    /**
 * @summary Send a receipt
 */
export const usePostSendReceipt = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postSendReceipt>>, TError,{data: BodyType<SendEmailDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postSendReceipt>>,
        TError,
        {data: BodyType<SendEmailDTO>},
        TContext
      > => {

      const mutationOptions = getPostSendReceiptMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * This endpoint sends a damage specification
 * @summary Send a damage specification
 */
export const postSendDamageSpecification = (
    sendEmailDTO: MaybeRef<SendEmailDTO>,
 options?: SecondParameter<typeof axios>,) => {
      sendEmailDTO = unref(sendEmailDTO);
      
      return axios<void>(
      {url: `/api/mail/damage-specification`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: sendEmailDTO
    },
      options);
    }
  


export const getPostSendDamageSpecificationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postSendDamageSpecification>>, TError,{data: BodyType<SendEmailDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postSendDamageSpecification>>, TError,{data: BodyType<SendEmailDTO>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postSendDamageSpecification>>, {data: BodyType<SendEmailDTO>}> = (props) => {
          const {data} = props ?? {};

          return  postSendDamageSpecification(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostSendDamageSpecificationMutationResult = NonNullable<Awaited<ReturnType<typeof postSendDamageSpecification>>>
    export type PostSendDamageSpecificationMutationBody = BodyType<SendEmailDTO>
    export type PostSendDamageSpecificationMutationError = ErrorType<unknown>

    /**
 * @summary Send a damage specification
 */
export const usePostSendDamageSpecification = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postSendDamageSpecification>>, TError,{data: BodyType<SendEmailDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postSendDamageSpecification>>,
        TError,
        {data: BodyType<SendEmailDTO>},
        TContext
      > => {

      const mutationOptions = getPostSendDamageSpecificationMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * This endpoint sends a rental damage report
 * @summary Send a rental damage report
 */
export const postSendRentalDamageReport = (
    sendEmailDTO: MaybeRef<SendEmailDTO>,
 options?: SecondParameter<typeof axios>,) => {
      sendEmailDTO = unref(sendEmailDTO);
      
      return axios<void>(
      {url: `/api/mail/rental-damage-report`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: sendEmailDTO
    },
      options);
    }
  


export const getPostSendRentalDamageReportMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postSendRentalDamageReport>>, TError,{data: BodyType<SendEmailDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postSendRentalDamageReport>>, TError,{data: BodyType<SendEmailDTO>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postSendRentalDamageReport>>, {data: BodyType<SendEmailDTO>}> = (props) => {
          const {data} = props ?? {};

          return  postSendRentalDamageReport(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostSendRentalDamageReportMutationResult = NonNullable<Awaited<ReturnType<typeof postSendRentalDamageReport>>>
    export type PostSendRentalDamageReportMutationBody = BodyType<SendEmailDTO>
    export type PostSendRentalDamageReportMutationError = ErrorType<unknown>

    /**
 * @summary Send a rental damage report
 */
export const usePostSendRentalDamageReport = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postSendRentalDamageReport>>, TError,{data: BodyType<SendEmailDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postSendRentalDamageReport>>,
        TError,
        {data: BodyType<SendEmailDTO>},
        TContext
      > => {

      const mutationOptions = getPostSendRentalDamageReportMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * This endpoint sends an offer
 * @summary Send an offer
 */
export const postSendOffer = (
    sendEmailDTO: MaybeRef<SendEmailDTO>,
 options?: SecondParameter<typeof axios>,) => {
      sendEmailDTO = unref(sendEmailDTO);
      
      return axios<void>(
      {url: `/api/mail/offer`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: sendEmailDTO
    },
      options);
    }
  


export const getPostSendOfferMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postSendOffer>>, TError,{data: BodyType<SendEmailDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postSendOffer>>, TError,{data: BodyType<SendEmailDTO>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postSendOffer>>, {data: BodyType<SendEmailDTO>}> = (props) => {
          const {data} = props ?? {};

          return  postSendOffer(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostSendOfferMutationResult = NonNullable<Awaited<ReturnType<typeof postSendOffer>>>
    export type PostSendOfferMutationBody = BodyType<SendEmailDTO>
    export type PostSendOfferMutationError = ErrorType<unknown>

    /**
 * @summary Send an offer
 */
export const usePostSendOffer = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postSendOffer>>, TError,{data: BodyType<SendEmailDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postSendOffer>>,
        TError,
        {data: BodyType<SendEmailDTO>},
        TContext
      > => {

      const mutationOptions = getPostSendOfferMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * This endpoint sends a service report
 * @summary Send a service report
 */
export const postSendServiceReport = (
    sendEmailDTO: MaybeRef<SendEmailDTO>,
 options?: SecondParameter<typeof axios>,) => {
      sendEmailDTO = unref(sendEmailDTO);
      
      return axios<void>(
      {url: `/api/mail/service-report`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: sendEmailDTO
    },
      options);
    }
  


export const getPostSendServiceReportMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postSendServiceReport>>, TError,{data: BodyType<SendEmailDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof postSendServiceReport>>, TError,{data: BodyType<SendEmailDTO>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postSendServiceReport>>, {data: BodyType<SendEmailDTO>}> = (props) => {
          const {data} = props ?? {};

          return  postSendServiceReport(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostSendServiceReportMutationResult = NonNullable<Awaited<ReturnType<typeof postSendServiceReport>>>
    export type PostSendServiceReportMutationBody = BodyType<SendEmailDTO>
    export type PostSendServiceReportMutationError = ErrorType<unknown>

    /**
 * @summary Send a service report
 */
export const usePostSendServiceReport = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postSendServiceReport>>, TError,{data: BodyType<SendEmailDTO>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof postSendServiceReport>>,
        TError,
        {data: BodyType<SendEmailDTO>},
        TContext
      > => {

      const mutationOptions = getPostSendServiceReportMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
